module.exports = {
	"fr": {
		"moet-core": {
			"select_language": {
				"title": "Sélectionnez votre langue",
				"paragraph": "Il s'agira de votre langue par défaut",
				"submit": "OK"
			},
			"products": {
				"mandatory": "Toujours inclus",
				"kco": {
					"name": {
						"default": "Checkout"
					},
					"description": {
						"default": "Proposer tous nos modes de paiement."
					},
					"options": {
						"kco-pay-now": {
							"name": {
								"default": "Payer maintenant"
							},
							"description": {
								"default": "Proposer des paiements instantanés par carte ou virement."
							}
						},
						"kco-pay-later": {
							"name": {
								"default": "Payer dans 30 jours"
							},
							"description": {
								"default": "Proposer un paiement sous 30 jours. Sans intérêts."
							}
						},
						"kco-slice-it": {
							"name": {
								"default": "Financement"
							},
							"description": {
								"default": "Proposer un paiement sous 6 à 36 mois.",
								"DE": "Proposer un paiement sous 6 à 24 mois.",
								"AT": "Proposer un paiement sous 6 à 24 mois."
							}
						},
						"kco-slice-it-in-3": {
							"name": {
								"default": "Versements"
							},
							"description": {
								"default": "Proposer un paiement en 3 fois sans intérêts.",
								"GB": "Proposer un paiement en 3 fois sans intérêts."
							}
						},
						"kco-slice-it-in-4": {
							"name": {
								"default": "Payer en 4",
								"US": "Versements",
								"AU": "Payer en 4 fois"
							},
							"description": {
								"default": "Proposer un paiement en 4 fois sans intérêts.",
								"GB": "Proposer un paiement en 4 fois sans intérêts."
							}
						}
					}
				},
				"kp": {
					"name": {
						"default": "Modes de paiement"
					},
					"description": {
						"default": "Faites votre choix parmi nos solutions de paiement indépendantes. Choisissez-en une, ou associez-les. Intégration simple et unique, quel que soit votre choix."
					},
					"options": {
						"kp-pay-now": {
							"name": {
								"default": "Payer maintenant"
							},
							"description": {
								"default": "Proposer des paiements instantanés par carte ou virement."
							}
						},
						"kp-pay-later": {
							"name": {
								"default": "Payer dans 30 jours"
							},
							"description": {
								"default": "Proposer un paiement sous 30 jours. Sans intérêts."
							}
						},
						"kp-slice-it": {
							"name": {
								"default": "Financement"
							},
							"description": {
								"default": "Proposer un paiement sous 6 à 36 mois.",
								"DE": "Proposer un paiement sous 6 à 24 mois.",
								"AT": "Proposer un paiement sous 6 à 24 mois."
							}
						},
						"kp-slice-it-in-3": {
							"name": {
								"default": "Versements"
							},
							"description": {
								"default": "Proposer un paiement en 3 fois sans intérêts.",
								"GB": "Proposer un paiement en 3 fois sans intérêts."
							}
						},
						"kp-slice-it-in-4": {
							"name": {
								"default": "Payer en 4",
								"US": "4 paiements",
								"CA": "4 paiements",
								"AU": "Payer en 4 fois"
							},
							"description": {
								"default": "Proposer un paiement en 4 fois sans intérêts.",
								"GB": "Proposer un paiement en 4 fois sans intérêts.",
								"US": "Les commandes de 35 $ à 1000 $ peuvent être payées en 4 fois sans intérêts, toutes les 2 semaines.",
								"CA": "Toute commande d’une valeur comprise entre 35 $ et 1 000 $ peut être divisée en 4 paiements sans intérêts, à rembourser toutes les 2 semaines."
							}
						}
					}
				},
				"kco_one": {
					"name": {
						"default": "Checkout"
					},
					"description": {
						"default": "Remplacez la caisse de votre magasin par les services de caisse complets de Klarna."
					},
					"description_expanded": {
						"default": "Remplacez la caisse de votre magasin par les services de caisse complets de Klarna."
					}
				},
				"kp_one": {
					"name": {
						"default": "Méthode de paiement"
					},
					"description": {
						"default": "Ajoutez les méthodes de paiement Klarna à votre caisse existante"
					},
					"description_expanded": {
						"default": "En proposant les solutions de paiement de Klarna, vous bénéficiez en moyenne d'une augmentation de 30 % du taux de conversion, de 41 % du panier moyen et de 36 % de la fréquence d'achat."
					}
				}
			}
		},
		"products-fe": {
			"error_messages": {
				"validation": {
					"required": "Ce champ est obligatoire pour pouvoir continuer",
					"generic": "La valeur fournie n’est pas valide",
					"required_suffix": "est requis(e) pour continuer",
					"generic_suffix": "n’est pas valide",
					"min_one": "Vous devez sélectionner au moins un élément",
					"min": "Vous devez sélectionner au moins {min} éléments",
					"max": "Vous ne pouvez sélectionner plus de {max} éléments",
					"given_name": "Prénom manquant",
					"family_name": {
						"general": "Nom manquant",
						"too_short": "Veuillez indiquer un nom valide"
					},
					"date_of_birth": {
						"general": {
							"default": "Veuillez indiquer une date de naissance valide (JJ/MM/AAAA)",
							"US": "Veuillez indiquer une date de naissance valide (MM/JJ/AAAA)"
						},
						"too_young": "Toutes les parties prenantes doivent être âgées de 16 ans au minimum",
						"too_young_eighteen": "Vous devez avoir 18 ans au minimum"
					},
					"street_address": "Veuillez indiquer une adresse",
					"street_address2": "Veuillez fournir une ligne d'adresse 2 valide",
					"postal_code": "Veuillez indiquer un code postal",
					"country": "Veuillez indiquer un pays",
					"region": "Veuillez indiquer une région",
					"state": "Veuillez indiquer un État",
					"iban": "Veuillez indiquer un numéro de compte (IBAN)",
					"companyName": "Veuillez indiquer une raison sociale",
					"email": "Veuillez indiquer une adresse e-mail valide",
					"contact_email": "Veuillez fournir une adresse e-mail valide",
					"support_email": "Veuillez fournir une adresse électronique de l'assistance client valide",
					"support_phone": "Veuillez fournir un numéro de téléphone de l'assistance client valide",
					"selling_countries": "Vous devez sélectionner au moins un pays",
					"store_category": "Vous devez sélectionner l’une des options",
					"name": "Veuillez indiquer le nom de la boutique",
					"legal_form": "Veuillez choisir l’un des types d’activité répertoriés",
					"generic_toggle_undefined": "Veuillez sélectionner l’une des options",
					"website": "Veuillez indiquer une URL de site Web valide",
					"bankAccounts": "Veuillez indiquer au moins un compte bancaire",
					"product": "Veuillez sélectionner un produit",
					"platform": "Veuillez sélectionner une plateforme",
					"password": "Veuillez créer un mot de passe fort",
					"currency_code": "Veuillez indiquer un code de devise",
					"account_holder": "Veuillez indiquer un titulaire de compte bancaire",
					"account_type": "Veuillez indiquer un type de compte bancaire",
					"routing_number": "Veuillez indiquer un numéro de routage valide",
					"account_number": {
						"first": "Veuillez indiquer un numéro de compte valide pour le compte bancaire par défaut",
						"second": "Veuillez indiquer un numéro de compte valide pour le premier compte bancaire supplémentaire",
						"third": "Veuillez indiquer un numéro de compte valide pour le deuxième compte bancaire supplémentaire",
						"fourth": "Veuillez indiquer un numéro de compte valide pour le troisième compte bancaire supplémentaire",
						"general": "Veuillez indiquer un numéro de compte valide"
					},
					"role": "Veuillez indiquer un rôle",
					"address": "Veuillez indiquer une adresse",
					"political_exposed_person": "Veuillez fournir plus d’informations sur la PPE (personne politiquement exposée)",
					"pep_position": "Veuillez fournir plus d’informations sur le poste",
					"pep_relationship": "Veuillez fournir plus d’informations sur la relation avec la PPE",
					"goodsCategory": "Veuillez indiquer une catégorie de marchandises",
					"registered": "Veuillez fournir plus d’informations sur l’enregistrement de votre société",
					"subjectToVat": "Veuillez indiquer un numéro de TVA",
					"registrationCourt": "Veuillez indiquer un tribunal d’enregistrement",
					"registrationId": {
						"general": {
							"default": "Veuillez saisir un numéro d’enregistrement valide",
							"AT": "Veuillez saisir un numéro d’enregistrement valide",
							"AU": "Veuillez saisir un numéro ACN valide",
							"ES": "Saisissez un NIF/NIE/DNI de société valide",
							"GB": "Veuillez saisir un numéro d’entreprise valide",
							"GR": "Indiquez un numéro valide de Registre général du commerce (G.E.MI. ou Γ.Ε.ΜΗ.)",
							"CA": "Veuillez saisir un numéro d'entreprise valide",
							"NZ": "Veuillez saisir un numéro d'entreprise valide.",
							"US": "Veuillez saisir un numéro d’identification de l'employeur valide"
						},
						"missing_leading_0_GB": "Veuillez indiquer un numéro d’entreprise à 8 chiffres. Il est possible qu’il manque un 0 devant votre numéro d’entreprise (par ex. 03452678)",
						"invalid": {
							"default": "Veuillez saisir un numéro d’enregistrement valide",
							"AT": "Le numéro d’enregistrement doit comporter entre 5 et 11 caractères. Veuillez noter qu’il ne s’agit pas de votre numéro de TVA, ni de votre ID de marchand.",
							"AU": "Le numéro ACN doit comporter 9 chiffres. Aucun espace n’est autorisé. Par exemple : 123456789",
							"BE": "Le numéro d’enregistrement doit comporter 10 chiffres. Par exemple : 1234567890",
							"CA": "Le numéro d'entreprise doit comporter 9 chiffres. Par exemple : 123456789",
							"CZ": "Le numéro d’enregistrement doit comporter 8 chiffres. Par exemple : 12345678",
							"DE": "Le numéro d’enregistrement doit comporter entre 6 et 11 caractères. Il doit commencer par la mention HRA, HRB, GnR, VR ou PR suivie d’un espace. Veuillez noter qu’il ne s’agit pas de votre numéro de TVA, ni de votre ID de marchand.",
							"ES": "Le NIF/NIE/DNI doit comporter 8 ou 9 caractères et commencer par une lettre/un chiffre suivi(e) de 6 ou 7 chiffres et d’une lettre/un chiffre.",
							"FI": "Le numéro d’enregistrement doit comporter 8 chiffres, avec un tiret avant le dernier chiffre. Aucun espace n’est autorisé. Par exemple : 1234567-8",
							"FR": "Le numéro d'identification doit être composé de 9 chiffres, par ex. 123 456 789 ou 123456789 (SIREN), ou de 14 chiffres, par ex. 123 456 789 12345 ou 12345678912345 (SIRET).",
							"IE": "Le numéro d’enregistrement doit comporter 2 lettres suivies de 6 chiffres ou 6 chiffres seulement si vous êtes un entrepreneur individuel (ex. : AB123456).",
							"IT": "Le numéro d’enregistrement doit comporter 11 chiffres (par exemple : 01234567890) ou une combinaison de 16 chiffres et lettres majuscules (par exemple : ABCABC12A12A123A)",
							"GB": "Le numéro d’organisation doit comporter 8 chiffres. Par ex. : 12345678, ou deux lettres suivies de 6 chiffres (SC123456), ou 1 lettre suivie de 7 chiffres (S1234567)",
							"GR": "Le numéro G.E.MI. doit comporter 12 caractères, par ex. 012345678901",
							"NL": "Le numéro d’enregistrement doit comporter 8 chiffres. Par exemple : 12345678",
							"NO": "Le numéro d’enregistrement doit comporter 9 chiffres. Aucun espace n’est autorisé. Par exemple : 123456789",
							"NZ": "Le numéro d'entreprise doit comporter 13 chiffres. Par exemple : 1234567890123",
							"PL": "Le numéro d’enregistrement doit comporter 10 chiffres. Aucun espace n’est autorisé. Par exemple : 1234561234",
							"PT": "Le numéro d’enregistrement doit comporter 9 chiffres. Aucun espace n’est autorisé. Par exemple : 123123123",
							"SE": "Le numéro d’enregistrement doit comporter 10 chiffres avec un tiret. Aucun espace n’est autorisé. Par exemple : 123456-1234",
							"US": "Le numéro d'identification de l'employeur doit comporter 9 chiffres avec un \"-\" après les deux premiers chiffres. Par exemple : 12-3456789",
							"MX": "Le RFC doit comporter 12 caractères. Il commence par les initiales de l'entreprise suivies des 6 chiffres de la date d'enregistrement et de la valeur de contrôle. Par exemple : ABC921010H20"
						}
					},
					"tocLink": "Un problème est survenu en lien avec les conditions générales. Veuillez réessayer ultérieurement ou contacter notre service client à l’adresse {supportEmail}",
					"vat": {
						"general": {
							"default": "Veuillez saisir un numéro de TVA valide",
							"AU": "Veuillez saisir un numéro ABN valide",
							"ES": "Veuillez saisir un NIF/NIE/DNI de société valide",
							"NZ": "Veuillez saisir un numéro d'identification GST valide"
						},
						"invalid": {
							"default": "Numéro de TVA non valide",
							"AT": "Le numéro de TVA doit commencer par la mention ATU, suivie de 8 chiffres. Par exemple : ATU12345678",
							"AU": "Le numéro ABN doit comporter 11 chiffres.",
							"CZ": "Le numéro de TVA doit commencer par la mention CZ, suivie de 8, 9 ou 10 chiffres. Par exemple : CZ123456789",
							"GR": "Le numéro de TVA doit comporter 9 chiffres et commencer par EL. Par exemple : EL123456789",
							"DE": "Le numéro de TVA doit commencer par la mention DE, suivie de 9 chiffres. Par exemple : DE123456789",
							"ES": "Le NIF/NIE/DNI doit comporter 8 ou 9 caractères et commencer par une lettre/un chiffre suivi(e) de 6 ou 7 chiffres et d’une lettre/un chiffre.",
							"FR": "Le numéro de TVA doit commencer par la mention FR, suivie de deux lettres/chiffres, puis de 9 chiffres (SIREN), par ex. FRXX123456789",
							"GB": "Le numéro de TVA doit comporter entre 6 et 15 caractères.",
							"IE": "Le numéro de TVA doit commencer par IE suivi de 8 ou 9 caractères qui comprennent 1 ou 2 lettres. Par exemple : IE1234567WA, IE1234567A",
							"IT": "Le numéro de TVA doit commencer par la mention IT, suivie de 11 chiffres. Par exemple : IT12345678912",
							"NL": "Le numéro de TVA doit commencer par la mention NL, suivie de 9 chiffres, puis de la lettre B et de 2 chiffres. Par exemple : NL123456789B12",
							"NZ": "Le numéro d'identification GST doit comporter 8 (12345678) ou 9 chiffres, avec ou sans tirets tous les 3 chiffres (123-123-123 ou 123123123)",
							"PL": "Le numéro de TVA doit commencer par la mention PL, suivie de 10 chiffres. Par exemple : PL1234567890",
							"PT": "Le numéro de TVA doit commencer par la mention PT, suivie de 9 chiffres. Par exemple : PT123123123",
							"MX": "Le RFC doit commencer par les initiales de l'entreprise suivies des 6 chiffres de la date d'enregistrement et de la valeur de contrôle. Par exemple : ABC921010H20"
						}
					},
					"personal_id": {
						"US": {
							"general": "Veuillez indiquer les 4 derniers chiffres de votre numéro de sécurité sociale",
							"format": "Veuillez saisir les 4 derniers chiffres de votre numéro de sécurité sociale"
						},
						"US_FULL_SSN": {
							"general": "Veuillez indiquez votre numéro de sécurité sociale complet (9 chiffres)",
							"format": "Veuillez saisir votre numéro de sécurité sociale complet (9 chiffres)"
						},
						"CA": {
							"general": "Veuillez indiquer un numéro de sécurité sociale ou de passeport valide",
							"format": "Numéro de sécurité sociale : XXX-XXX-XXX / Numéro de passeport : ABXXXXXX"
						},
						"SE": {
							"general": "Veuillez entrer un numéro d'identification personnel valide (PNO)",
							"format": "Veuillez entrer le PNO au format suivant : AAAAMMJJ-XXXX"
						},
						"FI": {
							"general": "Veuillez entrer un code d'identification personnel valide (HETU)",
							"format": "Veuillez entrer le code HETU au format suivant : JJMMAASXXXX"
						},
						"NO": {
							"general": "Veuillez fournir un numéro national d'identité valide",
							"format": "Veuillez l'entrer au format suivant : JJMMAAXXXXX"
						},
						"DK": {
							"general": "Veuillez entrer un numéro d'identification personnel valide (CPR)",
							"format": "Veuillez entrer le CPR au format suivant : JJMMAA-XXXX"
						},
						"IT": {
							"general": "Veuillez saisir un code fiscal valide",
							"format": "Veuillez saisir un code fiscal au format : CLDNRG84L58H501R"
						},
						"ES": {
							"general": "Veuillez saisir un numéro d'identification personnelle (DNI ou NIE)",
							"format": "Veuillez saisir le DNI ou NIE, par ex. 12345678A"
						},
						"PL": {
							"general": "Veuillez saisir un numério d'identification personnelle valide (PESEL)",
							"format": "Veuillez saisir votre PESEL au format : AAMMJJZZZXQ"
						},
						"default": {
							"general": "Veuillez indiquer un numéro de passeport valide"
						}
					},
					"store_name": "Veuillez indiquer le nom de la boutique"
				},
				"errors_keys": {
					"correlationIdLabel": "ID de corrélation : {correlationId}",
					"decisionTaken": "La décision de pré-évaluation a déjà été prise. Veuillez recharger la page.",
					"maintenanceMode": "Notre application est actuellement indisponible pour des raisons de maintenance. Veuillez réessayer ultérieurement",
					"validation": {
						"storeName": {
							"invalidType": "Veuillez indiquer un nom de boutique valide."
						},
						"email": {
							"invalidType": "Veuillez indiquer une adresse e-mail valide."
						},
						"goodsCategory": {
							"invalidType": "Veuillez indiquer une catégorie de marchandises."
						},
						"website": {
							"invalidType": "Veuillez indiquer un site Web valide."
						}
					}
				}
			},
			"general": {
				"yes": "Oui",
				"no": "Non",
				"encrypted_text": "*******",
				"pricing_link_eu": "Afficher tous les prix par pays",
				"pricing_link_us": "Afficher les prix",
				"formFieldOptional": "facultatif",
				"buttons": {
					"next": "Suivant",
					"back": "Retour",
					"continue": "Continuer",
					"submit_application": {
						"default": "C’est parti",
						"UPSELL_WEBSTORE_TO_ADS_MANAGER": "Commencer"
					},
					"add_aditional_item": "+ Ajouter un article supplémentaire"
				},
				"unknown_step_title": "Veuillez fournir les informations requises",
				"selected": "Sélectionné",
				"clear_all": "Effacer tout"
			},
			"errors": {
				"general": "Une erreur s’est produite. Veuillez contacter notre assistance.",
				"salesforce": "Veuillez rafraîchir la page. Si l'erreur persiste, veuillez envoyer l'ID d'erreur sur le canal Slack #smooothforce-support pour obtenir de l'aide.",
				"managed_kyc": "Veuillez réactualiser la page. Si l'erreur persiste, veuillez contacter notre service d'assistance des marchands ou votre contact de vente.",
				"copy": "Copier",
				"noTermsAccepted": "Veuillez lire et accepter tous les accords listés",
				"termsAlreadyAccepted": "Vous avez déjà acepté tous les accords listés",
				"mandatoryField": "est requis"
			},
			"options": {
				"entity_types": {
					"SOLE_TRADER": "Commerçant individuel",
					"PARTNERSHIP": "Partenariat",
					"PUBLIC_LISTED_COMPANY": "Société cotée en bourse",
					"PRIVATE_COMPANY": "Société privée"
				},
				"organization_entity_types": {
					"C_CORP": "C Corporation",
					"S_CORP": "S Corporation",
					"PARTNERSHIP": "Partenariat",
					"TRUST_ESTATE": "Fiducie/patrimoine",
					"INDIVIDUAL": "Individuel",
					"SOLE_PROPRIETORSHIP": "Entreprise personnelle",
					"SOLE_TRADER": "Commerçant individuel",
					"LIMITED_LIABILITY_COMPANY": "Société à responsabilité limitée",
					"SINGLE_MEMBER_LIMITED_LIABILITY_COMPANY": "Entreprise unipersonnelle à responsabilité limitée"
				},
				"goods_categories": {
					"ADULT_SHOES_AND_CLOTHING": "Vêtements et chaussures - Chaussures et vêtements pour adultes",
					"AUTOMOTIVE_PARTS_AND_ACCESSORIES": "Produits automobiles - Pièces et accessoires automobiles",
					"BAGS_AND_WALLETS": "Bijoux et accessoires - Sacs et portefeuilles",
					"BODY_AND_HAIR_CARE": "Santé et beauté - Soin du corps et des cheveux",
					"BOOK_AND_MAGAZINES": "Divertissement - Livre et magazines",
					"CANDY": "Alimentation et boissons - Confiseries",
					"CAR_ELECTRONICS": "Électronique - Électronique automobile",
					"CHILDREN_CLOTHES_AND_NURTURING_PRODUCTS": "Produits pour les enfants - Vêtements pour enfants et articles de soin",
					"CHILDREN_TOYS": "Produits pour les enfants - Jouets pour enfants",
					"CLEANING_AND_SANITARY": "Maison et jardin - Nettoyage et hygiène",
					"COLLECTIBLES": "Loisirs, sport et hobbies - Collections",
					"CONCEPT_STORES_AND_MISCELLANEOUS": "Loisirs, sport et hobbies - Concept Store et divers",
					"COSMETICS": "Santé et beauté - Cosmétiques",
					"COSTUMES_AND_PARTY_SUPPLIES": "Loisirs, sport et hobbies - Costumes et articles de fête",
					"DATING_SERVICES": "Produits immatériels - Services de rencontre",
					"DECORATION_AND_ART": "Maison et jardin - Décoration et art",
					"DIETARY_SUPPLEMENTS": "Santé et beauté - Compléments alimentaires",
					"DIGITAL_SERVICES": "Produits immatériels - Services numériques",
					"DIVERSIFIED_CHILDREN_PRODUCTS": "Produits pour les enfants - Articles pour enfants variés",
					"DIVERSIFIED_ELECTRONICS": "Électronique - Articles électroniques variés",
					"DIVERSIFIED_ENTERTAINMENT": "Divertissement - Divertissements variés",
					"DIVERSIFIED_EROTIC_MATERIAL": "Articles érotiques - Articles érotiques variés",
					"DIVERSIFIED_HEALTH_AND_BEAUTY_PRODUCTS": "Santé et beauté - Articles santé et beauté variés",
					"DIVERSIFIED_HOME_AND_GARDEN_PRODUCTS": "Maison et jardin - Articles maison et jardin variés",
					"DIVERSIFIED_JEWELRY_AND_ACCESSORIES": "Bijoux et accessoires - Bijoux et accessoires variés",
					"EDUCATION": "Produits immatériels - Éducation",
					"ELECTRONIC_EQUIPMENT_AND_RELATED_ACCESSORIES": "Électronique - Équipement électronique et accessoires associés",
					"EROTIC_CLOTHING_AND_ACCESSORIES": "Articles érotiques - Vêtements et accessoires érotiques",
					"EVENT_TICKETS": "Produits immatériels - Billets pour des événements",
					"FOOD_AND_BEVERAGE": "Alimentation et boissons - Aliments et boissons",
					"FRAGRANCES": "Santé et beauté - Parfums",
					"FURNITURE": "Maison et jardin - Meubles",
					"GENERAL_SHOES_AND_CLOTHING": "Vêtements et chaussures - Chaussures et vêtements généraux",
					"HOBBY_ARTICLES": "Loisirs, sport et hobbies - Articles de loisir",
					"HOUSEHOLD_ELECTRONICS": "Électronique - Électronique domestique",
					"JEWELRY_AND_WATCHES": "Bijoux et accessoires - Bijoux et montres",
					"KITCHENWARE": "Maison et jardin - Ustensiles de cuisine",
					"MARKETPLACES": "Produits immatériels - Marchés",
					"MUSIC_AND_MOVIES": "Divertissement - Musique et films",
					"MUSICAL_INSTRUMENTS_AND_EQUIPMENT": "Loisirs, sport et hobbies - Matériel et instruments de musique",
					"NON_PRESCRIPTION_SUNGLASSES_AND_LENSES": "Bijoux et accessoires - Lunettes de soleil et lentilles sans ordonnance",
					"OFFICE_MACHINES_AND_RELATED_ACCESSORIES": "Électronique - Matériel de bureau et accessoires associés",
					"OTHER_SERVICES": "Produits immatériels - Autres services",
					"PERSONAL_CARE_AND_BODY_IMPROVEMENT": "Santé et beauté - Soins personnels et embellissement du corps",
					"PET_SUPPLIES": "Maison et jardin - Articles pour animaux domestiques",
					"PHARMACEUTICAL_PRODUCTS": "Santé et beauté - Produits pharmaceutiques",
					"PLANTS_AND_FLOWERS": "Maison et jardin - Plantes et fleurs",
					"PRESCRIPTION_OPTICS": "Santé et beauté - Optique de prescription",
					"PRINTS_AND_PHOTOS": "Loisirs, sport et hobbies - Impressions et photos",
					"SAFETY_PRODUCTS": "Maison et jardin - Produits de sécurité",
					"SEX_TOYS": "Articles érotiques - Jouets érotiques",
					"SPORTS_GEAR_AND_OUTDOOR": "Loisirs, sport et hobbies - Équipement de sport et d’extérieur",
					"TOBACCO": "Alimentation et boissons - Tabac",
					"TOOLS_AND_HOME_IMPROVEMENT": "Maison et jardin - Outils et embellissement de la maison",
					"TRAVEL_SERVICES": "Produits immatériels - Services de voyage",
					"UNDERWEAR": "Vêtements et chaussures - Sous-vêtements",
					"VIDEO_GAMES_AND_RELATED_ACCESSORIES": "Divertissement - Jeux vidéo et accessoires associés",
					"WHEELS_AND_TIRES": "Articles automobiles - Roues et pneus",
					"WINE_BEER_AND_LIQUOR": "Alimentation et boissons - Vin, bière et spiritueux",
					"YOUTHFUL_SHOES_AND_CLOTHING": "Vêtements et chaussures - Chaussures et vêtements pour les jeunes",
					"GAMBLING_BETTING_CASINOS_AND_LOTTERY": "Limite d'âge - Jeux d'argent, paris, casinos et loteries",
					"CHARITIES_AND_NGO": "Produits immatériels - Organismes de charité et services d'ONG",
					"EROTIC_SERVICES": "Articles érotiques - Services érotiques",
					"FINANCIAL_SERVICES_CRYPTO": "Services financiers - Activités liées à la cryptomonnaie",
					"FINANCIAL_SERVICES_MSB": "Services financiers - Entreprises de services monétaires",
					"FINANCIAL_SERVICES_E_WALLETS": "Services financiers - Portefeuilles virtuels",
					"FINANCIAL_SERVICES_TRADING": "Services financiers - Investissements boursiers",
					"SOCIAL_PLATFORMS_COMMUNITIES": "Produits immatériels - Communautés de réseaux sociaux",
					"TRAVEL_AIR_TRAVEL_AND_CRUISE_OPERATORS": "Voyage - Transport aérien et opérateurs de croisière",
					"TRAVEL_BROKER_AND_AGENCIES": "Voyage - Courtier et agences",
					"TRAVEL_GROUND_TRANSPORTATION": "Voyage - Transports terrestres",
					"TRAVEL_ACCOMMODATION_AND_RESORTS": "Voyage - Hébergement et hôtels",
					"EVENT_ORGANIZER": "Événements - Organisateur",
					"EVENT_BROKER_AND_AGENCIES": "Événementiel - Courtier et agences"
				},
				"us_states": {
					"AL": "Alabama",
					"AK": "Alaska",
					"AZ": "Arizona",
					"AR": "Arkansas",
					"CA": "Californie",
					"CO": "Colorado",
					"CT": "Connecticut",
					"DC": "District de Columbia",
					"DE": "Delaware",
					"FL": "Floride",
					"GA": "Géorgie",
					"HI": "Hawaï",
					"ID": "Idaho",
					"IL": "Illinois",
					"IN": "Indiana",
					"IA": "Iowa",
					"KS": "Kansas",
					"KY": "Kentucky",
					"LA": "Louisiane",
					"ME": "Maine",
					"MD": "Maryland",
					"MA": "Massachusetts",
					"MI": "Michigan",
					"MN": "Minnesota",
					"MS": "Mississippi",
					"MO": "Missouri",
					"MT": "Montana",
					"NE": "Nebraska",
					"NV": "Nevada",
					"NH": "New Hampshire",
					"NJ": "New Jersey",
					"NM": "Nouveau Mexique",
					"NY": "New York",
					"NC": "Caroline du Nord",
					"ND": "Dakota du Nord",
					"OH": "Ohio",
					"OK": "Oklahoma",
					"OR": "Oregon",
					"PA": "Pennsylvanie",
					"RI": "Rhode Island",
					"SC": "Caroline du Sud",
					"SD": "Dakota du Sud",
					"TN": "Tennessee",
					"TX": "Texas",
					"UT": "Utah",
					"VT": "Vermont",
					"VA": "Virginie",
					"WA": "Washington",
					"WV": "Virginie occidentale",
					"WI": "Wisconsin",
					"WY": "Wyoming"
				},
				"stakeholder": {
					"types": {
						"PERSON": "Personne",
						"COMPANY": "Société"
					},
					"roles": {
						"OWNER": "Propriétaire",
						"ULTIMATE_BENEFICIAL_OWNER": "Propriétaire bénéficiaire effectif",
						"CONTROL_OVER_MANAGEMENT": "Contrôle de gestion",
						"APPLICANT": "Signataire autorisé",
						"SOLE_TRADER": "Commerçant individuel",
						"PARTNER": "Partenaire"
					}
				},
				"payment_intervals": {
					"DAILY": "Quotidien",
					"WEEKLY": "Hebdomadaire"
				},
				"business_concepts": {
					"TRADITIONAL_SALE_OF_GOODS": {
						"label": "Vente de marchandises classique",
						"description": "Le marchand vend des produits ou des services de façon classique : les marchandises sont considérées comme entièrement consommées à la livraison et il n'existe généralement pas de période prolongée entre la commande et la livraison"
					},
					"VOUCHER": {
						"label": "Bon",
						"description": "Plus de 10 % des ventes se composent de bons et/ou de cartes-cadeaux"
					},
					"MEMBERSHIP": {
						"label": "Adhésion",
						"description": "Plus de 10 % des ventes se composent d'adhésions"
					},
					"SUBSCRIPTION": {
						"label": "Abonnement",
						"description": "Plus de 10 % des ventes se composent d'abonnements"
					},
					"PHARMACIES": {
						"label": "Pharmacies",
						"description": "Le commerçant vend des médicaments sur ordonnance ou sans ordonnance"
					},
					"US_PHARMACIES": {
						"label": "Pharmacies aux États-Unis",
						"description": "Le marchand vend des médicaments avec ou sans prescriptions aux États-Unis"
					},
					"MEDICAL_SERVICES": {
						"label": "Services médicaux",
						"description": "Le marchand vend des services médicaux tels que des test, des examens ou des soins infirmiers"
					},
					"MARKETPLACES": {
						"label": "Marketplaces",
						"description": "Le commerçant présente une relation de sous-marchand"
					},
					"FIREARM_DEALERS": {
						"label": "Revendeur d’armes à feu",
						"description": "Le commerçant vend des armes et munitions nécessitant une licence"
					},
					"AUCTIONS": {
						"label": "Enchères",
						"description": "Le commerçant représente une société de vente aux enchères"
					},
					"ALCOHOL": {
						"label": "Alcool",
						"description": "Le commerçant vend de l’alcool"
					},
					"TOBACCO": {
						"label": "Tabac",
						"description": "Le commerçant vend du tabac avec ou sans nicotine, ou des cigarettes électroniques"
					},
					"HEMP_CBD_THC": {
						"label": "Marijuana, CBD ou THC",
						"description": "Le commerçant vend des produits contenant de la marijuana, du CBD ou du THC"
					},
					"DONATIONS_CHARITY": {
						"label": "Dons et charité",
						"description": "Le commerçant représente une organisation caritative ou dédiée aux dons, inscrite selon le principe « Sortie de fonds post-règlement »"
					},
					"TRAVEL": {
						"label": "Voyage",
						"description": "Plus de 10 % des ventes se composent de voyages"
					},
					"EVENTS": {
						"label": "Événements",
						"description": "Plus de 10 % des ventes se composent d'événements"
					},
					"COURSES": {
						"label": "Formations",
						"description": "Plus de 10 % des ventes se composent de formations"
					},
					"EDUCATIONAL_COURSES": {
						"label": "Cours éducatifs",
						"description": "Le marchand vend des cours éducatifs ayant lieu pendant une période de temps donnée."
					},
					"FOOD_DELIVERY": {
						"label": "Livraison de nourriture",
						"description": "Le marchand offre un service de livraison de nourriture."
					},
					"CUSTOMISED_PRE_ORDER_FURNITURE": {
						"label": "Pré-commande personnalisée/Mobilier",
						"description": "Le marchand vend des produits en pré-commande, tels que du mobilier."
					},
					"DIGITAL_CONTENT": {
						"label": "Contenu numérique",
						"description": "Le marchand vend du contenu numérique, tel que des livres électroniques et des jeux en ligne."
					},
					"GAMING_INDUSTRY": {
						"label": "Industrie du jeu (jeux d'argent, paris, casinos, lotteries)",
						"description": "Le marchand offre des services liés à l'industrie du jeu, tels que les jeux d'argent, les paris, les casinos et les lotteries."
					}
				}
			},
			"pages": {
				"select_products_page": {
					"page_header": {
						"primary_title": "Bonjour, {firstName}",
						"primary_title_without_name": "Bonjour,",
						"sub_title": "Être ou ne pas être Klarna, comme le disait si bien Shakespeare.",
						"sub_title_no_products": "Commencez votre expérience Klarna en choisissant un produit ci-dessous",
						"sub_title_kp_products": "Sélectionner un autre produit Klarna",
						"sub_title_ongoing_product": "Continuer la configuration de {productName}"
					},
					"sidebar_left": {
						"products": {
							"title": "Produits de paiement",
							"text_blocks": [
								{
									"text": "Ajouter une solution à votre configuration"
								}
							]
						}
					},
					"buttons": {
						"start": "Commencer",
						"continue": "Continuer",
						"view_summary": "Afficher le résumé",
						"add_another_product": "Ajouter un autre produit"
					},
					"goodie_bags": {
						"playground": {
							"title": "Aire de jeux",
							"text": "Passez à l’environnement « Terrain de jeu » afin d’explorer et de générer des identifiants pour l’API d’essai, et testez votre plateforme.",
							"link": "Aire de jeux"
						},
						"marketing_assets": {
							"title": "Ressources marketing",
							"text": "Utiliser Klarna garantit une navigation smoooth pour vos clients. Utilisez nos ressources marketing pour susciter leur enthousiasme.",
							"link": "Obtenir des ressources"
						},
						"your_application": {
							"title": "Votre candidature",
							"text": "Cliquez ici pour terminer votre configuration ou afficher les détails de votre candidature, y compris les conditions générales.",
							"link": "Ouvrir"
						},
						"invite_more_users": {
							"title": "Inviter plus d’utilisateurs",
							"text": "Invitez vos collaborateurs sur le Portail marchand. Vous pourrez définir des autorisations personnalisées pour chacun d’eux !",
							"link": "Inviter des utilisateurs"
						}
					},
					"footer": {
						"title": "Toujours inclus avec Klarna",
						"list": {
							"merchant_portal": {
								"title": "Le Portail marchand",
								"text_blocks": [
									{
										"text": "Gérez tout ce dont vous avez besoin dans Klarna avec un accès complet en back-end."
									}
								]
							},
							"global_products": {
								"title": "Produits internationaux, visages locaux",
								"text_blocks": [
									{
										"text": "Tous nos produits sont conçus pour répondre aux préférences et législations locales."
									}
								]
							},
							"local_support": {
								"title": "Assistance locale pour vous et vos clients",
								"text_blocks": [
									{
										"text": "Nos milliers de collaborateurs sont prêts à aider vos clients quand ils ont besoin d’un contact humain."
									}
								]
							},
							"marketing_tool": {
								"title": "Klarna en tant qu’outil marketing",
								"text_blocks": [
									{
										"text": "Nous vous donnons accès aux ressources Klarna, que vous pouvez utiliser dans vos démarches marketing."
									}
								]
							},
							"single_integration": {
								"title": "Intégration unique, mises à jour automatiques",
								"text_blocks": [
									{
										"text": "Une intégration, aucune mise à jour. Jamais."
									},
									{
										"text": "Une fois que vous avez intégré Klarna, vous avez terminé. Le système reste à jour, sans même que vous ayez à lever le petit doigt."
									}
								]
							},
							"no_risk": {
								"title": "Aucun risque pour vous ou vos clients",
								"text_blocks": [
									{
										"text": "Vos paiements sont toujours garantis, et vos clients sont couverts par la protection des acheteurs de Klarna."
									}
								]
							}
						}
					}
				},
				"credentials_page": {
					"sidebar_left": {
						"connection_key": {
							"title": "Identifiants d'API Klarna",
							"text_blocks": [
								{
									"text": "Les identifiants d’API Klarna connectent notre produit à votre boutique, afin que vous puissiez commencer à vendre sans attendre."
								}
							]
						},
						"toc_key": {
							"title": "Conditions générales",
							"text_blocks": [
								{
									"text": "Vous devez simplement mettre à jour vos conditions générales de commerce électronique."
								}
							]
						},
						"connect_to_your_platform": {
							"title": "Instructions d’intégration",
							"text_blocks": [
								{
									"text": ""
								}
							]
						}
					},
					"main": {
						"how_to_use": {
							"title": "Comment utiliser les identifiants d'API Klarna",
							"ordered_list": {
								"one": "Générez et téléchargez vos identifiants",
								"two": "Ajoutez les identifiants (nom d’utilisateur et mot de passe de l'API Klarna) à votre plateforme comme expliqué dans les instructions d’intégration ci-dessous"
							}
						},
						"number_of_live_keys_in_total": {
							"title": "5 identifiants d'API Klarna au total",
							"text": "Vous pouvez générer jusqu’à cinq identifiants pour l’API Klarna. Obtenez le premier ici, puis créez les autres dans les Paramètres.",
							"button": "Générer des identifiants d'API Klarna"
						},
						"how_to_update_toc": {
							"title": "Comment mettre à jour les conditions générales",
							"ordered_list": {
								"one": "Cliquez sur le lien",
								"two": "Lisez les instructions et copiez le texte",
								"three": "Intégrez-le ensuite dans les conditions générales de votre boutique en ligne"
							}
						},
						"update_toc_link": {
							"title": "",
							"text": "N’oubliez pas de mettre à jour le texte avec les produits auxquels vous avez souscrit.",
							"linkText": "Rendez-vous sur des Conditions générales >"
						},
						"buttons": {
							"back": "Retour"
						}
					}
				},
				"whats_next_page": {
					"communication": {
						"TRANSACTIONS_REVIEW_AUTOMATED": "Votre candidature est en cours d’examen...",
						"TRANSACTION_DETAILS_STARTED": "Votre candidature est examinée par notre équipe. Nous vous recontacterons dès que possible.",
						"TRANSACTIONS_REVIEW_MANUAL": "Votre candidature est examinée par notre équipe. Nous vous recontacterons dès que possible.",
						"TRANSACTIONS_ENABLED": "Félicitations. Vous êtes prêt à vendre avec Klarna.",
						"PAYOUTS_REVIEW_AUTOMATED": "Votre demande de règlement est en cours d’examen...",
						"PAYOUTS_REVIEW_MANUAL": "Votre demande de règlement est examinée par notre équipe. Nous vous recontacterons dès que possible.",
						"PAYOUTS_REVIEW_AWAITING_FIRST_TRANSACTION": "En attente de votre première vente avec Klarna...",
						"TRANSACTIONS_DISABLED": "Votre compte est désactivé. Vous devez finaliser l’étape Activer les règlements.",
						"SUSPENDED": "Votre compte est suspendu.",
						"notice": "Le délai nécessaire pour étudier les demandes est actuellement plus long qu’en temps normal. Mais ne vous inquiétez pas, votre demande est en cours d’examen et nous vous contacterons pour vous fournir plus d’informations sur les prochaines étapes. Nous vous remercions de votre patience et de votre compréhension."
					},
					"statuses": {
						"pending": "En attente",
						"done": "Terminé"
					},
					"in_review": {
						"title": "Nous sommes en train d'analyser votre candidature.",
						"subtitle": "Nous effectuons actuellement l'examen final de votre candidature auprès de Klarna afin de nous assurer que tous les aspects du contrat soient correct. Comme cette procédure est réalisée manuellement, sa durée est susceptible de varier, mais nous nous efforcerons de la réaliser aussi rapidement que possible.",
						"content": {
							"title": "Afin que la révision soit effectuée le plus rapidement possible, assurez-vous que les informations suivantes sont visibles sur votre site :",
							"list": {
								"default": {
									"item_1": "Dénomination sociale de votre société",
									"item_2": "Numéro d'enregistrement de votre société",
									"item_3": "Adresse officielle de votre société",
									"item_4": "Politique de retour d'au moins 14 jours",
									"item_5": "Adresse e-mail ou numéro de téléphone du service client"
								},
								"US": {
									"item_1": "Dénomination sociale de la société",
									"item_2": "Politique de retour",
									"irem_3": "Adresse e-mail ou numéro de téléphone du service client"
								},
								"AU": {
									"item_1": "Numéro d'identification d'entreprise (ABN)",
									"item_3": "Adresse officielle de votre société",
									"item_4": "Politique de retour d'au moins 14 jours",
									"item_5": "Adresse e-mail ou numéro de téléphone du service client"
								}
							}
						},
						"footer": "Nous vous enverrons un e-mail une fois la révision terminée ou dans le cas où nous aurions besoin d'informations supplémentaires."
					},
					"suspended": {
						"title": "Malheureusement...",
						"subtitle": "Suite à l’examen de vos données commerciales, nous avons dû rejeter votre candidature. Plusieurs raisons peuvent expliquer le rejet de votre candidature. Vous trouverez quelques-uns des motifs les plus courants ci-dessous.",
						"content": {
							"title": "",
							"list": {
								"item_1": "Votre boutique ne respecte pas les directives éthiques de Klarna.",
								"item_2": "Impossibilité de joindre la personne de contact enregistrée. ",
								"item_3": "Autres facteurs techniques ou administratifs."
							}
						},
						"footer": "Merci pour l'intérêt que vous portez à Klarna. Veuillez prendre contact avec nous si vous avez la moindre question ou si vous souhaitez vous inscrire avec une autre boutique à l'avenir."
					},
					"disabled": {
						"title": "Votre candidature a été désactivée.",
						"subtitle": "Votre compte a été automatiquement désactivé car certaines informations légales obligatoires ne sont pas présentes.",
						"content": {
							"title": "La raison la plus probable est que Klarna vous a demandé de fournir des informations et que vous n'avez pas répondu avant la date d'échéance indiquée."
						},
						"footer": "Si vous pensez qu'il s'agit d'une erreur et voudriez à nouveau soumettre vos informations, veuillez contacter le support aux marchands à l'aide des informations de contact au bas de cette page."
					},
					"ready_to_connect": {
						"title": "Connectez votre boutique",
						"subtitle": "Votre contrat est rempli ; vous pouvez maintenant intégrer Klarna à votre boutique. Suivez les étapes ci-dessous pour finaliser l'intégration.",
						"status_messsage": {
							"title": "L'intégration n'est pas encore finalisée",
							"subtitle": "Suivez les instructions d'intégration pour connecter votre boutique. Ce statut passera au vert une fois qu'une transaction aura été effectuée à l'aide de Klarna."
						},
						"content": {
							"title": "Instructions",
							"options": {
								"label_1": "Générez et sauvegardez vos identifiants de l'API Klarna",
								"description_1": "Générez de nouveaux identifiants de l'API et téléchargez-les sur votre ordinateur. Ces identifiants seront nécessaires lors de la prochaine étape.",
								"label_2": "Installer Klarna dans votre boutique Shopify"
							}
						}
					},
					"ready_to_connect_new_ig": {
						"title": "Vous y êtes presque.",
						"subtitle": "Une étape de plus franchie pour offrir à vos clients une expérience d'achat smoooth ! Votre contrat est rempli et votre boutique est prête à l'intégration.",
						"buttons": {
							"connect": "Connectez votre boutique"
						},
						"additional_info": "Veuillez noter que l'intégration ne sera marquée comme vraiment complète que lorsque nous recevrons le premier achat, ce qui pourrait prendre un certain temps selon votre plateforme."
					},
					"store_connected": {
						"title": "Votre boutique est connectée",
						"subtitle": "L'intégration de votre boutique à Klarna est terminée et vos clients peuvent dorénavant utiliser Klarna pour leurs paiements.",
						"status_messsage": {
							"title": "Intégration réussie",
							"subtitle": "Une transaction par Klarna a été réalisée avec succès sur votre boutique.",
							"button_text": {
								"shown": "Afficher les instructions d'intégration",
								"hidden": "Masquer les instructions d'intégration"
							}
						}
					},
					"actions": {
						"view_summary": {
							"title": "Votre candidature",
							"subtitle": "Réviser les informations de votre candidature.",
							"button_text": "Afficher le résumé"
						},
						"connect_store": {
							"title": "Identifiants d'API Klarna",
							"subtitle": "Générez vos identifiants d'API Klarna pour intégrer votre boutique.",
							"button_text": "Générer des identifiants d'API Klarna"
						},
						"add_product": {
							"title": "Produits",
							"subtitle": "Cliquez ici si vous souhaitez ajouter un produit à cette configuration.",
							"button_text": "Ajouter des produits"
						}
					},
					"timeline": {
						"application": {
							"title": "Votre candidature",
							"alert": {
								"view_summary": "Afficher le résumé",
								"rejected": "Nous avons dû rejeter votre demande.",
								"review": "Vérifiez les informations de votre demande en cliquant sur le lien ci-dessous."
							}
						},
						"payouts": {
							"title": "Règlements activés"
						},
						"integration": {
							"title": "L'intégration n'est pas encore finalisée",
							"alert": "Suivez les instructions d’intégration pour connecter votre magasin."
						},
						"integration_complete": {
							"title": "Intégration terminée !"
						}
					}
				},
				"summary_page": {
					"header": {
						"title": "Félicitations, votre configuration est terminée !",
						"rejection": "Nous sommes désolés, nous n’avons pas pu terminer votre configuration."
					},
					"header_new": {
						"title": "Bienvenue, cher marchand Klarna",
						"subtitle": "Synthèse",
						"rejection": "Candidature rejetée"
					},
					"joy_section": {
						"approved": {
							"title": "C’est validé !",
							"content": "Votre candidature a été examinée et validée. Vous bénéficiez désormais d’un accès complet au service Klarna. Nous sommes ravis de travailler avec vous !",
							"button_title": "Consultez vos commandes",
							"link": "ou nos ressources marketing"
						},
						"rejected": {
							"title": "Malheureusement...",
							"content_1": "Nous avons examiné votre candidature, et ne sommes malheureusement pas en mesure de valider votre contrat en tant que marchand.",
							"content_2": "N’hésitez pas à contacter notre équipe d’assistance si vous avez des questions."
						}
					},
					"sidebar_left": {
						"application_details": "Détails de votre candidature",
						"store_details": {
							"title": "Détails relatifs à la boutique",
							"text_blocks": [
								{
									"text": "Résumé de vos informations"
								}
							]
						},
						"credentials": {
							"title": "Identifiants d'API Klarna",
							"text_blocks": [
								{
									"text": "Vos identifiants d'API Klarna"
								}
							]
						},
						"payouts": {
							"title": "Règlements",
							"text_blocks": [
								{
									"text": "Vos données bancaires transmises"
								}
							]
						},
						"additional_bank_accounts": {
							"title": "Comptes bancaires supplémentaires",
							"text_block": null
						},
						"business_owners": {
							"title": "Propriétaires d’entreprise",
							"text_blocks": null
						},
						"material_influencers": {
							"title": "Personnes de grande influence",
							"text_blocks": null
						},
						"stakeholders": {
							"title": "Parties prenantes",
							"text_blocks": [
								{
									"text": "Vos informations transmises"
								}
							]
						}
					},
					"main": {
						"store_details": {
							"business_owners": {
								"title": "Propriétaires d’entreprise",
								"no_elements": "Vous n’avez indiqué aucun propriétaire d’entreprise"
							}
						},
						"payouts": {
							"default_bank_accounts": {
								"title": "Compte bancaire par défaut",
								"no_elements": "Aucun compte bancaire par défaut disponible"
							},
							"additional_bank_accounts": {
								"title": "Comptes bancaires supplémentaires",
								"no_elements": "Vous n’avez pas indiqué de comptes bancaires supplémentaires"
							}
						},
						"stakeholders": {
							"owners": {
								"title": "Propriétaires",
								"no_elements": "Vous n’avez indiqué aucun propriétaire"
							},
							"ultimate_beneficial_owner": {
								"title": "Bénéficiaires effectifs",
								"no_elements": "Vous n’avez indiqué aucun bénéficiaire effectif"
							},
							"applicant": {
								"title": "Candidats",
								"no_elements": "Vous n’avez indiqué aucun(e) candidat(e)"
							},
							"control_over_management": {
								"title": "Personnes exerçant un contrôle au niveau de la direction",
								"no_elements": "Vous n’avez indiqué aucune partie prenante exerçant un contrôle au niveau de la direction"
							}
						},
						"buttons": {
							"back": "Retour",
							"next_step": "Suivant"
						}
					}
				},
				"additional_products_page": {
					"sidebar_left": {
						"we_have_your_data": {
							"title": "Nous disposons déjà de vos données",
							"text_blocks": [
								{
									"text": "Il s’agit des informations que vous nous avez fournies précédemment."
								}
							]
						}
					},
					"main": {
						"business_ownership": {
							"no_elements": "Vous n’avez indiqué aucun propriétaire d’entreprise"
						},
						"buttons": {
							"submit": "Envoyer",
							"back": "Retour"
						}
					}
				},
				"checking_page": {
					"title": "Vérification...",
					"subtitle": "Merci d’avoir envoyé le formulaire de candidature. Veuillez patienter pendant que nous vérifions vos informations..."
				},
				"success_page": {
					"title": "Vous pouvez maintenant connecter votre boutique",
					"subtitle": "Merci d’avoir envoyé le formulaire de candidature.",
					"buttons": {
						"next": "Suivant"
					}
				}
			},
			"components": {
				"split_image_container": {
					"timeline": {
						"basics": "Fondamentaux",
						"business": "Entreprise",
						"stakeholders": "Parties prenantes",
						"bank_accounts": "Comptes bancaires"
					}
				},
				"app_error": {
					"title": "L’application Produits est actuellement indisponible",
					"message": "Nous rencontrons des problèmes avec notre application, et travaillons actuellement à leur résolution. Nous faisons notre maximum pour trouver une solution aussi vite que possible. Veuillez réessayer à nouveau plus tard."
				},
				"temporarily_down": {
					"title": "Nous rencontrons des difficultés techniques",
					"message": "Nous vous prions de bien vouloir nous excuser pour la gêne occasionnée et vous assurons que nous faisons de notre mieux pour résoudre le problème. Veuillez réessayer ultérieurement."
				},
				"maintenance_mode": {
					"title": {
						"products_app": "Notre application Produits est actuellement indisponible pour des raisons de maintenance",
						"signup_app": "Notre application Inscription est en cours de maintenance"
					},
					"message": "Nous travaillons en vue d’améliorer votre expérience et faisons notre maximum pour terminer le plus rapidement possible. Veuillez réessayer ultérieurement."
				},
				"unknown_merchant": {
					"before_link": "Si vous avez déjà un accord avec nous, rendez-vous sur",
					"link_text": "cette page",
					"after_link": "pour en savoir plus sur nos produits !"
				},
				"pre_assessment_error": {
					"title": {
						"invalid_flow_type": "Une erreur s’est produite.",
						"invalid_token": "Ce lien a expiré"
					},
					"message": {
						"invalid_token_risk": "Veuillez contacter le canal Slack #smooothforce-support pour obtenir de l'aide.",
						"invalid_token": "Veuillez contacter votre contact de vente.",
						"invalid_flow_type": "Le type et le statut d’intégration de ce marchand sont incompatibles. Si vous pensez qu’il s’agit d’une erreur, veuillez contacter le service de Support aux marchands."
					}
				},
				"topbar": {
					"title": "Configuration",
					"widget_type": {
						"MANAGED_KYC": "Sélection KYC",
						"MANAGED_RISK": "Sélection de pré-évaluation",
						"MANAGED_SME_RISK": "Sélection de pré-évaluation pour les PME"
					}
				},
				"product_card": {
					"incompatible_description": "Indisponible dans votre pays/sur votre plateforme",
					"kco_footer_text": "Les modes de paiement disponibles sur la Page de paiement Klarna dépendent de votre pays d’inscription et du pays auquel vous vendez.",
					"products_link_text": "Plus"
				},
				"product_prices_card": {
					"title": "Produits",
					"subtitle": "{country}",
					"pricing": "Tarification en/au/aux/à {country}",
					"monthly_fee": "frais mensuels",
					"transaction_fee": "frais de transaction",
					"before_link": "J’accepte les",
					"link_text": "Conditions générales",
					"after_link_one_product": "concernant ce produit",
					"after_link_more_than_one_product": "concernant ces produits",
					"product_not_available_in_your_country": "* Ce produit n’est pas disponible sur votre marché national, mais il est disponible dans d’autres pays.",
					"edit_link": "Modifier",
					"merchant_agreement": {
						"before_link": "J’accepte",
						"link_text": "le Contrat de commerçant",
						"after_link_one_product": "pour ce produit",
						"after_link_more_than_one_product": "pour ces produits"
					},
					"pricing_annex": {
						"before_link": "J’accepte",
						"link_text": "les Conditions de tarification",
						"after_link_one_product": "pour ce produit"
					}
				},
				"support_footer": {
					"text": "Assistance en anglais",
					"copyright": {
						"eu": "Copyright © 2005-{currentYear} Klarna Bank AB (publ). Tous droits réservés.",
						"ap": "Copyright © 2005-{currentYear} Klarna Australia Pty Ltd, ABN # 82 635 912 579.",
						"us": "Copyright © 2005-{currentYear} Klarna Inc. NMLS #1353190, 629 N. High Street, Third Floor, Columbus, OH 43215."
					},
					"terms_and_conditions": "Conditions générales",
					"privacy_policy": "Politique de confidentialité",
					"merchant_id": "ID de marchand {merchantId}",
					"email": "moa.support@klarna.com",
					"contact_number": "+46 (8) 123 45 67",
					"support_link": "Support aux marchands",
					"recaptcha": {
						"1_main_text": "Ce site est protégé par reCAPTCHA et les",
						"2_privacy_policy": "Politique de confidentialité du Portail des marchands",
						"3_and": "et",
						"4_terms_of_service": "conditions d'utilisation de Google",
						"5_apply": "s'appliquent."
					}
				},
				"global_prices_dialog": {
					"title_eu": "Prix pour tous nos marchés",
					"title_us": "Prix",
					"subtitle": "Vous ne payez que les frais par transaction, c’est smoooth !",
					"table": {
						"country": "Pays",
						"price_column_heading": "Frais par transaction",
						"global": "Mondial",
						"title": {
							"kp": "Moyens de paiement",
							"kco": "Klarna Checkout",
							"kco_one": "Klarna Checkout",
							"kp_one": "Méthode de paiement Klarna"
						},
						"headers": {
							"kp_one": "Frais de service"
						}
					},
					"buttons": {
						"back": "Retour"
					},
					"foot_notes": {
						"global_price": "* Ou devise locale du commerçant "
					}
				},
				"fake_approval": {
					"first_transaction": {
						"title": "Première transaction",
						"content": "Nous avons besoin d’une première commande pour pouvoir vérifier vos informations de paiement. Vous ne voulez pas gaspiller votre propre argent ? Aucun problème !",
						"button": "Vous pouvez simuler la transaction."
					},
					"transactions": {
						"title": "Valider les transactions",
						"content": "Vous pouvez simplement simuler la validation de la transaction commerciale",
						"button": "Valider"
					},
					"payouts": {
						"title": "Valider les règlements",
						"content": "Vous pouvez simplement simuler la validation des règlements commerciaux",
						"button": "Valider"
					}
				},
				"bank_account_summary": {
					"subtitle": {
						"default": "Compte bancaire par défaut",
						"additional": "Compte bancaire supplémentaire {index}",
						"normal": "Compte bancaire {index}"
					},
					"currency_code": {
						"label": "Devise"
					},
					"country_of_bank_account": {
						"label": "Pays"
					},
					"account_number": {
						"label": {
							"default": "Numéro de compte",
							"MX_LOCAL": "Numéro CLABE"
						}
					},
					"account_holder": {
						"label": "Nom du titulaire du compte"
					},
					"routing_number": {
						"label": "Numéro de routage"
					},
					"transit_number": {
						"label": "Numéro de routage"
					},
					"institution_number": {
						"label": "Numéro de l'institution"
					},
					"bic": {
						"label": {
							"default": "Code BIC",
							"AU": "Code BSB"
						}
					},
					"no_edit_button": "Vous pourrez modifier les informations de votre compte bancaire une fois votre intégration finalisée"
				},
				"store_details_summary": {
					"legal_company_name": {
						"label": "Nom légal de la société"
					},
					"country": {
						"label": "Pays"
					},
					"registrationId": {
						"label": {
							"default": "Numéro d’enregistrement",
							"AT": "Numéro d’enregistrement",
							"AU": "Numéro ACN",
							"CA": "Numéro d'entreprise",
							"ES": "NIF/NIE/DNI de société",
							"GB": "Numéro d’entreprise",
							"GR": "Numéro G.E.MI. (Γ.Ε.ΜΗ.)",
							"US": "Numéro d’identification de l'employeur"
						}
					},
					"organizationRegistrationAuthority": {
						"label": "Tribunal d’enregistrement"
					},
					"goodsCategory": {
						"label": "Catégorie de marchandises"
					},
					"registered": {
						"label": {
							"default": "Société enregistrée",
							"AU": "La société possède un numéro ACN"
						}
					},
					"subjectToVat": {
						"label": {
							"default": "Société assujettie à la TVA",
							"AU": "Société présentant un numéro ABN",
							"ES": "Ma société possède un NIF/NIE/DNI"
						}
					},
					"vatId": {
						"label": {
							"default": "Numéro de TVA",
							"AU": "Numéro ABN",
							"ES": "NIF/NIE/DNI de société"
						}
					},
					"storeName": {
						"label": "Nom de la boutique"
					},
					"website": {
						"label": "Site Web"
					},
					"email": {
						"label": "Adresse électronique de l'assistance client"
					},
					"entityType": {
						"label": "Type d’entité"
					},
					"toc_data": {
						"label": "Conditions générales",
						"toc_approval_text": {
							"before_link": "Vos",
							"link_text": "conditions générales",
							"after_link": "acceptées le {date}",
							"merchant_agreement": {
								"before_link": "Votre",
								"link_text": "Contrat de commerçant",
								"after_link": "accepté le {date}"
							},
							"pricing_annex": {
								"before_link": "Votre",
								"link_text": "Annexe sur la tarification",
								"after_link": "acceptée le {date}"
							}
						}
					},
					"companyName": {
						"label": "Nom du partenariat"
					},
					"registeredCompanyName": {
						"label": "Raison sociale"
					},
					"address": {
						"label": "Adresse"
					},
					"operatingAddress": {
						"label": "Adresse d’exploitation"
					},
					"organizationEntityType": {
						"label": "Classification fiscale"
					}
				},
				"api_key_dialog": {
					"title": "Identifiants d'API Klarna générés",
					"subtitle": "Ces identifiants ne seront affichés qu'une seule fois. Cliquez sur le bouton ci-dessous pour télécharger vos identifiants avant de fermer cette fenêtre.",
					"key_box": {
						"username": {
							"label": "Nom d'utilisateur de l'API Klarna"
						},
						"password": {
							"label": "Mot de passe de l'API Klarna"
						},
						"file_name": "Klarna_credentials"
					},
					"buttons": {
						"download": "Télécharger au format .txt"
					}
				},
				"platform_instructions": {
					"step": "Étape {current}/{max}",
					"next": "Suivant",
					"back": "Retour",
					"shopify": [
						{
							"title": "Générez et sauvegardez vos identifiants de l'API Klarna",
							"step_instructions": [
								[
									{
										"text": "Générez de nouveaux identifiants de l'API et téléchargez-les sur votre ordinateur. Ouvrez le fichier et laissez-le ouvert : ces identifiants seront nécessaires lors de la prochaine étape."
									}
								]
							],
							"alternate": [
								{
									"text": "Pour de plus amples informations sur votre intégration Shopify, suivez le"
								},
								{
									"link": "https://x.klarnacdn.net/plugins/Klarna%20Payments%20on%20Shopify%20-%20Merchant%20Guide.pdf#page=4",
									"text": "guide d'intégration complet."
								}
							]
						},
						{
							"title": "Installer Klarna dans votre boutique Shopify",
							"step_instructions": [
								[
									{
										"text": "Se rendre au"
									},
									{
										"link": "https://www.klarnapayments.com/merchant_admin/guide/install_app/slice_it_pay_over_time_with_klarna/enter-your-shopify-store-name-here",
										"text": "Assistant de configuration de la méthode de paiement Klarna avec Shopify."
									}
								],
								[
									{
										"text": "Suivez-y les instructions pour finaliser votre intégration."
									}
								]
							],
							"alternate": [
								{
									"text": "Pour de plus amples informations sur votre intégration Shopify, suivez le"
								},
								{
									"link": "https://x.klarnacdn.net/plugins/Klarna%20Payments%20on%20Shopify%20-%20Merchant%20Guide.pdf#page=4",
									"text": "guide d'intégration complet."
								}
							]
						},
						{
							"title": "Effectuer un test d'achat",
							"step_instructions": [
								[
									{
										"text": "Afin de vérifier que l'intégration a été correctement configurée, veuillez effectuer un test d'achat sur votre boutique."
									}
								],
								[
									{
										"text": "Une fois la commande effectuée, rendez-vous sur l'onglet"
									},
									{
										"link": "/orders/#realm=merchants",
										"text": "Commandes sur le portail des marchands,"
									},
									{
										"text": "localisez votre commande et annulez-la, afin d'éviter de devoir la payer vous-même."
									}
								],
								[
									{
										"text": "Une fois l'intégration réussie, la bannière en tête de cette page passera au vert et vous verrez apparaître les mots « Intégration terminée »."
									}
								]
							],
							"alternate": [
								{
									"text": "Pour de plus amples informations sur votre intégration Shopify, suivez le"
								},
								{
									"link": "https://x.klarnacdn.net/plugins/Klarna%20Payments%20on%20Shopify%20-%20Merchant%20Guide.pdf#page=4",
									"text": "guide d'intégration complet."
								}
							]
						}
					],
					"plentymarkets": [
						{
							"title": "Activer le plugin de la méthode de paiement Klarna pour Plentymarkets",
							"step_instructions": [
								[
									{
										"text": "Pour pouvoir installer le plugin Klarna, vous avez besoin du système d’exécution Plentymarkets CERES. Le"
									},
									{
										"link": "https://marketplace.plentymarkets.com/en/plugins/sales/online-shops/ceres_4697",
										"text": "plugin Ceres"
									},
									{
										"text": "peut être téléchargé sur plentyMarketplace. De là, vous serez également redirigé(e) vers les"
									},
									{
										"link": "https://knowledge.plentymarkets.com/en/online-store/setting-up-ceres",
										"text": "instructions d'installation."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Pour de plus amples informations concernant l'intégration de Klarna à Plentymarkets Ceres, veuillez suivre"
									},
									{
										"link": "https://marketplace.plentymarkets.com/plugins/payment/klarna_6731",
										"text": "ce lien."
									}
								]
							]
						},
						{
							"title": "Installation et configuration",
							"step_instructions": [
								[
									{
										"text": "L'installation du plugin Klarna se fait via"
									},
									{
										"link": "https://marketplace.plentymarkets.com/plugins/payment/klarna_6731",
										"text": "plentyMarketplace."
									},
									{
										"text": "Vous serez aussi redirigé(e) vers plentyMarketplace depuis le service de gestion des systèmes Plentymarkets. Des"
									},
									{
										"link": "https://knowledge.plentymarkets.com/en/slp/plugins/plugins-system-hinzufuegen",
										"text": "instructions pour installer les plugins sur Plentymarkets"
									},
									{
										"text": "sont disponibles sur plentyKnowledge."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Pour de plus amples informations concernant l'intégration de Klarna à Plentymarkets Ceres, veuillez suivre"
									},
									{
										"link": "https://marketplace.plentymarkets.com/plugins/payment/klarna_6731",
										"text": "ce lien."
									}
								]
							]
						},
						{
							"title": "Configuration du plugin",
							"step_instructions": [
								[
									{
										"text": "Le plugin est directement configuré dans le groupe respectif. En cliquant sur la ligne du"
									},
									{
										"bold": "plugin Klarna"
									},
									{
										"text": "la page de configuration s'ouvre."
									}
								],
								[
									{
										"text": "La configuration comprend deux sections :"
									},
									{
										"list": [
											[
												{
													"bold": "L'authentification :"
												},
												{
													"text": "Le mode est utilisé afin de déterminer si elle est en cours de test ou en fonctionnement. Selon le mode, le nom d'utilisateur et le mot de passe doivent être enregistrés."
												}
											],
											[
												{
													"bold": "Les paramètres généraux :"
												},
												{
													"text": "Ici, vous pouvez sélectionner le produit que vous souhaitez utiliser : soit les méthodes de paiement individuel de Klarna (Klarna Payment), soit le paiement complet de Klarna (Klarna Checkout). Lorsque vous sélectionnez Klarna Checkout, le paiement sur la boutique sera automatiquement remplacé par Klarna Checkout."
												}
											]
										]
									},
									{
										"text": "Aucun paramètre supplémentaire n'est nécessaire. Si vous désactivez le plugin, ceci sera annulé."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Pour de plus amples informations concernant l'intégration de Klarna à Plentymarkets Ceres, veuillez suivre"
									},
									{
										"link": "https://marketplace.plentymarkets.com/plugins/payment/klarna_6731",
										"text": "ce lien."
									}
								]
							]
						},
						{
							"title": "Informations finales",
							"step_instructions": [
								[
									{
										"text": "La configuration suivante est requise :"
									},
									{
										"list": [
											{
												"text": "Plentymarkets version 7"
											},
											{
												"text": "Installation des plugins Ceres et IO"
											}
										]
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Pour de plus amples informations concernant l'intégration de Klarna à Plentymarkets Ceres, veuillez suivre"
									},
									{
										"link": "https://marketplace.plentymarkets.com/plugins/payment/klarna_6731",
										"text": "ce lien."
									}
								]
							]
						}
					],
					"woocommerce_kco": [
						{
							"title": "Activer le plugin « Klarna Checkout » (Page de paiement Klarna) pour WooCommerce",
							"step_instructions": [
								[
									{
										"text": "Tout d’abord, assurez-vous d’avoir installé le plugin Klarna Checkout pour WooCommerce. Si ce n’est pas le cas, rendez-vous sur"
									},
									{
										"link": "https://woocommerce.com/products/klarna-checkout/#",
										"text": "cette page"
									},
									{
										"text": "pour l’obtenir."
									}
								],
								[
									{
										"text": "Une fois que vous disposez de vos identifiants d’API Klarna, rendez-vous dans « Paramètres » puis « Paiement » dans le panneau WooCommerce. Sélectionnez Page de paiement Klarna."
									}
								],
								[
									{
										"text": "Activez la page de paiement Klarna en cochant la case « Activer page de paiement Klarna »."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Pour plus d’informations sur votre intégration WooCommerce, consultez le"
									},
									{
										"link": "https://docs.woocommerce.com/document/klarna-checkout/?_ga=2.128400911.2052696952.1531845795-1157999962.1506496988#",
										"text": "guide complet."
									}
								]
							]
						},
						{
							"title": "Configurer vos paramètres",
							"step_instructions": [
								[
									{
										"text": "Configurez les paramètres de votre plugin Klarna Checkout (Page de paiement Klarna). Notez que le champ « Titre » est utilisé pour définir l’intitulé du mode de paiement affiché dans vos e-mails de paiement et de confirmation de commande (c.-à-d. Page de paiement Klarna)."
									}
								],
								[
									{
										"text": "Cochez la case « Mode de test » si vous souhaitez créer des commandes à l’aide d’identifiants de test."
									}
								],
								[
									{
										"text": "Il est maintenant temps de saisir les paramètres du pays. Si vous êtes basé en Europe, cliquez sur « Développer » dans la section Europe. Si vous êtes basé aux États-Unis, cliquez sur « Développer » dans la section États-Unis."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Pour plus d’informations sur votre intégration WooCommerce, consultez le"
									},
									{
										"link": "https://docs.woocommerce.com/document/klarna-checkout/?_ga=2.128400911.2052696952.1531845795-1157999962.1506496988#",
										"text": "guide complet."
									}
								]
							]
						},
						{
							"title": "Ajouter vos identifiants d'API Klarna",
							"step_instructions": [
								[
									{
										"text": "Ajoutez vos identifiants d’API Klarna dans les champs Nom d’utilisateur de l'API Klarna et Mot de passe de l'API Klarna."
									}
								],
								[
									{
										"text": "Enregistrez vos paramètres."
									}
								],
								[
									{
										"text": "Il ne vous reste plus qu’à définir la Page de paiement Klarna comme mode de paiement par défaut. Accédez à « Paramètres » puis « Paiements » dans le panneau WooCommerce. Localisez la section « Modes de paiement » et définissez la Page de paiement Klarna comme mode de paiement par défaut."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Pour plus d’informations sur votre intégration WooCommerce, consultez le"
									},
									{
										"link": "https://docs.woocommerce.com/document/klarna-checkout/?_ga=2.128400911.2052696952.1531845795-1157999962.1506496988#",
										"text": "guide complet."
									}
								]
							]
						},
						{
							"title": "Dernières étapes",
							"step_instructions": [
								[
									{
										"text": "Assurez-vous d’activer"
									},
									{
										"link": "https://codex.wordpress.org/Using_Permalinks",
										"text": "les permaliens"
									},
									{
										"text": "dans votre installation WordPress. Si vous ne le faites pas, les rappels envoyés par Klarna à votre boutique ne fonctionneront pas et les commandes ne seront pas mises à jour avec le statut/les informations de commande corrects."
									}
								],
								[
									{
										"text": "Si vous souhaitez gérer votre commande Klarna directement dans WooCommerce, vous devez installer le plugin"
									},
									{
										"link": "https://wordpress.org/plugins/klarna-order-management-for-woocommerce/",
										"text": "Klarna Order Management (Gestion des commandes Klarna)"
									},
									{
										"text": "."
									}
								],
								[
									{
										"text": "Assurez-vous que la Page de paiement Klarna s’affiche comme prévu en ajoutant un article à votre panier et en accédant au paiement (ne passez pas réellement la commande)."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Pour plus d’informations sur votre intégration WooCommerce, consultez le"
									},
									{
										"link": "https://docs.woocommerce.com/document/klarna-checkout/?_ga=2.128400911.2052696952.1531845795-1157999962.1506496988#",
										"text": "guide complet."
									}
								]
							]
						}
					],
					"woocommerce_kp": [
						{
							"title": "Générez et sauvegardez vos identifiants de l'API Klarna",
							"step_instructions": [
								[
									{
										"text": "Générez de nouveaux identifiants de l'API et téléchargez-les sur votre ordinateur. Ouvrez le fichier et laissez-le ouvert : ces identifiants seront nécessaires lors de la prochaine étape."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Pour obtenir des informations plus détaillées sur votre intégration WooCommerce, suivez le"
									},
									{
										"link": "https://docs.woocommerce.com/document/klarna-payments/",
										"text": "guide d'intégration étendu."
									}
								]
							]
						},
						{
							"title": "Installer et activer le plugin de la méthode de paiement Klarna",
							"step_instructions": [
								[
									{
										"text": "Installer le"
									},
									{
										"link": "https://woocommerce.com/products/klarna-payments/",
										"text": "Plugin de la méthode de paiement Klarna pour WooCommerce."
									}
								],
								[
									{
										"text": "Dans votre compte WooCommerce, rendez-vous sur"
									},
									{
										"bold": "Réglages → Paiements → Méthode de paiement Klarna."
									}
								],
								[
									{
										"text": "Activez la méthode de paiement Klarna en cochant la case Activer la méthode de paiement Klarna."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Pour de plus amples informations sur votre intégration de WooCommerce, suivez le"
									},
									{
										"link": "https://docs.woocommerce.com/document/klarna-payments/",
										"text": "guide d'intégration complet."
									}
								]
							]
						},
						{
							"title": "Configurez les paramètres de votre pays",
							"step_instructions": [
								[
									{
										"text": "Veuillez remplir les paramètres du Pays. Chaque pays Klarna dispose de ses propres paramètres spécifiques. En ajoutant des identifiants de commerçant à un pays spécifique, vous activez également la méthode de paiement Klarna pour le pays en question."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Pour de plus amples informations sur votre intégration de WooCommerce, suivez le"
									},
									{
										"link": "https://docs.woocommerce.com/document/klarna-payments/",
										"text": "guide d'intégration complet."
									}
								]
							]
						},
						{
							"title": "Saisir vos identifiants d’API Klarna",
							"step_instructions": [
								[
									{
										"text": "Entrez vos identifiants d'API Klarna dans les champs « Nom d'utilisateur de l'API Klarna » et « Mot de passe de l'API Klarna »."
									}
								],
								[
									{
										"text": "Enregistrez vos paramètres."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Pour de plus amples informations sur votre intégration de WooCommerce, suivez le"
									},
									{
										"link": "https://docs.woocommerce.com/document/klarna-payments/",
										"text": "guide d'intégration complet."
									}
								]
							]
						},
						{
							"title": "Effectuer un test d'achat",
							"step_instructions": [
								[
									{
										"text": "Afin de vérifier que l'intégration a été correctement configurée, veuillez effectuer un test d'achat sur votre boutique."
									}
								],
								[
									{
										"text": "Une fois la commande effectuée, rendez-vous sur l'onglet"
									},
									{
										"link": "/orders/#realm=merchants",
										"text": "Commandes sur le portail des marchands,"
									},
									{
										"text": "localisez votre commande et annulez-la, afin d'éviter de devoir la payer vous-même."
									}
								],
								[
									{
										"text": "Une fois l'intégration réussie, la bannière en tête de cette page passera au vert et vous verrez apparaître les mots « Intégration terminée »."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Pour de plus amples informations sur votre intégration de WooCommerce, suivez le"
									},
									{
										"link": "https://docs.woocommerce.com/document/klarna-payments/",
										"text": "guide d'intégration complet."
									}
								]
							]
						}
					],
					"magento_kco": [
						{
							"title": "Configurer vos paramètres pour activer la Page de paiement Klarna.",
							"step_instructions": [
								[
									{
										"text": "Tout d’abord, assurez-vous d’avoir installé le module Klarna Checkout pour Magento. Si vous n’avez pas encore le module, rendez-vous sur"
									},
									{
										"link": "https://marketplace.magento.com/klarna-m2-checkout.html",
										"text": "cette page"
									},
									{
										"text": "pour l’obtenir."
									}
								],
								[
									{
										"text": "Une fois que vous disposez de vos identifiants d’API Klarna, ouvrez le panneau Magento. Rendez-vous dans « Boutiques » → « Configuration » → « Ventes » → « Modes de paiement » → « Klarna » → « API Klarna »."
									}
								],
								[
									{
										"text": "Développez la section « API Klarna » et saisissez votre version d’API, votre nom d'utilisateur de l'API Klarna et votre mot de passe de l'API Klarna. Assurez-vous de désactiver le mode de test si vous êtes prêt à mettre votre site en ligne."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Pour plus d’informations sur votre intégration Magento, consultez le"
									},
									{
										"link": "https://marketplace.magento.com/media/catalog/product/klarna-m2-checkout-6-2-0-ce/user_guides.pdf",
										"text": "guide complet."
									}
								]
							]
						},
						{
							"title": "Dernières étapes",
							"step_instructions": [
								[
									{
										"text": "Lorsque vos paramètres sont configurés, vous devez vérifier que la Page de paiement Klarna est définie comme activée dans vos options de paiement."
									}
								],
								[
									{
										"text": "Rendez-vous dans « Boutiques » → « Configuration » → « Ventes » → « Paiement » → « Options de la Page de paiement Klarna » dans le panneau Magento."
									}
								],
								[
									{
										"text": "La Page de paiement Klarna doit être activée par défaut. Si ce n’est pas le cas, sélectionnez"
									},
									{
										"bold": "Activer"
									},
									{
										"text": "dans « Activer la Page de paiement Klarna »."
									}
								]
							]
						}
					],
					"magento_kp": [
						{
							"title": "Générez et sauvegardez vos identifiants de l'API Klarna",
							"step_instructions": [
								[
									{
										"text": "Générez de nouveaux identifiants de l'API et téléchargez-les sur votre ordinateur. Ouvrez le fichier et laissez-le ouvert : ces identifiants seront nécessaires lors de la prochaine étape."
									}
								]
							]
						},
						{
							"title": "Installer et activer le module de paiement Klarna",
							"step_instructions": [
								[
									{
										"text": "Consultez le"
									},
									{
										"link": "https://docs.magento.com/user-guide/payment/klarna-setup.html#set-up-klarna-payments-in-magento",
										"text": "Guide d'utilisateur Magento à la section Configurer Klarna"
									},
									{
										"text": "et suivez-y les instructions pour installer et configurer le module sur votre compte Magento."
									}
								]
							]
						},
						{
							"title": "Effectuer un test d'achat",
							"step_instructions": [
								[
									{
										"text": "Afin de vérifier que l'intégration a été correctement configurée, veuillez effectuer un test d'achat sur votre boutique."
									}
								],
								[
									{
										"text": "Une fois la commande effectuée, rendez-vous sur l'onglet"
									},
									{
										"link": "/orders/#realm=merchants",
										"text": "Commandes sur le portail des marchands,"
									},
									{
										"text": "localisez votre commande et annulez-la, afin d'éviter de devoir la payer vous-même."
									}
								],
								[
									{
										"text": "Une fois l'intégration réussie, la bannière en tête de cette page passera au vert et vous verrez apparaître les mots « Intégration terminée »."
									}
								]
							]
						}
					],
					"shopware_kp": [
						{
							"title": "Activer le plugin de la méthode de paiement Klarna pour Shopware",
							"step_instructions": [
								[
									{
										"text": "Tout d’abord, assurez-vous d’avoir installé le plugin de la méthode de paiement Klarna pour Shopware. Si ce n’est pas le cas, rendez-vous sur"
									},
									{
										"link": "https://store.shopware.com/en/besti13231874259f/klarna-payments.html",
										"text": "cette page"
									},
									{
										"text": "pour l’obtenir."
									}
								],
								[
									{
										"text": "Par la suite, vous devez importer le plugin de la méthode de paiement Klarna dans Shopware en cliquant sur"
									},
									{
										"bold": "Configuration → Gestionnaire de plugins → Installé → Télécharger un plugin."
									},
									{
										"text": "Cliquez sur"
									},
									{
										"bold": "Sélectionner"
									},
									{
										"text": "et sélectionnez le fichier ZIP du plugin de la méthode de paiement Klarna. Confirmez en cliquant sur"
									},
									{
										"bold": "Télécharger un plugin."
									},
									{
										"text": "Le plugin est maintenant accessible dans le gestionnaire de plugins."
									}
								],
								[
									{
										"text": "Installez le plugin en cliquant sur le"
									},
									{
										"bold": "« + » vert"
									},
									{
										"text": "."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Pour plus d’informations sur votre intégration Shopware, consultez notre"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "guide complet (en allemand)."
									}
								]
							]
						},
						{
							"title": "Configurer le plugin de la méthode de paiement Klarna pour Shopware",
							"step_instructions": [
								[
									{
										"text": "Accédez aux paramètres du plugin en cliquant sur"
									},
									{
										"bold": "Configuration → Réglages de base → Rechercher la méthode de paiement Klarna"
									}
								],
								[
									{
										"text": "Saisissez vos identifiants d’API Klarna dans les champs"
									},
									{
										"bold": "Nom d'utilisateur de l'API Klarna"
									},
									{
										"text": "et"
									},
									{
										"bold": "Mot de passe de l'API Klarna"
									},
									{
										"text": "et enregistrez vos modifications."
									}
								],
								[
									{
										"text": "Assurez-vous d’utiliser le mode en direct ainsi que vos identifiants d’API Klarna."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Pour plus d’informations sur votre intégration Shopware, consultez notre"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "guide complet (en allemand)."
									}
								]
							]
						},
						{
							"title": "Configurer la ou les passerelles de la méthode de paiement Klarna",
							"step_instructions": [
								[
									{
										"text": "Avant d’utiliser Klarna, vous devez activer votre ou vos passerelles de la méthode de paiement Klarna. Vous les trouverez en cliquant sur"
									},
									{
										"bold": "Configuration → Modes de paiement"
									}
								],
								[
									{
										"text": "Par défaut, toutes les passerelles de la méthode de paiement Klarna sont installées. Ouvrez les passerelles de la méthode de paiement Klarna auxquelles vous avez souscrit et activez-les en cochant"
									},
									{
										"bold": "Activé"
									},
									{
										"text": ". Enregistrez vos modifications."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Pour plus d’informations sur votre intégration Shopware, consultez notre"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "guide complet (en allemand)."
									}
								]
							]
						},
						{
							"title": "Configurer vos frais d’expédition",
							"step_instructions": [
								[
									{
										"text": "Configurez les frais de livraison sur votre ou vos passerelles de la méthode de paiement Klarna en cliquant sur"
									},
									{
										"bold": "Configuration → Frais d’expédition"
									}
								],
								[
									{
										"text": "Sélectionnez les modes d’expédition qui doivent être disponibles pour Klarna en cliquant sur"
									},
									{
										"bold": "l’icône en forme de crayon."
									}
								],
								[
									{
										"text": "Sélectionnez l’onglet de choix du mode de paiement et passez votre ou vos passerelles de la méthode de paiement Klarna de"
									},
									{
										"bold": "Disponible"
									},
									{
										"text": "à"
									},
									{
										"bold": "Sélectionné."
									},
									{
										"text": "Enregistrez vos paramètres"
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Pour plus d’informations sur votre intégration Shopware, consultez notre"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "guide complet (en allemand)."
									}
								]
							]
						},
						{
							"title": "Activer votre plugin de la méthode de paiement Klarna",
							"step_instructions": [
								[
									{
										"text": "Vous devez ensuite activer le plugin de la méthode de paiement Klarna. Cliquez sur"
									},
									{
										"bold": "Configuration → Gestionnaire de plugins → Installé"
									},
									{
										"text": "pour accéder au gestionnaire de plugins."
									}
								],
								[
									{
										"text": "Activez le plugin en cliquant sur l’icône"
									},
									{
										"bold": "« X » rouge"
									},
									{
										"text": "."
									}
								],
								[
									{
										"text": "Vous serez invité à vider le cache. Cliquez sur"
									},
									{
										"bold": "Oui."
									},
									{
										"text": "Veuillez noter que vous devez vider le cache et compiler les thèmes chaque fois que vous modifiez un élément dans les paramètres du module ou les modes de paiement de Klarna."
									}
								],
								[
									{
										"text": "Pour finaliser l’activation du plugin de la méthode de paiement Klarna, le thème de la boutique doit être recompilé. Cliquez sur"
									},
									{
										"bold": "Compiler les thèmes"
									},
									{
										"text": "lorsque cela vous est demandé."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Pour plus d’informations sur votre intégration Shopware, consultez notre"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "guide complet (en allemand)."
									}
								]
							]
						},
						{
							"title": "Dernières étapes",
							"step_instructions": [
								[
									{
										"text": "Pour éviter toute erreur d’arrondi, assurez-vous que l’extension PHP bcmath est installée sur votre serveur. Retrouvez le guide ici"
									},
									{
										"link": "http://php.net/manual/en/book.bc.php",
										"text": "ici"
									},
									{
										"text": "."
									}
								],
								[
									{
										"text": "Redémarrez ensuite votre interface back-end pour vous assurer que toutes les configurations sont disponibles dans votre boutique."
									}
								],
								[
									{
										"text": "Assurez-vous que votre/vos produit(s) Klarna Payment sont affichés comme prévu en ajoutant un article à votre panier, en choisissant Klarna comme mode de paiement et en accédant au paiement (ne passez pas réellement la commande)."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Pour plus d’informations sur votre intégration Shopware, consultez notre"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "guide complet (en allemand)."
									}
								]
							]
						}
					],
					"shopware_kco": [
						{
							"title": "Activer le plugin Klarna Checkout (Page de paiement Klarna) pour Shopware",
							"step_instructions": [
								[
									{
										"text": "Tout d’abord, assurez-vous d’avoir installé le plugin Klarna Checkout pour Shopware (versions 5.2.17 et ultérieures). Si ce n’est pas le cas, rendez-vous sur"
									},
									{
										"link": "https://store.shopware.com/en/besti56121054232f/klarna-checkout.html",
										"text": "cette page"
									},
									{
										"text": "pour l’obtenir."
									}
								],
								[
									{
										"text": "Vous devez ensuite importer le plugin Klarna Checkout dans Shopware en cliquant sur"
									},
									{
										"bold": "Configuration → Gestionnaire de plugins → Installé → Télécharger un plugin."
									},
									{
										"text": "Cliquez sur"
									},
									{
										"bold": "Sélectionner"
									},
									{
										"text": "et sélectionnez le fichier ZIP du plugin Klarna Checkout. Confirmez en cliquant sur"
									},
									{
										"bold": "Télécharger un plugin."
									},
									{
										"text": "Le plugin est maintenant accessible dans le gestionnaire de plugins."
									}
								],
								[
									{
										"text": "Installez le plugin en cliquant sur le"
									},
									{
										"bold": "« + » vert"
									},
									{
										"text": "."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Pour plus d’informations sur votre intégration Shopware, consultez notre"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "guide complet (en allemand)."
									}
								]
							]
						},
						{
							"title": "Configurer le plugin Klarna Checkout (Page de paiement Klarna) pour Shopware",
							"step_instructions": [
								[
									{
										"text": "Accédez aux paramètres du plugin en cliquant sur"
									},
									{
										"bold": "Configuration → Paramètres de base → Rechercher Klarna Checkout"
									}
								],
								[
									{
										"text": "Saisissez vos identifiants d’API Klarna dans les champs"
									},
									{
										"bold": "Nom d'utilisateur de l'API Klarna"
									},
									{
										"text": "et"
									},
									{
										"bold": "Mot de passe de l'API Klarna"
									},
									{
										"text": "et enregistrez vos modifications."
									}
								],
								[
									{
										"text": "Assurez-vous d’utiliser le mode en direct ainsi que vos identifiants d’API Klarna."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Pour plus d’informations sur votre intégration Shopware, consultez notre"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "guide complet (en allemand)."
									}
								]
							]
						},
						{
							"title": "Activer la passerelle vers la Page de paiement Klarna",
							"step_instructions": [
								[
									{
										"text": "Avant d’utiliser Klarna, vous devez activer votre/vos passerelles de paiement avec Klarna. Vous les trouverez en cliquant sur"
									},
									{
										"bold": "Configuration → Modes de paiement"
									}
								],
								[
									{
										"text": "Ouvrez la passerelle de paiement Klarna et activez-la en cochant la case"
									},
									{
										"bold": "Activé"
									},
									{
										"text": ". Enregistrez vos modifications."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Pour plus d’informations sur votre intégration Shopware, consultez notre"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "guide complet (en allemand)."
									}
								]
							]
						},
						{
							"title": "Configurer vos frais d’expédition",
							"step_instructions": [
								[
									{
										"text": "Configurez vos frais d’expédition pour votre Page de paiement Klarna en cliquant sur"
									},
									{
										"bold": "Configuration → Frais d’expédition"
									}
								],
								[
									{
										"text": "Sélectionnez les modes d’expédition qui doivent être disponibles pour Klarna en cliquant sur"
									},
									{
										"bold": "l’icône en forme de crayon."
									}
								],
								[
									{
										"text": "Sélectionnez l’onglet de choix du mode de paiement et passez votre Page de paiement Klarna du statut"
									},
									{
										"bold": "Disponible"
									},
									{
										"text": "à"
									},
									{
										"bold": "Sélectionné."
									},
									{
										"text": "Enregistrez vos paramètres"
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Pour plus d’informations sur votre intégration Shopware, consultez notre"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "guide complet (en allemand)."
									}
								]
							]
						},
						{
							"title": "Activer votre plugin Klarna Checkout (Page de paiement Klarna)",
							"step_instructions": [
								[
									{
										"text": "Vous devez ensuite activer le plugin Klarna Checkout. Cliquez sur"
									},
									{
										"bold": "Configuration → Gestionnaire de plugins → Installé"
									},
									{
										"text": "pour accéder au gestionnaire de plugins."
									}
								],
								[
									{
										"text": "Activez le plugin en cliquant sur l’icône"
									},
									{
										"bold": "« X » rouge"
									},
									{
										"text": "."
									}
								],
								[
									{
										"text": "Vous serez invité à vider le cache. Cliquez sur"
									},
									{
										"bold": "Oui."
									}
								],
								[
									{
										"text": "Pour finaliser l’activation du plugin Klarna Checkout, le thème de la boutique doit être recompilé. Cliquez sur"
									},
									{
										"bold": "Compiler les thèmes"
									},
									{
										"text": "lorsque cela vous est demandé."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Pour plus d’informations sur votre intégration Shopware, consultez notre"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "guide complet (en allemand)."
									}
								]
							]
						},
						{
							"title": "Dernières étapes",
							"step_instructions": [
								[
									{
										"text": "Pour éviter toute erreur d’arrondi, assurez-vous que l’extension PHP bcmath est installée sur votre serveur. Retrouvez le guide ici"
									},
									{
										"link": "http://php.net/manual/en/book.bc.php",
										"text": "ici"
									},
									{
										"text": "."
									}
								],
								[
									{
										"text": "Assurez-vous que la « Ligne d’adresse supplémentaire 1 » et la « Ligne d’adresse supplémentaire 2 » ne sont pas marquées comme requises."
									}
								],
								[
									{
										"text": "Redémarrez ensuite votre interface back-end pour vous assurer que toutes les configurations sont disponibles dans votre boutique."
									}
								],
								[
									{
										"text": "Assurez-vous que votre Page de paiement Klarna s’affiche comme prévu en ajoutant un article à votre panier, en choisissant Klarna comme mode de paiement et en accédant au paiement (ne passez pas réellement la commande)."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Pour plus d’informations sur votre intégration Shopware, consultez notre"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "guide complet (en allemand)."
									}
								]
							]
						}
					],
					"shopware_6_kp": [
						{
							"title": "Activer le plugin de la méthode de paiement Klarna pour Shopware",
							"step_instructions": [
								[
									{
										"text": "Pour pouvoir installer le plugin Klarna, vous avez besoin du système d’exécution Shopware 6. Les instructions d’installation sont disponibles"
									},
									{
										"link": "https://docs.shopware.com/en/shopware-6-en/first-steps/installing-shopware-6",
										"text": "ici."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Pour plus d’informations sur votre intégration Shopware, consultez notre"
									},
									{
										"link": "https://x.klarnacdn.net/mepo/onboarding/integration-guides/shopware_6/de.pdf",
										"text": "guide complet (en allemand)."
									}
								]
							]
						},
						{
							"title": "Installation et Configuration. Il existe plusieurs façons d’installer le plugin Klarna.",
							"step_instructions": [
								[
									{
										"text": "Assistant de première exécution."
									}
								],
								[
									{
										"text": "Installation via la page Administration."
									}
								],
								[
									{
										"text": "Installation via un Téléchargement direct depuis la boutique de communauté."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Pour plus d’informations sur votre intégration Shopware, consultez notre"
									},
									{
										"link": "https://x.klarnacdn.net/mepo/onboarding/integration-guides/shopware_6/de.pdf",
										"text": "guide complet (en allemand)."
									}
								]
							]
						},
						{
							"title": "Activer le plugin de la méthode de paiement Klarna pour Shopware",
							"step_instructions": [
								[
									{
										"text": "Rendez-vous sur l’aperçu de vos plugins sur la page d’administration de Shopware. Vous pouvez y accéder via"
									},
									{
										"bold": "Paramètres > Système > Plugins."
									}
								],
								[
									{
										"text": "Sélectionner"
									},
									{
										"bold": "Installez"
									},
									{
										"text": "depuis le menu contextuel (\"...\"). Vous recevrez un message de confirmation de Shopware vous indiquant que le plugin a été installé avec succès."
									}
								],
								[
									{
										"text": "Pour des raisons de sécurité, le plugin est maintenant installé mais pas activé. Vous devez d’abord l’optimiser avec vos données d’accès et vos paramètres individuels."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Pour plus d’informations sur votre intégration Shopware, consultez notre"
									},
									{
										"link": "https://x.klarnacdn.net/mepo/onboarding/integration-guides/shopware_6/de.pdf",
										"text": "guide complet (en allemand)."
									}
								]
							]
						},
						{
							"title": "Assistant",
							"step_instructions": [
								[
									{
										"text": "Une fois que le plugin a été activé, rendez-vous dans le"
									},
									{
										"bold": "menu contextuel (\"...\") > assistant.",
										"text": "Vous serez ensuite redirigé vers le programme."
									}
								],
								[
									{
										"text": "Le programme vous guidera tout au long du processus de configuration. Il vous permet de vous inscrire aux services Klarna si vous ne disposez pas encore d’un compte revendeur."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Pour plus d’informations sur votre intégration Shopware, consultez notre"
									},
									{
										"link": "https://x.klarnacdn.net/mepo/onboarding/integration-guides/shopware_6/de.pdf",
										"text": "guide complet (en allemand)."
									}
								]
							]
						},
						{
							"title": "Configuration du plugin",
							"step_instructions": [
								[
									{
										"bold": "Canaux de vente."
									},
									{
										"text": "Vous déterminez ici si les paramètres suivants pour « tous les canaux de vente » doivent être utilisés ou appliqués uniquement à certains canaux de vente individuels."
									}
								],
								[
									{
										"bold": "Paramètres d’API."
									},
									{
										"text": "Nom d’utilisateur et mot de passe dans l’API : Saisissez vos données d’accès à l’API ici pour utiliser le mode direct et test dans les sections appropriées."
									}
								],
								[
									{
										"text": "Vous pouvez tester vos identifiants d’API Klarna en cliquant sur"
									},
									{
										"bold": "Tester les identifiants API",
										"text": "qui se trouve dans l’en-tête. Vous recevrez alors un message de réussite ou une notification vous indiquant quelles données semblent incorrectes."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Pour plus d’informations sur votre intégration Shopware, consultez notre"
									},
									{
										"link": "https://x.klarnacdn.net/mepo/onboarding/integration-guides/shopware_6/de.pdf",
										"text": "guide complet (en allemand)."
									}
								]
							]
						},
						{
							"title": "Activer/désactiver le plugin",
							"step_instructions": [
								[
									{
										"text": "Si vous souhaitez activer/désactiver le plugin de la méthode de paiement Klarna ou simplement voir le statut d’activation actuel, rendez-vous sur la page Admin de Shopware et sélectionnez"
									},
									{
										"bold": "Paramètres > Système > Plugins."
									}
								],
								[
									{
										"text": "Vous trouverez ici le statut actuel dans le tableau sous"
									},
									{
										"bold": "\"Mes plugins\"."
									}
								],
								[
									{
										"text": "Le statut peut être modifié en cliquant sur le curseur."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Pour plus d’informations sur votre intégration Shopware, consultez notre"
									},
									{
										"link": "https://x.klarnacdn.net/mepo/onboarding/integration-guides/shopware_6/de.pdf",
										"text": "guide complet (en allemand)."
									}
								]
							]
						},
						{
							"title": "Dernières étapes",
							"step_instructions": [
								[
									{
										"text": "Pour éviter toute erreur d’arrondi, assurez-vous d’avoir la version PHP >= 7,2."
									}
								],
								[
									{
										"text": "Installation complète de Shopware"
									},
									{
										"bold": "(Storefront + Administration, intitulé présent)."
									}
								],
								[
									{
										"text": "Le système doit être accessible depuis l’extérieur pour mettre à jour le statut de paiement."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Pour plus d’informations sur votre intégration Shopware, consultez notre"
									},
									{
										"link": "https://x.klarnacdn.net/mepo/onboarding/integration-guides/shopware_6/de.pdf",
										"text": "guide complet (en allemand)."
									}
								]
							]
						}
					],
					"3dcart_kp": [
						{
							"title": "Générez et sauvegardez vos identifiants de l'API Klarna",
							"step_instructions": [
								[
									{
										"text": "Générez de nouveaux identifiants de l'API et téléchargez-les sur votre ordinateur. Ouvrez le fichier et laissez-le ouvert : ces identifiants seront nécessaires lors de la prochaine étape."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Pour de plus amples informations sur l'intégration de votre 3dcart, suivez le"
									},
									{
										"link": "https://support.3dcart.com/Knowledgebase/Article/View/886/56/how-do-i-set-up-klarna",
										"text": "guide d'intégration complet."
									}
								]
							]
						},
						{
							"title": "Activez la méthode de paiement Klarna dans le gestionnaire de boutiques en ligne",
							"step_instructions": [
								[
									{
										"text": "Connectez-vous à votre"
									},
									{
										"link": "https://www.shift4shop.com/login-page.html",
										"text": "gestionnaire de boutique en ligne 3dcart,"
									},
									{
										"text": "et rendez-vous sur"
									},
									{
										"bold": "Paramètres → Paiement."
									}
								],
								[
									{
										"text": "Sur la page Paiement, cliquez sur le"
									},
									{
										"bold": "Sélectionner les modes de paiement"
									},
									{
										"text": "."
									}
								],
								[
									{
										"text": "Vous trouverez une liste de modules pré-installés. Localisez le module Klarna et activez-le à l'aide de l'interrupteur à bascule."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Pour de plus amples informations sur l'intégration de votre 3dcart, suivez le"
									},
									{
										"link": "https://support.3dcart.com/Knowledgebase/Article/View/886/56/how-do-i-set-up-klarna",
										"text": "guide d'intégration complet."
									}
								]
							]
						},
						{
							"title": "Saisir vos identifiants d’API Klarna",
							"step_instructions": [
								[
									{
										"text": "Une fois votre module activé, entrez votre nom d'utilisateur de l'API Klarna (UID) dans le champ prévu à cet effet. Vous trouverez ce nom d'utilisateur dans le fichier d'identifiants que vous avez téléchargé plus tôt."
									}
								],
								[
									{
										"text": "Ensuite, cliquez sur le lien"
									},
									{
										"bold": "Changement de mot de passe"
									},
									{
										"text": "et entrer votre mot de passe de l'API Klarna dans le champ prévu à cet effet."
									}
								],
								[
									{
										"text": "Sous"
									},
									{
										"bold": "Langue du pays"
									},
									{
										"text": "sélectionnez la langue du pays utilisée pour les options de paiement Klarna sur la boutique."
									}
								],
								[
									{
										"text": "Au-dessus du champ « Nom d'utilisateur » se trouve une case nommée"
									},
									{
										"bold": "« Mode Test »."
									},
									{
										"text": "Cochez cette option pour activer le mode test, vous permettant de passer des commandes sans entraîner le moindre le frais et sans devoir effectuer d'action de paiement lors du test du module."
									}
								],
								[
									{
										"text": "Une fois que vous avez configuré vos paramètres, cliquez sur « Sauvegarder » en haut à droite."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Pour de plus amples informations sur l'intégration de votre 3dcart, suivez le"
									},
									{
										"link": "https://support.3dcart.com/Knowledgebase/Article/View/886/56/how-do-i-set-up-klarna",
										"text": "guide d'intégration complet."
									}
								]
							]
						},
						{
							"title": "Effectuer un test d'achat",
							"step_instructions": [
								[
									{
										"text": "Afin de vérifier que l'intégration a été correctement configurée, veuillez effectuer un test d'achat sur votre boutique."
									}
								],
								[
									{
										"text": "Une fois la commande effectuée, rendez-vous sur l'onglet"
									},
									{
										"link": "/orders/#realm=merchants",
										"text": "Commandes sur le portail des marchands,"
									},
									{
										"text": "localisez votre commande et annulez-la, afin d'éviter de devoir la payer vous-même."
									}
								],
								[
									{
										"text": "Une fois l'intégration réussie, la bannière en tête de cette page passera au vert et vous verrez apparaître les mots « Intégration terminée »."
									}
								],
								[
									{
										"text": "Si vous avez activé le « Mode Test » au cours de l'étape précédente, retournez, décochez l'option et sauvegardez avant de mettre votre boutique en ligne, afin que vos clients puissent réaliser de vraies commandes."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Pour de plus amples informations sur l'intégration de votre 3dcart, suivez le"
									},
									{
										"link": "https://support.3dcart.com/Knowledgebase/Article/View/886/56/how-do-i-set-up-klarna",
										"text": "guide d'intégration complet."
									}
								]
							]
						}
					],
					"bigcommerce_kp": [
						{
							"title": "Générez et sauvegardez vos identifiants de l'API Klarna",
							"step_instructions": [
								[
									{
										"text": "Générez de nouveaux identifiants de l'API et téléchargez-les sur votre ordinateur. Ouvrez le fichier et laissez-le ouvert : ces identifiants seront nécessaires lors de la prochaine étape."
									}
								]
							],
							"alternate": [
								{
									"text": "Pour de plus amples informations sur l'intégration de votre BigCommerce, suivez le"
								},
								{
									"link": "https://support.bigcommerce.com/s/article/Connecting-with-Klarna-Payments",
									"text": "guide d'intégration complet."
								}
							]
						},
						{
							"title": "Configurez vos paramètres BigCommerce",
							"step_instructions": [
								[
									{
										"text": "Dans BigCommerce, accédez à"
									},
									{
										"link": "http://login.bigcommerce.com/deep-links/settings/payment",
										"text": "Configuration de la boutique › Paiements,"
									},
									{
										"text": "et développez la section Modes de paiement en ligne. Ensuite, cliquez sur"
									},
									{
										"bold": "Configuration"
									},
									{
										"text": "à côté de la méthode de paiement Klarna."
									}
								],
								[
									{
										"text": "Vous serez redirigé vers l’onglet de configuration de la méthode de paiement Klarna. Saisissez les identifiants API que vous avez enregistrés dans la section précédente, puis copiez le nom d’utilisateur et le mot de passe dans leurs champs respectifs."
									}
								],
								[
									{
										"text": "Une fois cela fait, sauvegardez vos changements."
									}
								]
							],
							"alternate": [
								{
									"text": "Pour de plus amples informations sur l'intégration de votre BigCommerce, suivez le"
								},
								{
									"link": "https://support.bigcommerce.com/s/article/Connecting-with-Klarna-Payments",
									"text": "guide d'intégration complet."
								}
							]
						},
						{
							"title": "Effectuer un test d'achat",
							"step_instructions": [
								[
									{
										"text": "Afin de vérifier que l'intégration a été correctement configurée, veuillez effectuer un test d'achat sur votre boutique."
									}
								],
								[
									{
										"text": "Une fois la commande effectuée, rendez-vous sur l'onglet"
									},
									{
										"link": "/orders/#realm=merchants",
										"text": "Commandes sur le portail des marchands,"
									},
									{
										"text": "localisez votre commande et annulez-la, afin d'éviter de devoir la payer vous-même."
									}
								],
								[
									{
										"text": "Une fois l'intégration réussie, la bannière en tête de cette page passera au vert et vous verrez apparaître les mots « Intégration terminée »."
									}
								]
							],
							"alternate": [
								{
									"text": "Pour de plus amples informations sur l'intégration de votre BigCommerce, suivez le"
								},
								{
									"link": "https://support.bigcommerce.com/s/article/Connecting-with-Klarna-Payments",
									"text": "guide d'intégration complet."
								}
							]
						}
					],
					"prestashop_kco": [
						{
							"title": "Activer le module Klarna Checkout (Page de paiement Klarna)",
							"step_instructions": [
								[
									{
										"text": "Tout d’abord, assurez-vous d’avoir installé le module Klarna officiel pour Prestashop. Si ce n’est pas le cas, rendez-vous sur"
									},
									{
										"link": "https://addons.prestashop.com/en/express-checkout-process/90132-klarna-checkout.html?no_cache=1",
										"text": "cette page"
									},
									{
										"text": "pour l’obtenir."
									}
								],
								[
									{
										"text": "Malheureusement, à partir du 1er janvier 2023, ces plug-ins développés et détenus par Prestasworks A.B (SI) ne seront plus distribués gratuitement. Si vous êtes intéressés par Klarna, vous pouvez acheter le plug-in ou attendre que les plug-ins appartenant à Klarna soient publiés au deuxième trimestre 2023."
									}
								],
								[
									{
										"text": "Connectez-vous à votre page d’admin Prestashop et rendez-vous sur"
									},
									{
										"bold": "Modules → Modules."
									}
								],
								[
									{
										"text": "Saisissez « Klarna » dans la barre de recherche pour localiser le module Klarna par Prestaworks AB. Cliquez sur"
									},
									{
										"bold": "Configurer."
									}
								]
							]
						},
						{
							"title": "Configurer les paramètres de votre module Klarna",
							"step_instructions": [
								[
									{
										"text": "Vous vous trouvez maintenant sur la page des paramètres du module. En haut des « Paramètres généraux », le bouton"
									},
									{
										"bold": "Activer KCO dans cette boutique"
									},
									{
										"text": "(Klarna Checkout V3) s’affiche. Choisissez"
									},
									{
										"bold": "Oui."
									}
								],
								[
									{
										"text": "Cliquez sur"
									},
									{
										"bold": "Enregistrer"
									},
									{
										"text": "pour enregistrer vos paramètres."
									}
								],
								[
									{
										"text": "Cliquez ensuite sur votre pays de vente dans le menu de gauche, puis saisissez vos identifiants d’API Klarna dans"
									},
									{
										"bold": "Nom d'utilisateur de l'API Klarna"
									},
									{
										"text": "et"
									},
									{
										"bold": "Mot de passe de l'API Klarna."
									}
								],
								[
									{
										"text": "Cliquez sur"
									},
									{
										"bold": "Enregistrer."
									}
								]
							]
						},
						{
							"title": "Dernières étapes",
							"step_instructions": [
								[
									{
										"text": "Vérifiez que le mode de test est désactivé si vous êtes prêt à mettre votre site en ligne. Pour ce faire, rendez-vous dans l’onglet"
									},
									{
										"bold": "Paramètres communs."
									},
									{
										"text": "Le bouton"
									},
									{
										"bold": "Essai"
									},
									{
										"text": "doit être paramétré sur"
									},
									{
										"bold": "Non."
									}
								],
								[
									{
										"text": "Pendant que vous vous trouvez dans les"
									},
									{
										"bold": "Paramètres communs,"
									},
									{
										"text": "veillez à configurer vos paramètres de gestion des commandes, d’envois de factures, etc."
									}
								],
								[
									{
										"text": "Assurez-vous que la Page de paiement Klarna s’affiche comme prévu en ajoutant un article à votre panier et en accédant au paiement (ne passez pas réellement la commande)."
									}
								]
							]
						}
					],
					"prestashop_kp": [
						{
							"title": "Générez et sauvegardez vos identifiants de l'API Klarna",
							"step_instructions": [
								[
									{
										"text": "Générez de nouveaux identifiants de l'API et téléchargez-les sur votre ordinateur. Ouvrez le fichier et laissez-le ouvert : ces identifiants seront nécessaires lors de la prochaine étape."
									}
								]
							]
						},
						{
							"title": "Installer et activer le module de paiement Klarna",
							"step_instructions": [
								[
									{
										"text": "Ouvrez la"
									},
									{
										"link": "https://addons.prestashop.com/en/payment-card-wallet/90140-klarna-payments.html?no_cache=1",
										"text": "Page d’instructions de la méthode de paiement Klarna pour Prestashop"
									},
									{
										"text": "et suivez-y les instructions afin d'installer et de configurer le module sur votre compte Prestashop."
									}
								]
							]
						},
						{
							"title": "Effectuer un test d'achat",
							"step_instructions": [
								[
									{
										"text": "Afin de vérifier que l'intégration a été correctement configurée, veuillez effectuer un test d'achat sur votre boutique."
									}
								],
								[
									{
										"text": "Une fois la commande effectuée, rendez-vous sur l'onglet"
									},
									{
										"link": "/orders/#realm=merchants",
										"text": "Commandes sur le portail des marchands,"
									},
									{
										"text": "localisez votre commande et annulez-la, afin d'éviter de devoir la payer vous-même."
									}
								],
								[
									{
										"text": "Une fois l'intégration réussie, la bannière en tête de cette page passera au vert et vous verrez apparaître les mots « Intégration terminée »."
									}
								]
							]
						}
					],
					"jumpseller": [
						{
							"title": "Générer les identifiants d’API Klarna.",
							"step_instructions": [
								[
									{
										"text": "Ces identifiants vous seront nécessaires pour intégrer Klarna à votre boutique."
									}
								]
							]
						},
						{
							"title": "Ajouter Klarna commen une méthode de paiement.",
							"step_instructions": [
								[
									{
										"text": "Dans le panneau d'administration de Jumpseller, accédez à Paramètres > Paiements, trouvez Klarna dans la liste de cases à cocher et cliquez sur « Ajouter un mode »."
									}
								]
							]
						},
						{
							"title": "Configurez votre nouveeau mode de paiement.",
							"step_instructions": [
								[
									{
										"text": "Dans le panneau de configuration Klarna (Panneau d'administration Jumpseller puis accédez à Paramètres > Paiements > Klarna), (i) ajoutez les indentifiants Klarna API générés à la première étape, (ii) sélectionnez les packages EMD que vous souhaitez/devez partager avec Klarna et (iii) choisissez si vous devez capturer les commandes automatiquement (par défaut, ce paramètre est désactivé)."
									}
								]
							]
						}
					],
					"lightspeed": [
						{
							"title": "Intégrer Lightspeed eCom",
							"step_instructions": [
								[
									{
										"text": "Voir le guide d'intégration sur"
									},
									{
										"link": "https://x.klarnacdn.net/mepo/onboarding/integration-guides/lightspeed/eng.pdf",
										"text": "Anglais"
									},
									{
										"text": "et sur"
									},
									{
										"link": "https://x.klarnacdn.net/mepo/onboarding/integration-guides/lightspeed/nl.pdf",
										"text": "Néerlandais"
									},
									{
										"text": "."
									}
								]
							]
						}
					],
					"shoper": [
						{
							"title": "Intégration de Shoper",
							"step_instructions": [
								[
									{
										"text": "Consultez le guide d’intégration sur"
									},
									{
										"link": "https://www.shoper.pl/help/artykul/klarna-platnosci-odroczone-konfiguracja",
										"text": "le site de Shoper"
									},
									{
										"text": "."
									}
								]
							]
						}
					],
					"timma": [
						{
							"title": "Intégration de Timma",
							"step_instructions": [
								[
									{
										"text": "Consultez le guide d’intégration sur"
									},
									{
										"link": "https://help.timma.fi/sv/articles/4990994-betalning-via-klarna",
										"text": "via le site de Timma"
									},
									{
										"text": "."
									}
								]
							]
						}
					],
					"smartetailing": [
						{
							"title": "Générez et sauvegardez vos identifiants de l'API Klarna",
							"step_instructions": [
								[
									{
										"text": "Générez de nouveaux identifiants de l'API et téléchargez-les sur votre ordinateur. Ouvrez le fichier et laissez-le ouvert : ces identifiants seront nécessaires lors de la prochaine étape."
									}
								]
							]
						},
						{
							"title": "Intégration à SmartEtailing",
							"step_instructions": [
								[
									{
										"text": "Suivez les instructions figurant sur"
									},
									{
										"link": "https://www.smartetailing.com/help/financing-with-klarna",
										"text": "le site Web SmartEtailing."
									}
								]
							]
						}
					],
					"workstand": [
						{
							"title": "Générez et sauvegardez vos identifiants de l'API Klarna",
							"step_instructions": [
								[
									{
										"text": "Générez de nouveaux identifiants de l'API et téléchargez-les sur votre ordinateur. Ouvrez le fichier et laissez-le ouvert : ces identifiants seront nécessaires lors de la prochaine étape."
									}
								]
							]
						},
						{
							"title": "Intégration à Workstand",
							"step_instructions": [
								[
									{
										"text": "Suivez les instructions figurant sur"
									},
									{
										"link": "https://www.workstand.com/help/financing-with-klarna",
										"text": "le site Web Workstand."
									}
								]
							]
						}
					],
					"jtl5_kco": [
						{
							"title": "Lire la documentation de notre plugin",
							"step_instructions": [
								[
									{
										"text": "Rendez-vous sur"
									},
									{
										"link": "https://solution360.atlassian.net/wiki/spaces/S360DOKU/pages/1518829612/Klarna+Zahlungsarten+JTL-Shop+5",
										"text": ", notre page de documentation"
									}
								]
							]
						},
						{
							"title": "Activer le module Klarna Checkout pour JTL-Shop 5",
							"step_instructions": [
								[
									{
										"text": "Assurez-vous d'avoir installé l'extension Klarna officielle. Si ce n'est pas encore le cas,"
									},
									{
										"text": "rendez-vous sur"
									},
									{
										"link": "https://www.jtl-software.de/extension-store/klarna-payments-mehr-als-reine-zahlungsarten-jtl-shop-5",
										"text": "cette page"
									},
									{
										"text": "pour l’obtenir."
									}
								]
							]
						}
					],
					"jtl5_kp": [
						{
							"title": "Lire la documentation de notre plugin",
							"step_instructions": [
								[
									{
										"text": "Rendez-vous sur"
									},
									{
										"link": "https://solution360.atlassian.net/wiki/spaces/S360DOKU/pages/1518829612/Klarna+Zahlungsarten+JTL-Shop+5",
										"text": ", notre page de documentation"
									}
								]
							]
						},
						{
							"title": "Activer le module Klarna Payments pour JTL-Shop 5",
							"step_instructions": [
								[
									{
										"text": "Assurez-vous d'avoir installé l'extension Klarna officielle. Si ce n'est pas encore le cas,"
									},
									{
										"text": "rendez-vous sur"
									},
									{
										"link": "https://www.jtl-software.de/extension-store/klarna-payments-mehr-als-reine-zahlungsarten-jtl-shop-5",
										"text": "cette page"
									},
									{
										"text": "pour l’obtenir."
									}
								]
							]
						}
					],
					"no_instructions": [
						{
							"title": "Voici ce que vous devez faire ensuite",
							"step_instructions": [
								[
									{
										"bold": "Générer les identifiants d’API Klarna."
									},
									{
										"text": "Ces identifiants sont nécessaires pour intégrer Klarna à votre boutique."
									}
								],
								[
									{
										"bold": "Ajoutez les identifiants d’API Klarna dans votre interface back-end pour activer Klarna."
									},
									{
										"text": "Consultez notre"
									},
									{
										"link": "https://developers.klarna.com/",
										"text": "Portail des développeurs"
									},
									{
										"text": "pour plus d’informations."
									}
								]
							]
						}
					]
				},
				"stakeholders": {
					"form": {
						"first_name": {
							"label": "Prénom",
							"error": "Veuillez saisir un prénom"
						},
						"last_name": {
							"label": "Nom de famille",
							"error": "Veuillez saisir un nom"
						},
						"dateOfBirth": {
							"label": {
								"default": "Date de naissance (JJ/MM/AAAA)",
								"without_format": "Date de naissance",
								"US": "Date de naissance (MM/JJ/AAAA)"
							},
							"error": "Veuillez saisir une date valide",
							"error_too_young": "Vous devez avoir au moins 18 ans pour vendre avec Klarna"
						},
						"address": {
							"label": "Adresse de résidence",
							"error": "Veuillez saisir une adresse"
						},
						"city": {
							"label": "Ville",
							"error": "Veuillez saisir une ville"
						},
						"country": {
							"label": "Pays",
							"error": "Veuillez sélectionner un pays"
						},
						"postal_code": {
							"label": {
								"default": "Code postal",
								"US": "Code postal"
							},
							"error": {
								"default": "Veuillez saisir un code postal valide",
								"US": "Veuillez saisir un code postal valide"
							}
						},
						"region": {
							"label": "État/région (facultatif)",
							"label_summary": "État/région"
						},
						"state": {
							"label": "État",
							"error": "Veuillez saisir un État"
						},
						"role_question": {
							"OWNER": "Cette personne est-elle un propriétaire ?",
							"BENEFICIAL_OWNER": "Cette personne contrôle-t-elle plus de 25 % des actions ou droits de vote ?",
							"ULTIMATE_BENEFICIAL_OWNER": "Cette personne détient ou contrôle plus de 25 % des actions ou droits de vote"
						},
						"is_person_pep": [
							{
								"text": "Cette personne est-elle"
							},
							{
								"link": "https://cdn.klarna.com/1.0/shared/content/merchant-portal/products/amu/pep-20180626.html",
								"text": "politiquement exposée (PPE)"
							},
							{
								"text": ","
							},
							{
								"link": "https://cdn.klarna.com/1.0/shared/content/merchant-portal/products/amu/pep-20180626.html",
								"text": "un membre de la famille proche"
							},
							{
								"text": "ou"
							},
							{
								"link": "https://cdn.klarna.com/1.0/shared/content/merchant-portal/products/amu/pep-20180626.html",
								"text": "un(e) collaborateur(trice) connu(e)"
							},
							{
								"text": "d’une telle personne ?"
							}
						],
						"pep_relationship": {
							"label": "Relation",
							"error": "Veuillez sélectionner la relation de cette personne avec une PPE"
						},
						"pep_position": {
							"label": "Position de la personne politiquement exposée (PPE)",
							"error": "Veuillez sélectionner le poste occupé par la PPE"
						},
						"personal_id_question": "Cette personne ne possède pas de numéro d'identification personnel",
						"personal_id": {
							"US": {
								"label": "Numéro de sécurité sociale (4 derniers chiffres)",
								"label_summary": "Numéro de sécurité sociale"
							},
							"US_FULL_SSN": {
								"label": "Numéro de sécurité sociale",
								"label_summary": "Numéro de sécurité sociale"
							},
							"CA": {
								"label": "Numéro de sécurité sociale ou de passeport valide",
								"label_summary": "Numéro de sécurité sociale ou de passeport valide"
							},
							"SE": {
								"label": "Numéro d'identification personnel (PNO)",
								"label_summary": "Numéro d'identification personnel (PNO)"
							},
							"FI": {
								"label": "Code d'identification personnel (HETU)",
								"label_summary": "Numéro d'identification personnel (HETU)"
							},
							"NO": {
								"label": "Numéro national d'identité",
								"label_summary": "Numéro national d'identité"
							},
							"DK": {
								"label": "Numéro d'identification personnel",
								"label_summary": "Numéro d'identification personnel (CPR)"
							},
							"IT": {
								"label": "Code fiscal",
								"label_summary": "Code fiscal"
							},
							"ES": {
								"label": "Numéro d'identification personnel",
								"label_summary": "Numéro d'identification personnel (DNI)"
							},
							"PL": {
								"label": "Numéro d'identification personnel",
								"label_summary": "Numéro d'identification personnelle (PESEL)"
							},
							"default": {
								"label": "Numéro de passeport",
								"label_summary": "Numéro de passeport"
							},
							"value": "Confidentiel"
						},
						"registration_number": {
							"label": "Numéro d’identification de l’entreprise",
							"error": "Veuillez saisir votre numéro d'identification de l’employeur au format suivant : XX-XXXXXXXXX"
						},
						"company_name": {
							"label": "Nom de la boutique",
							"error": "Veuillez indiquer une raison sociale valide"
						},
						"legal_company_name": {
							"label": "Nom légal de la société",
							"error_label": "Veuillez indiquer le nom légal de la société"
						},
						"add_person": "Ajouter une personne",
						"remove": "Supprimer",
						"edit": "Modifier"
					}
				},
				"steps_headers": {
					"merchant": {
						"merchant_id": "ID de marchand : {merchantId}"
					}
				},
				"goodie_bags": {
					"marketing_material": {
						"title": "Ressources marketing",
						"text": "Vous faites maintenant partie de la famille Klarna. Voici un ensemble de ressources et d’autres éléments pour partir du bon pied.",
						"link": "Télécharger"
					},
					"invite_more_users": {
						"title": "Inviter plus d’utilisateurs",
						"text": "Invitez vos collaborateurs sur le Portail marchand. Vous pourrez définir des autorisations personnalisées pour chacun d’eux !",
						"link": "Inviter des utilisateurs"
					}
				},
				"terms_and_conditions_confirmation": {
					"title": "Produits et tarification",
					"subtitle": "{country}",
					"pricing": "Tarification en/au/aux/à {country}",
					"monthly_fee": "frais mensuels",
					"transaction_fee": "frais de transaction",
					"before_link": "J’accepte les",
					"link_text": "conditions générales de Klarna",
					"after_link_one_product": "concernant ce produit",
					"after_link_more_than_one_product": "concernant ces produits",
					"product_not_available_in_your_country": "* Ce produit n’est pas disponible sur votre marché national, mais il est disponible dans d’autres pays."
				},
				"product_description": {
					"product_attributes": {
						"installed": {
							"text": "Installé"
						},
						"in_progress": {
							"text": "En cours"
						}
					}
				},
				"phone_collection_block": {
					"title": "Vous avez des difficultés à réaliser l'intégration de Klarna ?",
					"description": "Indiquez votre numéro ci-dessous. L'un de nos agents vous appellera pour vous aider à intégrer Klarna à votre plateforme de commerce électronique.",
					"success_banner": "Merci ! Notre équipe vous contactera dès que possible.",
					"submit": "Envoyer",
					"fields": {
						"phone": {
							"label": "Numéro de téléphone",
							"tooltip": "Veuillez inclure le code du pays, par exemple +1 541 754 3010",
							"errors": {
								"required": "Le numéro de téléphone est requis",
								"invalid": "Numéro de téléphone non valide"
							}
						}
					}
				}
			},
			"containers": {
				"applicant": {
					"title": {
						"unmanaged": "Qui est en charge de signer les contrats de votre entreprise ?",
						"managed": "Qui est en charge de signer les contrats de l'entreprise ?",
						"recollection": "Qui sont les signataires autorisés de votre entreprise?"
					},
					"subtitle": {
						"unmanaged": "Votre entreprise est sur le point de conclure un contrat avec Klarna. Nous devons vérifier qui est légalement autorisé à signer de tels contrats.",
						"managed": "Veuillez fournir les informations relatives aux signataires autorisés de la société qui conclut cet accord. Nous sommes légalement tenus de valider l’autorité de signature de ces représentants. Si aucune personne de la liste n’a signé l'accord, cliquez sur « Ajouter une personne » et fournissez les informations requises.",
						"recollection": "Du fait que votre société a un accord actif avec Klarna, nous sommes légalement tenus de recueillir et valider des informations à propos de tous les signataires autorisés de votre société. "
					},
					"form_title": "Veuillez saisir les informations",
					"robot_message": {
						"unmanaged": "Il s'agit généralement des membres du conseil d'administration ou de cadres supérieurs tels que le P.-D.G., le directeur financier ou le directeur opérationnel. Indiquer le nom de deux personnes ou plus peut contribuer à accélérer l'approbation du contrat.",
						"managed": "Il s'agit généralement du président du conseil d'administration ou de cadres supérieurs tels que le P.-D.G., le directeur financier ou le directeur opérationnel. Indiquer le nom de deux personnes ou plus peut contribuer à accélérer l'approbation du contrat."
					},
					"error_tooltip": {
						"too_young": "Cette personne n'est pas autorisées à soumettre la candidature  car elle est âgée de moins de {minAge} ans."
					},
					"alert_all_too_young": "Toute personne donnant son accord doit être âgée d'au moins {minAge} ans. Pour poursuivre, merci d'ajouter et de sélectionner un(e) candidat(e) âgé(e) d'au moins {minAge} ans.",
					"buttons": {
						"next": "Suivant",
						"back": "Retour",
						"add_person": "+ Ajouter une personne"
					},
					"role": {
						"recollection": "Représentant légal"
					}
				},
				"application_summary": {
					"title": "Examiner et soumettre votre candidature.",
					"subtitle": {
						"unmanaged": "Vérifiez vos informations avant de valider votre demande.",
						"managed": "Vérifiez les informations avant de valider la demande."
					},
					"stakeholders": {
						"title": "Direction de l'entreprise",
						"subtitle": "Partie prenante {index}"
					},
					"businessDetailsCard": {
						"title": "Informations commerciales"
					},
					"businessDetailsCardFields": {
						"companyName": "Raison sociale",
						"organizationEntityType": "Classification fiscale",
						"organizationRegistrationAuthority": "Tribunal d’enregistrement",
						"goodsCategory": "Catégorie de marchandises",
						"registrationId": {
							"default": "Numéro d’enregistrement",
							"AT": "Numéro d’enregistrement",
							"AU": "Numéro ACN",
							"CA": "Numéro d'entreprise",
							"ES": "NIF/NIE/DNI de société",
							"GB": "Numéro d’entreprise",
							"GR": "Numéro G.E.MI. (Γ.Ε.ΜΗ.)",
							"NZ": "Numéro d'entreprise",
							"US": "Numéro d’identification de l'employeur"
						},
						"registered": {
							"default": "Société enregistrée",
							"AU": "La société possède un numéro ACN"
						},
						"subjectToVat": {
							"default": "Société assujettie à la TVA",
							"AU": "Société présentant un numéro ABN"
						},
						"vatId": {
							"default": "Numéro de TVA",
							"AU": "Numéro ABN",
							"NZ": "Numéro d'identification GST",
							"ES": "NIF/NIE/DNI de société"
						},
						"storeName": "Nom de la boutique",
						"storeName_us": "Nom de marque/En activité sous la raison sociale",
						"website": "Site Web",
						"email": "Adresse électronique de l'assistance client",
						"entityType": "Type d’entité"
					},
					"companyRegistrationAddressCard": {
						"title": "Adresse d’enregistrement de la société"
					},
					"companyAddressCard": {
						"title": "Adresse de la société"
					},
					"operatingAddressCard": {
						"title": "Adresse d’exploitation de la société"
					},
					"documentsCard": {
						"title": "Documents téléchargés"
					},
					"buttons": {
						"edit": "Modifier",
						"back": "Retour",
						"submit": "Envoyer"
					},
					"noTermsAccepted": "Veuillez lire et accepter les Conditions générales",
					"noTermsAcceptedWithPricingAnnex": "Veuillez lire et accepter le Contrat de commerçant et les Conditions de tarification"
				},
				"artificial_ultimate_beneficial_owner": {
					"title": {
						"default": "Qui dirige la société ?"
					},
					"subtitle": {
						"default": [
							{
								"text": "Nous sommes légalement tenus par la directive européenne visant à lutter contre le blanchiment de capitaux ("
							},
							{
								"text": "UE 2015/849",
								"link": "https://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri=CELEX:32015L0849"
							},
							{
								"text": ")."
							}
						],
						"US": [
							{
								"text": "En tant qu'établissement financier, nous sommes légalement tenus de recueillir ces informations."
							}
						],
						"CA": [
							{
								"text": "En tant qu'établissement financier, nous sommes légalement tenus de recueillir ces informations."
							}
						],
						"AU": [
							{
								"text": "En tant qu'établissement financier, nous sommes légalement tenus de recueillir ces informations."
							}
						]
					},
					"infobox": {
						"default": "Veuillez saisir les données personnelles et l'adresse de résidence du PDG de l'entreprise.",
						"US": "Veuillez saisir les informations personnelles et l'adresse de résidence du propriétaire majoritaire ou d'un représentant de haut niveau tel que le PDG, le directeur financier ou le directeur des opérations.",
						"CA": "Veuillez saisir les informations personnelles et l'adresse de résidence du propriétaire majoritaire ou d'un représentant de haut niveau tel que le PDG, le directeur financier ou le directeur des opérations."
					},
					"buttons": {
						"next": "Suivant",
						"back": "Retour"
					}
				},
				"managed_artificial_ultimate_beneficial_owner": {
					"title": "Cette société est-elle une société publique ou appartient-elle exclusivement à une société publique ?",
					"title_stakeholder": "Qui dirige la société ?",
					"subtitle": "En tant qu'établissement financier, nous sommes légalement tenus de recueillir ces informations.",
					"subtitle_stakeholder": "Veuillez saisir les données personnelles et l'adresse de résidence du PDG de l'entreprise.",
					"buttons": {
						"next": "Suivant",
						"back": "Retour"
					}
				},
				"bank_account": {
					"title": {
						"default": "Quelles sont vos données de compte bancaire ?"
					},
					"subtitle": {
						"US": "Les transactions Klarna seront transférées sur ce compte bancaire.",
						"default": "Nous les utiliserons pour transférer les paiements de vos ventes. "
					},
					"no_more_bank_accounts": "Vous avez déjà ajouté des comptes bancaires pour toutes les devises gérées. Excellent travail !",
					"robot_message_general": "Le compte bancaire par défaut doit se trouver dans une banque du pays dans lequel votre société est enregistrée. Vous devez également disposer d’un compte bancaire pour chacune des devises que vous prévoyez d’accepter.",
					"robot_message": "Le terme IBAN signifie International Bank Account Number (numéro de compte bancaire international). Il est fourni par votre banque pour votre compte. Par exemple : GB98 MIDL 0700 9312 3456 78",
					"robot_message_account_number": {
						"AU": "Le numéro de compte est fourni par votre banque et se compose de 6 à 10 chiffres. Par ex. : 12345678",
						"US": "Le numéro de compte est fourni par votre banque et se compose de 5 à 17 chiffres. Par ex. : 12345678",
						"GB": "Le numéro de compte est fourni par votre banque et compte 8 chiffres. Par exemple : 12345678. Certaines banques au Royaume-Uni fournissent des numéro de comptes plus courts (7 chiffres). Dans ce cas de figure, des zéros seront ajoutés au début de votre numéro de compte pour que sa longueur puisse atteindre 8 chiffres."
					},
					"robot_message_revolut": "L’IBAN que vous avez fourni ne peut recevoir de paiements nationaux en GBP. Veuillez contacter votre banque et demander à modifier les informations de votre compte pour gérer les virements nationaux en GBP.",
					"robot_message_local": "L'IBAN que tu nous as fourni est un IBAN local de ta banque que nous ne prenons pas en charge. Contacte ta banque et demande un IBAN personnel ou utilise un compte différent pour te connecter à Klarna.",
					"buttons": {
						"add_bank_account": "+ Ajouter un compte bancaire",
						"skip": "Ignorer (pour le moment)",
						"remove": "Supprimer",
						"submit": "Envoyer",
						"next": "Suivant",
						"back": "Retour"
					},
					"fields": {
						"currency_code": {
							"label": "Devise",
							"disable_reason": {
								"account_in_merchant_currency_required": "La devise par défaut est {currency}, conformément au pays dans lequel votre entreprise est enregistrée."
							},
							"errors": {
								"general": "Veuillez sélectionner une devise"
							}
						},
						"country_of_bankaccount": {
							"label": "Pays",
							"errors": {
								"general": "Veuillez sélectionner un pays"
							}
						},
						"iban_account_number": {
							"label": "Numéro de compte (IBAN)",
							"errors": {
								"general": "Veuillez saisir un numéro de compte bancaire (IBAN)"
							}
						},
						"use_as_default_bank_account": {
							"label": "Utiliser ce compte pour les devises non spécifiées",
							"tooltip": "Les commandes passées avec des devises qui ne sont pas listées sur cette page seront payées sur ce compte. Votre banque peut vous facturer une commission supplémentaire pour certaines devises."
						},
						"local_account_number": {
							"label": {
								"default": "Numéro de compte",
								"MX": "Numéro CLABE"
							},
							"errors": {
								"general": {
									"default": "Veuillez saisir un numéro de compte bancaire",
									"MX": "Veuillez saisir un numéro CLABE valide."
								}
							}
						},
						"account_holder": {
							"label": "Nom du titulaire du compte",
							"errors": {
								"general": "Veuillez saisir le nom du titulaire du compte (maximum 70 caractères)."
							}
						},
						"transit_number": {
							"label": "Numéro de routage",
							"errors": {
								"general": "Veuillez saisir un numéro de routage valide."
							}
						},
						"institution_number": {
							"label": "Numéro de l'institution",
							"errors": {
								"general": "Veuillez saisir un numéro d’institution valide"
							}
						},
						"bic": {
							"label": {
								"AU": "Code BSB"
							},
							"errors": {
								"general": {
									"AU": "Veuillez saisir un Bank State Branch (BSB) valide"
								}
							},
							"tooltip": {
								"AU": "Le code BSB doit contenir 6 caractères numériques séparés par un -. Par ex. : 123-456"
							}
						},
						"routing_number": {
							"label": {
								"default": "Numéro de routage",
								"GB": "Code de tri"
							},
							"errors": {
								"general": {
									"default": "Veuillez saisir un numéro de routage valide.",
									"GB": "Veuillez saisir un code de tri valide"
								}
							}
						}
					}
				},
				"control_over_management": {
					"title": {
						"default": "Qui dirige la société ?"
					},
					"subtitle": {
						"default": [
							{
								"text": "Nous sommes légalement tenus par la directive européenne visant à lutter contre le blanchiment de capitaux ("
							},
							{
								"text": "UE 2015/849",
								"link": "https://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri=CELEX:32015L0849"
							},
							{
								"text": ")."
							}
						],
						"GB": [
							{
								"text": "Nous sommes légalement tenus de recueillir ces informations. Veuillez vous assurer que les données fournies à la Companies House sont à jour."
							}
						]
					},
					"infobox": "Veuillez saisir les informations personnelles et l'adresse de résidence de personnes qui exercent une fonction de contrôle dans votre société, telles que le directeur général ou des membres du conseil d’administration.",
					"buttons": {
						"next": "Suivant",
						"back": "Retour",
						"add_person": "+ Ajouter une personne"
					},
					"messages": {
						"lookup": "Ces personnes gèrent-elles votre société ? Veuillez vérifier et confirmer si ces informations sont correctes."
					}
				},
				"de_registration_information": {
					"title": {
						"unmanaged": "Votre société est-elle une entreprise enregistrée ?",
						"managed": "Cette société est-elle une entreprise enregistrée ?"
					},
					"subtitle": {
						"unmanaged": "Nous avons besoin du numéro d’enregistrement de votre société pour vérifier vos informations commerciales.",
						"managed": "Nous avons besoin du numéro d’enregistrement de la société pour vérifier les informations commerciales."
					},
					"question": {
						"title": {
							"unmanaged": "Veuillez saisir votre numéro et votre tribunal d’enregistrement",
							"managed": "Veuillez saisir le numéro et le tribunal d’enregistrement"
						}
					},
					"fields": {
						"registration_number": {
							"label": "Numéro d’enregistrement"
						},
						"registration_court": {
							"label": "Tribunal d’enregistrement",
							"errors": {
								"general": {
									"unmanaged": "Veuillez sélectionner votre tribunal d’enregistrement",
									"managed": "Veuillez sélectionner le tribunal d’enregistrement"
								}
							}
						}
					},
					"buttons": {
						"next": "Suivant",
						"back": "Retour"
					}
				},
				"documents": {
					"title": "Téléchargez votre document",
					"subtitle": "Nous avons besoin de quelques documents supplémentaires qui nous permettront de valider votre identité. Les documents à télétransmettre doivent être au format <strong>JPG</strong>, <strong>PNG</strong> ou <strong>PDF</strong> (taille maximale des fichiers : 10 Mo).",
					"subheadline": {
						"default": "Klarna étant une banque dont le siège social est en Suède, et donc régulée sous le contrôle de l'autorité de surveillance financière suédoise, Klarna doit se conformer à la directive européenne UE 2015/849. Klarna a besoin de recueillir des informations sur les personnes qui contrôlent la société, afin que vous puissiez commencer à utiliser les services de Klarna. Veuillez télécharger uniquement des fichiers <strong>JPG, PNG ou PDF</strong> (taille maximale du fichier: 10 Mo).",
						"US": "Comme le siège social de Klarna se trouve en Suède, et que nous sommes sous le contrôle de l’autorité financière suédoise, Klarna doit se conformer à la directive européenne EU 2015/849. Klarna doit collecter des informations concernant les personnes responsables de la société, pour que vous puissiez commencer à utiliser les services Klarna. Veuillez nous fournir les documents suivants pour que nous puissions valider votre identité. Les documents à téléverser doivent être au format JPG, PNG ou PDF (taille maximale des fichiers : 10 Mo).",
						"IT": "Comme le siège social de Klarna se trouve en Suède, et que nous sommes sous le contrôle de l’autorité financière suédoise, Klarna doit se conformer à la directive européenne EU 2015/849. Klarna doit collecter des informations concernant les personnes responsables de la société, pour que vous puissiez commencer à utiliser les services Klarna. Veuillez noter que pour procéder à la demande, votre entreprise doit être enregistrée auprès de la Chambre de Commerce. Les documents à téléverser doivent être au format JPG, PNG ou PDF (taille maximale des fichiers : 10 Mo)."
					},
					"header_title": "Documents",
					"stakeholder": "Partie prenante",
					"business_documents": "Document d'entreprise",
					"browse_files": "Parcourir les fichiers",
					"optional": "(facultatif)",
					"upload_area": {
						"title": {
							"before_link": "Déposez vos fichiers ici ou",
							"link_text": "sélectionnez des fichiers"
						},
						"description": "{acceptedFileFormats} - Maximum {maxFileSizeMB} Mo/fichier"
					},
					"description": {
						"APPROVAL": "Télétransmettre l’<strong>approbation</strong>",
						"CONTRACT": "Télétransmettre le <strong>contrat</strong>",
						"CORRECTION_NOTE": "Télétransmettre la <strong>note de correction</strong>",
						"COUNTERSIGNED_CONTRACT": "Télétransmettre le <strong>contrat contresigné</strong>",
						"ID_DOCUMENT": "Télétransmettre la <strong>carte d’identité</strong> ou le <strong>passeport</strong>",
						"LICENSE": "Télétransmettre la <strong>licence</strong>",
						"PROOF_OF_ADDRESS": "Télétransmettre le <strong>justificatif de domicile</strong>",
						"SPECIAL_AGREEMENT": "Télétransmettre la <strong>convention spéciale</strong>",
						"SUPPORTING_DOCUMENT": "Télétransmettre la <strong>pièce justificative</strong>",
						"TAX_OFFICE_REGISTRATION": "Télétransmettre le <strong>justificatif d’inscription au bureau des impôts</strong>"
					},
					"explanation": {
						"APPROVAL": {
							"title": {
								"default": "Approbation"
							},
							"subtitle": {
								"default": null
							}
						},
						"CONTRACT": {
							"title": {
								"default": "Contrat"
							},
							"subtitle": {
								"default": null
							}
						},
						"CORRECTION_NOTE": {
							"title": {
								"default": "Note de correction"
							},
							"subtitle": {
								"default": null
							}
						},
						"COUNTERSIGNED_CONTRACT": {
							"title": {
								"default": "Contrat contresigné"
							},
							"subtitle": {
								"default": null
							}
						},
						"ID_DOCUMENT": {
							"title": {
								"default": "Pièce d'identité",
								"IT": "Carte d'identité"
							},
							"subtitle": {
								"default": "Veuillez fournir le recto et le verso de la carte d’identité.",
								"AT": "Veuillez nous fournir les deux côtés de votre carte d'identité. Si votre adresse ne figure pas sur votre pièce d'identité, nous aurons besoin de documents supplémentaires, p. ex. une facture de services publics, pour vérifier votre adresse.",
								"AU": "Pour une évaluation plus rapide de votre demande, veuillez fournir une copie valide d'une pièce d'identité avec photo, telle qu'un passeport ou un permis de conduire australien pour les personnes suivantes associées à l'entreprise : Entreprise individuelle/Partenariat - le(s) propriétaire(s). Société - le représentant légal, tous les administrateurs et tout actionnaire détenant plus de 25 % des actions.",
								"BE": "Veuillez fournir le recto et le verso de la pièce d'identité, assurez-vous que la qualité de l'image est suffisante et que toutes les informations sont clairement lisibles.",
								"DE": "Veuillez nous fournir les deux côtés de votre carte d'identité. Si votre adresse ne figure pas sur votre pièce d'identité, nous aurons besoin de documents supplémentaires, p. ex. une facture de services publics, pour vérifier votre adresse.",
								"FR": "Veuillez fournir le recto et le verso de la pièce d'identité, assurez-vous que la qualité de l'image est suffisante et que toutes les informations sont clairement lisibles.",
								"GB": "Merci de fournir un document d'identité. S'il s'agit de votre CNI, merci d'en fournir les deux faces.",
								"IT": "Une carte d'identité valide recto/verso pour chacune des personnes inscrites dans la demande. Permis de conduire, passeport, carte/numéro de sécurité sociale ne sont pas acceptés.",
								"NL": "Veuillez fournir le recto et le verso de la pièce d'identité, assurez-vous que la qualité de l'image est suffisante et que toutes les informations sont clairement lisibles.",
								"US": "Permis de conduire ou passeport : veuillez fournir le recto et le verso du document d'identité."
							}
						},
						"LICENSE": {
							"title": {
								"default": "Licence"
							},
							"subtitle": {
								"default": null
							}
						},
						"PROOF_OF_ADDRESS": {
							"title": {
								"default": "Justificatif de domicile",
								"BE": "Justificatif de domicile",
								"CZ": "Justificatif de domicile",
								"ES": "Justificatif de domicile",
								"FI": "Justificatif de domicile",
								"FR": "Justificatif de domicile",
								"GR": "Justificatif de domicile",
								"IT": "Justificatif de domicile",
								"NL": "Justificatif de domicile",
								"PL": "Justificatif de domicile",
								"PT": "Justificatif de domicile"
							},
							"subtitle": {
								"default": "Nous acceptons les documents suivants datant de moins de 3 mois comme justificatif de domicile : Facture d'électricité, d'eau, de gaz, déclaration d'impôts ou contrat de location. Si vous ne disposez d'aucun de ces documents, veuillez télécharger tout autre justificatif de domicile et ajouter une note explicative.",
								"AU": "Pour une évaluation plus rapide de votre demande, veuillez fournir l'un des documents suivants, datant de moins de 90 jours pour vérifier l'adresse du domicile : Facture de services publics, facture Internet, déclaration de revenus ou contrat de bail/location. * Si vous fournissez un passeport comme pièce d'identité, ou si votre adresse actuelle ne correspond pas à l'adresse sur votre pièce d'identité fournie, cette étape est obligatoire.",
								"BE": "Nous acceptons les documents suivants datant de moins de 3 mois comme justificatif de domicile : Facture d'électricité, d'eau, de gaz, déclaration d'impôts ou contrat de location. Si vous ne disposez d'aucun de ces documents, veuillez télécharger tout autre justificatif de domicile et ajouter une note explicative.",
								"FR": "Nous acceptons les documents suivants datant de moins de 3 mois comme justificatif de domicile : Facture d'électricité, d'eau, de gaz, déclaration d'impôts ou contrat de location. Si vous ne disposez d'aucun de ces documents, veuillez télécharger tout autre justificatif de domicile et ajouter une note explicative.",
								"NL": "Nous acceptons les documents suivants datant de moins de 3 mois comme justificatif de domicile : Facture d'électricité, d'eau, de gaz, déclaration d'impôts ou contrat de location. Si vous ne disposez d'aucun de ces documents, veuillez télécharger tout autre justificatif de domicile et ajouter une note explicative.",
								"US": "Nous acceptons les factures de services publics (gaz, eau, Internet, téléphone, etc.), le bail ou l'hypothèque avec justificatif de domicile - Le document ne doit pas être daté de plus de 90 jours à compter de la date d'application.",
								"IT": "Si votre carte d'identité a une adresse différente de votre adresse résidentielle actuelle, nous aurons besoin d'un document supplémentaire pour vérifier votre résidence actuelle. Nous acceptons les documents suivants datant de moins de 3 mois comme preuve de l'adresse de résidence des personnes énumérées dans la demande :"
							},
							"list": {
								"IT": [
									{
										"text": "Certificat de résidence délivré en ligne (via SPID) ou par la Commune de votre résidence"
									},
									{
										"text": "Factures électricité / eau / gaz / Internet"
									},
									{
										"text": "contrat de location"
									}
								]
							}
						},
						"SPECIAL_AGREEMENT": {
							"title": {
								"default": "Convention spéciale"
							},
							"subtitle": {
								"default": null
							}
						},
						"SUPPORTING_DOCUMENT": {
							"title": {
								"default": "Pièce justificative",
								"GB": "Auto-portrait"
							},
							"subtitle": {
								"default": null,
								"AU": "Si vous vendez des articles de marque de grande valeur, veuillez fournir ici 2 à 3 factures de fournisseurs pour ces produits. Veuillez vous assurer que la facture inclut les produits achetés, le nom du fournisseur, le nom du destinataire et l'adresse de livraison.",
								"GB": "Merci de fournir une photo dans laquelle vous tenez le document d'identité visible."
							}
						},
						"TAX_OFFICE_REGISTRATION": {
							"title": {
								"default": "Document d’inscription auprès du centre des impôts",
								"AT": "Document d'enregistrement auprès de l'administration fiscale",
								"AU": "Acte de fiducie",
								"BE": "Numéro de TVA activé pour les transactions transfrontalières (VIES).",
								"DE": "Document d'enregistrement auprès de l'administration fiscale",
								"FR": "Numéro de TVA activé pour les transactions transfrontalières (VIES).",
								"IT": "Numéro de TVA activé pour les transactions transfrontalières (VIES).",
								"NL": "Numéro de TVA activé pour les transactions transfrontalières (VIES).",
								"NO": "Justificatif d’inscription au bureau des impôts",
								"US": "Lettre EIN"
							},
							"subtitle": {
								"default": null,
								"AT": "Nous acceptons les documents suivants comme documents d’entreprise : Extrait du registre du commerce / licence d'entrepreneur individuel",
								"AU": "Si votre ABN est associé à une fiducie, veuillez fournir une copie du document de fiducie, y compris l'annexe de la fiducie. Attention, cette étape est obligatoire pour les fiducies.",
								"BE": "Vérifiez que votre numéro de TVA est <link>activé pour les transactions transfrontalières</link>. Cela est nécessaire même si vous ne faites du commerce que dans votre pays, car Klarna est une entité étrangère. Vous pouvez contacter votre bureau des impôts local pour demander une activation VIES gratuite de votre numéro de TVA.",
								"CZ": "Nous acceptons les documents suivants comme documents d’entreprise : Certificat d'inscription au registre public ou extrait du registre du commerce de l'entreprise individuelle.",
								"DE": "Nous acceptons les documents suivants comme documents d’entreprise : Extrait du registre du commerce / licence d'entrepreneur individuel",
								"ES": "Nous acceptons les documents suivants comme documents d'entreprise : textes statutaires pour les entreprises enregistrées ; pour les auto-entrepreneurs - Attestation de recensement / Modèle 036 / Modèle 037",
								"FI": "Nous acceptons les documents suivants comme documents d’entreprise : statut constitutif pour les auto-entrepreneurs - Attestation de recensement / Modèle 036 / Modèle 037",
								"FR": "Vérifiez que votre numéro de TVA est <link>activé pour les transactions transfrontalières</link>. Cela est nécessaire même si vous ne faites du commerce que dans votre pays, car Klarna est une entité étrangère. Vous pouvez contacter votre bureau des impôts local pour demander une activation VIES gratuite de votre numéro de TVA.",
								"GR": "Nous acceptons les documents suivants comme documents d’entreprise : Immatriculation fiscale / Début d'activité / Registre du Commerce Document délivré par le Service Compétent GEMI (Union Centrale des Chambres)",
								"IT": "Vous pouvez contacter l'Internal Revenue Service (Agenzia delle Entrate) pour demander une activation VIES gratuite de votre numéro de TVA. Cela sera nécessaire même si vous ne faites du commerce qu'en Italie, car Klarna est une entité étrangère.",
								"NL": "Vérifiez que votre numéro de TVA est <link>activé pour les transactions transfrontalières</link>. Cela est nécessaire même si vous ne faites du commerce que dans votre pays, car Klarna est une entité étrangère. Vous pouvez contacter votre bureau des impôts local pour demander une activation VIES gratuite de votre numéro de TVA.",
								"NO": "Nous acceptons les documents suivants comme documents d’entreprise : Documents d'entreprise",
								"PL": "Nous acceptons les documents suivants comme documents d’entreprise : Attestation d'inscription au registre du commerce du CEIDG, extrait du Registre Judiciaire National (KRS)",
								"PT": "Nous acceptons les documents suivants comme documents d’entreprise :  Certidão Permanente (obligatoire), Certificat d’Incorporation. Pour les commerçants individuels : déclaration d’activité indépendante (Declaração de Início de Atividade).",
								"US": "Ceci est la lettre reçue de l'IRS vous attribuant un EIN (IRS CP575 EIN Letter). Si votre entreprise est une entreprise individuelle et si vous déposez avec votre SSN, veuillez fournir une copie de votre carte SSN à la place"
							},
							"link": {
								"BE": "https://ec.europa.eu/taxation_customs/vies/#/vat-validation",
								"FR": "https://ec.europa.eu/taxation_customs/vies/#/vat-validation",
								"NL": "https://ec.europa.eu/taxation_customs/vies/#/vat-validation",
								"GR": "https://www.businessregistry.gr/publicity/index"
							}
						},
						"CERTIFIED_ID": {
							"title": {
								"default": "Pièce d'identité certifiée"
							},
							"subtitle": {
								"default": "Nous acceptons les documents suivants : Carte d'identité, passeport, permis de conduire. Les documents doivent répondre aux critères suivants :"
							},
							"list": [
								{
									"text": "Certifiés par un agent de certification autorisé (par exemple un notaire public, un commissaire aux serments, un avocat et/ou un comptable agréé)."
								},
								{
									"text": "Signés et tamponnés. Le tampon doit afficher des détails visibles et vérifiables du certificateur, tels que le nom complet, l'adresse et, le cas échéant, le numéro d'enregistrement."
								},
								{
									"text": "Datés - date de certification datant de moins de 6 mois."
								},
								{
									"text": "Attestés comme une copie conforme d'un original en indiquant clairement que le document original a été vu."
								}
							]
						}
					},
					"modal": {
						"title": "Pourquoi avons-nous besoin de vos documents ?",
						"close": "Fermer",
						"content": [
							{
								"title": "Description de la procédure",
								"text": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat."
							},
							{
								"title": "Exigences en matière de fichiers",
								"text": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat."
							},
							{
								"title": "Comment numériser mes documents ?",
								"text": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat."
							}
						]
					},
					"errors": {
						"general": "Échec du téléchargement",
						"too_large_file": "Le fichier est trop volumineux <strong>(max {maxFileSizeMB} Mo)</strong>",
						"max_num_files_exceeded": "Vous ne pouvez télécharger que {number} fichiers.",
						"invalid_file_format": "Format de fichier non valide. Les seuls types de fichiers acceptés sont {acceptedFileFormats}",
						"duplicate_file_name": "Dupliquer le nom de fichier. Tous les fichiers ajoutés doivent avec des noms différents.",
						"try_again": "Essayez à nouveau ou <u>choisissez un autre fichier</u>"
					},
					"buttons": {
						"modal": "Pourquoi avons-nous besoin de vos documents ?",
						"next": "Suivant",
						"back": "Retour",
						"submit": "Soumettre les documents"
					}
				},
				"document_upload_success": {
					"title": "Téléchargement terminé.",
					"message": "Merci ! Vos documents ont été téléchargés avec succès."
				},
				"forced_registration_information": {
					"title": {
						"unmanaged": {
							"default": "Veuillez saisir votre numéro d’enregistrement",
							"AT": "Veuillez saisir votre numéro d’enregistrement",
							"CA": "Pouvez-vous saisir votre numéro d'entreprise fédéral ?",
							"GR": "Veuillez saisir votre numéro G.E.MI. (Γ.Ε.ΜΗ.).",
							"NZ": "Veuillez saisir votre numéro d’entreprise."
						},
						"managed": {
							"default": "Veuillez saisir le numéro d’enregistrement de la société",
							"AT": "Veuillez saisir le numéro d’enregistrement de la société",
							"CA": "Pouvez-vous saisir votre numéro d'entreprise fédéral ?",
							"GR": "Veuillez saisir le numéro G.E.MI. (Γ.Ε.ΜΗ.) de l’entreprise.",
							"NZ": "Veuillez saisir le numéro d’entreprise de la société."
						}
					},
					"subtitle": {
						"unmanaged": {
							"default": "Nous avons besoin du numéro d’enregistrement de votre société pour vérifier vos informations commerciales.",
							"AT": "Nous avons besoin du numéro d’enregistrement de votre société pour vérifier vos informations commerciales.",
							"CA": "Nous avons besoin de votre numéro d'entreprise fédéral attribué à l'ARC (Agence du revenu du Canada) afin de vérifier les informations de votre entreprise.",
							"GR": "Nous avons besoin de votre numéro G.E.MI. pour vérifier les informations commerciales.",
							"NZ": "Nous avons besoin du numéro d’entreprise de votre société pour vérifier vos informations commerciales."
						},
						"managed": {
							"default": "Nous avons besoin du numéro d’enregistrement de la société pour vérifier les informations commerciales.",
							"AT": "Nous avons besoin du numéro d’enregistrement de la société pour vérifier les informations commerciales.",
							"CA": "Nous avons besoin de votre numéro d'entreprise fédéral attribué à l'ARC (Agence du revenu du Canada) afin de vérifier les informations de votre entreprise.",
							"GR": "Nous avons besoin du numéro G.E.MI. pour vérifier les informations commerciales.",
							"NZ": "Nous avons besoin du numéro d’entreprise de la société pour vérifier les informations commerciales."
						}
					},
					"infobox": {
						"unmanaged": {
							"CA": "Remarque : Klarna ne peut pour l'instant pas offrir de services de paiement pour les entreprises canadiennes individuelles. Si vous continuez votre demande, celle-ci sera rejetée."
						}
					},
					"fields": {
						"registration_number": {
							"label": {
								"default": "Numéro d’enregistrement",
								"AT": "Numéro d’enregistrement",
								"CA": "Numéro d'entreprise",
								"GR": "Numéro G.E.MI. (Γ.Ε.ΜΗ.)",
								"NZ": "Numéro d'entreprise"
							}
						}
					},
					"buttons": {
						"next": "Suivant",
						"back": "Retour"
					}
				},
				"tax_identification_number": {
					"title": {
						"unmanaged": "Quelle est votre classification fiscale ?",
						"managed": "Veuillez saisir la classification fiscale de votre entreprise."
					},
					"subtitle": {
						"unmanaged": "Nous vous demanderons différentes informations en fonction du statut juridique de l'entreprise.",
						"managed": "Nous vous demanderons différentes informations en fonction du statut juridique de l'entreprise."
					},
					"info": {
						"unmanaged": "Vous trouverez le numéro d’identification de l'employeur de votre entreprise sur vos déclarations de revenus, vos rapports de solvabilité, vos documents de paie ou encore vos licences et autorisations",
						"managed": "Vous trouverez le numéro d’identification fiscale de l'entreprise sur les déclarations de revenus, les rapports de solvabilité, les documents de paie ou encore les licences et autorisations"
					},
					"fields": {
						"registration_number": {
							"label": "Numéro d’identification de l'employeur",
							"errors": {
								"general": "Veuillez saisir un numéro d’identification de l'employeur valide",
								"invalid": "Le numéro d'identification de l'employeur doit comporter 9 chiffres avec un \"-\" après les deux premiers chiffres. Par exemple : 12-3456789"
							}
						},
						"organization_entity": {
							"label": {
								"unmanaged": "Classification fiscale fédérale",
								"managed": "Type de société"
							},
							"errors": {
								"is_one_of": "Veuillez choisir l’un des types d’activité répertoriés"
							}
						}
					},
					"buttons": {
						"next": "Suivant",
						"back": "Retour"
					}
				},
				"forced_vat_registration": {
					"title": {
						"unmanaged": {
							"default": "Veuillez saisir votre numéro de TVA",
							"AU": "Veuillez saisir votre numéro ABN",
							"ES": "Quel est votre numéro d’identification fiscale ?",
							"NZ": "Veuillez saisir votre numéro d'identification GST."
						},
						"managed": {
							"default": "Veuillez saisir le numéro de TVA",
							"AU": "Veuillez saisir le numéro ABN",
							"ES": "Quel est votre numéro d’identification fiscale ?",
							"NZ": "Veuillez saisir le numéro d'identification GST."
						}
					},
					"subtitle": {
						"unmanaged": {
							"default": "Grâce à votre numéro de TVA, nous pouvons vérifier plus facilement les informations relatives à votre société.",
							"AU": "Grâce à votre numéro ABN, nous pouvons vérifier plus facilement les informations relatives à votre société.",
							"NZ": "Grâce à votre numéro d'identification GST, nous pouvons vérifier plus facilement les informations relatives à votre société.",
							"ES": "Avec à votre numéro NIF, NIE ou DNI, nous pouvons vérifier plus facilement les informations relatives à votre société."
						},
						"managed": {
							"default": "Nous utilisons le numéro de TVA pour vérifier les informations relatives à la société.",
							"AU": "Nous utilisons le numéro ABN pour vérifier les informations relatives à la société.",
							"NZ": "Nous utilisons le numéro d'identification GST pour vérifier les informations relatives à la société.",
							"ES": "Nous utilisons le numéro NIF, NIE ou DNI pour vérifier les informations relatives à la société."
						}
					},
					"fields": {
						"vat_number": {
							"label": {
								"default": "Numéro de TVA",
								"AU": "Numéro ABN",
								"NZ": "Numéro d'identification GST",
								"ES": "NIF/NIE/DNI"
							}
						}
					},
					"buttons": {
						"next": "Suivant",
						"back": "Retour"
					}
				},
				"legal_entity_type": {
					"title": {
						"unmanaged": "Quel type d’activité exercez-vous ?",
						"managed": "Quel est le type de cette société ?"
					},
					"subtitle": {
						"unmanaged": "Nous sommes tenus de poser des questions spécifiques en fonction de votre type de société.",
						"managed": "Nous sommes tenus de poser des questions spécifiques en fonction du type de la société."
					},
					"fields": {
						"legal_entity_type": {
							"label": "Type d’entité juridique",
							"errors": {
								"is_one_of": "Veuillez choisir l’un des types d’activité répertoriés"
							}
						}
					},
					"buttons": {
						"next": "Suivant",
						"back": "Retour"
					}
				},
				"optional_registration_information": {
					"title": {
						"unmanaged": {
							"default": "Votre société est-elle une entreprise enregistrée ?",
							"AU": "Votre société possède-t-elle un numéro ACN ?",
							"ES": "Votre entreprise est-elle inscrite au Registro Mercantil ?"
						},
						"managed": {
							"default": "Cette société est-elle une entreprise enregistrée ?",
							"AU": "Cette société possède-t-elle un numéro ACN ?",
							"ES": "Votre entreprise est-elle inscrite au Registro Mercantil ?"
						}
					},
					"subtitle": {
						"unmanaged": {
							"default": "Nous avons besoin du numéro d’enregistrement de votre société pour vérifier vos informations commerciales.",
							"AT": "Nous avons besoin du numéro d’enregistrement de votre société pour vérifier vos informations commerciales.",
							"AU": "Si vous possédez un numéro ACN, veuillez le saisir. Sinon, sélectionnez Non et passez à la suite.",
							"ES": "La réponse est Oui si vous êtes une SL, SA, SCP, ...etc. La réponse est Non si vous êtes autónomo, freelancer, ...etc.",
							"GB": "Nous avons besoin de votre numéro d’entreprise pour vérifier vos informations commerciales.",
							"GR": "Nous avons besoin de votre numéro G.E.MI. pour vérifier les informations commerciales."
						},
						"managed": {
							"default": "Nous avons besoin du numéro d’enregistrement de la société pour vérifier les informations commerciales.",
							"AT": "Nous avons besoin du numéro d’enregistrement de la société pour vérifier les informations commerciales.",
							"AU": "Si cette société possède un numéro ACN, veuillez le saisir. Sinon, sélectionnez Non et passez à la suite.",
							"ES": "La réponse est Oui si vous êtes une SL, SA, SCP, ...etc. La réponse est Non si vous êtes autónomo, freelancer, ...etc.",
							"GB": "Nous avons besoin du numéro d’entreprise pour vérifier les informations commerciales.",
							"GR": "Nous avons besoin du numéro G.E.MI. de l’entreprise pour vérifier les informations commerciales."
						}
					},
					"form_title": {
						"unmanaged": {
							"default": "Veuillez saisir votre numéro d’enregistrement",
							"AT": "Veuillez saisir votre numéro d’enregistrement",
							"AU": "Veuillez saisir votre numéro ACN",
							"ES": "Veuillez saisir le NIF/NIE/DNI de votre société",
							"GB": "Veuillez saisir votre numéro d’entreprise",
							"GR": "Veuillez indiquer votre numéro G.E.MI. (Γ.Ε.ΜΗ.)"
						},
						"managed": {
							"default": "Veuillez saisir le numéro d’enregistrement",
							"AT": "Veuillez saisir le numéro d’enregistrement",
							"AU": "Veuillez saisir le numéro ACN",
							"ES": "Veuillez saisir le NIF/NIE/DNI de votre société",
							"GB": "Veuillez saisir le numéro d’entreprise",
							"GR": "Veuillez indiquer le numéro G.E.MI. (Γ.Ε.ΜΗ.)"
						}
					},
					"fields": {
						"registration_number": {
							"label": {
								"default": "Numéro d’enregistrement",
								"AT": "Numéro d’enregistrement",
								"AU": "Numéro de société australien (ACN)",
								"ES": "NIF/NIE/DNI de société",
								"GB": "Numéro d’entreprise",
								"GR": "Numéro G.E.MI. (Γ.Ε.ΜΗ.)"
							},
							"errors": null
						}
					},
					"buttons": {
						"next": "Suivant",
						"back": "Retour"
					}
				},
				"mid-selector": {
					"title": "Choisir une boutique",
					"subtitle": "Cette adresse e-mail est associée à plusieurs boutiques. Veuillez choisir une boutique pour continuer.",
					"mid-selector": "ID de marchand / Nom de la boutique",
					"buttons": {
						"next": "Continuer"
					}
				},
				"optional_registration_information_widget": {
					"title": {
						"unmanaged": "Votre société est-elle une entreprise enregistrée ?",
						"managed": "Cette société est-elle une entreprise enregistrée ?"
					},
					"subtitle": {
						"unmanaged": {
							"default": "Nous avons besoin du numéro d’enregistrement de votre société pour vérifier vos informations commerciales.",
							"AT": "Nous avons besoin du numéro d’enregistrement de votre société pour vérifier vos informations commerciales."
						},
						"managed": {
							"default": "Nous avons besoin du numéro d’enregistrement de la société pour vérifier les informations commerciales.",
							"AT": "Nous avons besoin du numéro d’enregistrement de la société pour vérifier les informations commerciales."
						}
					},
					"form_title": {
						"unmanaged": {
							"default": "Veuillez saisir votre numéro d’enregistrement",
							"AT": "Veuillez saisir votre numéro d’enregistrement"
						},
						"managed": {
							"default": "Veuillez saisir le numéro d’enregistrement",
							"AT": "Veuillez saisir le numéro d’enregistrement"
						}
					},
					"fields": {
						"registration_number": {
							"label": {
								"default": "Numéro d’enregistrement",
								"AT": "Numéro d’enregistrement"
							}
						}
					},
					"buttons": {
						"next": "Suivant",
						"back": "Retour"
					}
				},
				"optional_vat_registration": {
					"title": {
						"unmanaged": {
							"default": "Votre société est-elle assujettie à la TVA ?",
							"ES": "Votre société dispose-t-elle d’un NIF/NIE/DNI ?",
							"NZ": "Votre société est-elle assujettie à la TVA ?"
						},
						"managed": {
							"default": "Cette société est-elle assujettie à la TVA ?",
							"ES": "Votre société dispose-t-elle d’un NIF/NIE/DNI ?",
							"NZ": "Cette société est-elle assujettie à la TVA ?"
						}
					},
					"subtitle": {
						"unmanaged": {
							"default": "Si vous avez un numéro de TVA, nous pouvons vérifier plus facilement les informations relatives à votre société.",
							"ES": "Si votre société dispose d’un numéro NIF/NIE/DNI, nous pouvons vérifier plus facilement les informations relatives à cette dernière.",
							"NZ": "Si vous avez un numéro de TVA, nous pourrons vérifier plus facilement les informations relatives à votre société."
						},
						"managed": {
							"default": "Nous utilisons le numéro de TVA pour vérifier les informations relatives à la société.",
							"ES": "Si votre société dispose d’un numéro NIF/NIE/DNI, nous pouvons vérifier plus facilement les informations relatives à cette dernière.",
							"NZ": "Nous utilisons le numéro de TVA pour vérifier les informations relatives à la société."
						}
					},
					"form_title": {
						"unmanaged": {
							"default": "Veuillez saisir votre numéro de TVA",
							"ES": "Veuillez saisir le NIF/NIE/DNI de votre société",
							"NZ": "Veuillez saisir votre numéro de TVA"
						},
						"managed": {
							"default": "Veuillez saisir le numéro de TVA",
							"ES": "Veuillez saisir le NIF/NIE/DNI de votre société",
							"NZ": "Veuillez saisir votre numéro de TVA"
						}
					},
					"vat_id": {
						"label": {
							"default": "Numéro de TVA",
							"ES": "NIF/NIE/DNI de société",
							"NZ": "Numéro de TVA"
						}
					},
					"buttons": {
						"next": "Suivant",
						"back": "Retour"
					}
				},
				"optional_vat_registration_widget": {
					"title": {
						"unmanaged": "Votre société est-elle assujettie à la TVA ?",
						"managed": "Cette société est-elle assujettie à la TVA ?"
					},
					"subtitle": {
						"unmanaged": "Si vous avez un numéro de TVA, nous pouvons vérifier plus facilement les informations relatives à votre société.",
						"managed": "Nous utilisons le numéro de TVA pour vérifier les informations relatives à la société."
					},
					"form_title": {
						"unmanaged": "Veuillez saisir votre numéro de TVA",
						"managed": "Veuillez saisir le numéro de TVA"
					},
					"vat_id": {
						"label": {
							"default": "Numéro de TVA",
							"NZ": "Numéro de TVA"
						}
					},
					"buttons": {
						"next": "Suivant",
						"back": "Retour"
					}
				},
				"partnership_details": {
					"title": {
						"unmanaged": "Quelle est votre adresse d’activité ?",
						"managed": "Quelle est l’adresse professionnelle de la société ?"
					},
					"subtitle": {
						"unmanaged": "Nous devons savoir où se trouve votre société.",
						"managed": "Nous devons savoir où se trouve la société."
					},
					"buttons": {
						"next": "Suivant",
						"back": "Retour"
					},
					"fields": {
						"partnership_name": {
							"label": "Nom du partenariat",
							"errors": {
								"general": "Veuillez saisir un nom de partenariat"
							}
						},
						"street": {
							"label": "Adresse",
							"errors": {
								"general": "Veuillez saisir une adresse valide"
							}
						},
						"postal_code": {
							"label": "Code postal",
							"errors": {
								"general": "Veuillez saisir un code postal valide"
							}
						},
						"city": {
							"label": "Ville",
							"errors": {
								"general": "Veuillez saisir une ville valide"
							}
						},
						"country": {
							"label": "Pays",
							"errors": {
								"general": "Veuillez saisir un pays valide"
							}
						}
					}
				},
				"partners_and_principals": {
					"title": {
						"default": "Qui est le propriétaire de la société ?",
						"GB": "Qui dirige la société ?"
					},
					"subtitle": {
						"default": [
							{
								"text": "Nous sommes légalement tenus par la directive européenne visant à lutter contre le blanchiment de capitaux ("
							},
							{
								"text": "UE 2015/849",
								"link": "https://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri=CELEX:32015L0849"
							},
							{
								"text": ")."
							}
						],
						"AU": [
							{
								"text": "En tant qu'établissement financier, nous sommes légalement tenus de recueillir ces informations."
							}
						]
					},
					"infobox": "Veuillez saisir les informations personnelles et l'adresse de résidence de tous les partenaires et responsables qui exercent une fonction de contrôle dans votre société.",
					"buttons": {
						"add_person": "+ Ajouter une personne",
						"next": "Suivant",
						"back": "Retour"
					}
				},
				"payouts_summary": {
					"title": "Comptes bancaires",
					"default_bank_accounts": {
						"no_elements": "Aucun compte bancaire par défaut disponible"
					},
					"additional_bank_accounts": {
						"no_elements": "Vous n’avez pas indiqué de comptes bancaires supplémentaires"
					}
				},
				"pre_assessment_company_details": {
					"title": "Veuillez renseigner plus de détails sur votre activité.",
					"subtitle": "Veuillez nous indiquer la part du volume des transactions par carte et les détails de la société pour ce marchand. Veuillez également indiquer si la société opère sur un autre marché que celui du pays d’enregistrement, car cela est nécessaire pour l’évaluation des risques.",
					"fields": {
						"volume_by_card": {
							"label": "Part du volume des transactions par carte sur le volume total (en %)",
							"errors": {
								"invalid": "Le volume des transactions par carte doit être compris entre 0 et 100",
								"invalid_hint": "Veuillez ajouter la part du volume des transactions par carte sur le volume total de Klarna pour cette opportunité. Entrez 0 % si votre opportunité n'a réalisé aucun paiement par carte"
							}
						},
						"average_order_value": {
							"label": "Valeur de commande moyenne (en SEK)",
							"tooltip": "Doit être un montant positif en SEK",
							"errors": {
								"invalid": "Doit être un montant positif en SEK"
							}
						},
						"registration_country": {
							"label": "Pays d’enregistrement",
							"errors": {
								"required": "Le pays d’enregistrement est obligatoire"
							}
						},
						"operating_country": {
							"label": "Pays d’exploitation",
							"errors": {
								"required": "Le pays d’exploitation est obligatoire"
							}
						},
						"registration_number": {
							"label": {
								"default": "Numéro d'enregistrement (obligatoire pour les sociétés enregistrées)",
								"AU": "ACN (obligatoire pour les sociétés enregistrées)",
								"ES": "NIF/NIE/DNI de l'entreprise (obligatoire pour les sociétés enregistrées)",
								"GR": "Numéro G.E.MI. (Γ.Ε.ΜΗ.) (obligatoire pour les sociétés enregistrées)",
								"NZ": "Numéro d'entreprise (obligatoire pour les sociétés enregistrées)",
								"US": "TIN/EIN (obligatoire pour les sociétés enregistrées)"
							}
						},
						"vat_number": {
							"label": "Numéro ABN",
							"errors": {
								"required": "Veuillez indiquer un numéro ACN ou ABN",
								"invalid": "Le numéro ABN doit comporter 11 chiffres"
							}
						},
						"registration_authority": {
							"label": "Autorité d’enregistrement",
							"errors": {
								"required": "Veuillez sélectionner votre autorité d’enregistrement"
							}
						},
						"company_name": {
							"label": "",
							"errors": {
								"required": ""
							}
						},
						"sales_contact": {
							"label": "Adresse e-mail du représentant commercial",
							"errors": {
								"invalid": "Veuillez saisir une adresse e-mail valide"
							}
						},
						"store_url": {
							"label": "URL de la boutique",
							"errors": {
								"required": "L’URL de la boutique est requise",
								"invalid": "Veuillez saisir une URL de site Web valide"
							}
						},
						"goods_category": {
							"label": "Catégorie principale des marchandises vendues",
							"errors": {
								"invalid": "Vous devez sélectionner l’une des options"
							}
						},
						"is_managed": {
							"label": "Mettre en ligne la publication acceptée ?"
						}
					},
					"buttons": {
						"next": "Suivant",
						"back": "Retour"
					}
				},
				"pre_assessment_products": {
					"title": "Veuillez indiquer tous les produits",
					"subtitle": "Pour l’évaluation des risques, tous les produits par pays de vente doivent être indiqués",
					"select": {
						"label": "Rechercher un produit"
					},
					"selected": {
						"label": "Produits sélectionnés :"
					},
					"clear": "Effacer tout",
					"errors": {
						"invalid": "Au moins un produit par pays doit être sélectionné"
					},
					"channels": {
						"ONLINE": "En ligne",
						"IN_STORE": "En boutique",
						"TELESALES": "Téléventes",
						"SELLER_APP": "Application vendeur"
					},
					"buttons": {
						"next": "Suivant",
						"back": "Retour"
					}
				},
				"wrong_prefill_data": {
					"title": "Les données fournies sont invalides",
					"subtitle": "Les informations pré-saisies fournies par Salesforce ne sont pas valides, ou sont incompatibles.",
					"details": "Détails : ",
					"fields": {
						"goodsCategory": "Catégorie de marchandises",
						"paymentInterval": "Intervalle de paiement",
						"paymentDelay": "Délai de paiement",
						"registrationCountry": "Pays d’enregistrement",
						"storeUrl": "URL de la boutique",
						"mainSellingCountry": "Pays de vente principal",
						"products": "Produits",
						"products_item": "Produit {index}",
						"products_item_yearlyAcquiredVolume": "Produit {index} - volume annuel acquis",
						"products_item_sellingCountry": "Produit {index} - pays de vente",
						"products_item_productName": "Produit {index} - nom",
						"products_item_channels": "Produit {index} - canaux",
						"products_item_channels_item": "Produit {index} - canal"
					},
					"error_types": {
						"fallback": "n’est pas valide",
						"any": {
							"required": "est obligatoire et aucun(e) n’a été indiqué(e)"
						}
					}
				},
				"selling_countries": {
					"title": "Veuillez indiquer tous les pays de vente",
					"subtitle": "La liste complète des pays est requise pour l’évaluation des risques",
					"select": {
						"label": "Rechercher un pays"
					},
					"selected": {
						"label": "Pays sélectionnés :"
					},
					"fields": {
						"selling_countries": {
							"label": "Sélectionner un pays",
							"errors": {
								"invalid": "Vous devez sélectionner au moins un pays"
							}
						}
					},
					"clear": "Effacer tout",
					"buttons": {
						"next": "Suivant",
						"back": "Retour"
					}
				},
				"main_selling_country": {
					"title": "Quel est le principal marché Klarna pour le commerçant ?",
					"subtitle": "Veuillez sélectionner le marché présentant le volume Klarna attendu le plus élevé",
					"errors": {
						"invalid": "Vous devez sélectionner un pays"
					},
					"buttons": {
						"next": "Suivant",
						"back": "Retour"
					}
				},
				"fca_number": {
					"title": "Veuillez saisir le numéro FCA",
					"subtitle": "Nous sommes légalement tenus de vérifier la licence du courtier de crédit.",
					"fields": {
						"fca_number": {
							"label": "Numéro FCA",
							"errors": {
								"general": "Veuillez saisir un numéro FCA valide"
							}
						}
					},
					"buttons": {
						"next": "Suivant",
						"back": "Retour"
					}
				},
				"sole_trader": {
					"title": "Qui est le propriétaire de la société ?",
					"subtitle": {
						"default": [
							{
								"text": "Nous sommes légalement tenus par la directive européenne visant à lutter contre le blanchiment de capitaux ("
							},
							{
								"text": "UE 2015/849",
								"link": "https://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri=CELEX:32015L0849"
							},
							{
								"text": ")."
							}
						]
					},
					"infobox": {
						"unmanaged": "Veuillez saisir vos informations personnelles et votre adresse de résidence.",
						"managed": "Veuillez saisir les informations personnelles et l'adresse de résidence du propriétaire."
					},
					"buttons": {
						"next": "Suivant",
						"back": "Retour"
					},
					"fields": {
						"are_you_the_sole_trader": {
							"label": "La personne qui réalise la candidature fait office de commerçant individuel",
							"error": "Nous sommes désolés, vous ne pouvez continuer que si vous êtes la personne à l’origine de la candidature en tant que commerçant individuel."
						}
					},
					"address_form": {
						"question": {
							"title": {
								"unmanaged": "Gérez-vous votre société depuis une adresse différente ?",
								"managed": "Cette société opère-t-elle depuis une adresse différente ?"
							},
							"subtitle": {
								"unmanaged": "Ne choisissez Oui que si vous gérez votre société depuis une adresse différente de votre adresse de résidence.",
								"managed": "Choisissez Oui uniquement si cette société gère son activité à partir d’une adresse différente de l’adresse de résidence du commerçant individuel."
							}
						},
						"title": "Veuillez indiquer l’adresse d’activité",
						"fields": {
							"street": {
								"label": "Adresse",
								"errors": {
									"general": "Veuillez indiquer une adresse valide"
								}
							},
							"postal_code": {
								"label": "Code postal",
								"errors": {
									"general": "Veuillez indiquer un code postal valide"
								}
							},
							"city": {
								"label": "Ville",
								"errors": {
									"general": "Veuillez indiquer une ville valide"
								}
							},
							"country": {
								"label": "Pays",
								"errors": {
									"general": "Veuillez indiquer un pays valide"
								}
							}
						}
					}
				},
				"sole_trader_confirmation": {
					"title": "Pouvez-vous encore confirmer deux informations ?",
					"subtitle": "",
					"fields": {
						"are_you_the_sole_trader": {
							"title": "Vous êtes un commerçant individuel",
							"label": "La personne qui réalise la candidature fait office de commerçant individuel"
						},
						"are_you_the_only_with_financial_control": {
							"title": "Vous êtes le/la seul(e) à exercer un contrôle financier",
							"label": "Le propriétaire est la seule personne qui exerce un contrôle financier sur le(s) compte(s) bancaire(s) de votre société"
						}
					},
					"buttons": {
						"next": "Suivant",
						"back": "Retour"
					},
					"robot_message": "Nous sommes désolés, nous devons confirmer ces deux informations"
				},
				"underwriting_info": {
					"title": "Veuillez préciser le volume et le délai de paiement de l’opportunité",
					"subtitle": "Veuillez indiquer le volume annuel global attendu de Klarna pour cette opportunité sur tous les marchés ainsi que le délai de paiement. Dans le cas où le délai de paiement varie selon le pays, utilisez celui du pays de vente principal sélectionné.",
					"fields": {
						"yearly_acquired_volume": {
							"label": "Volume annuel total du marché (en SEK)",
							"errors": {
								"invalid": "Le volume annuel total du marché doit être un montant positif en SEK",
								"too_long": "Le volume annuel total du marché ne peut pas comporter plus de 16 chiffres"
							}
						},
						"payment_delay": {
							"label": "Délai de paiement",
							"errors": {
								"general": "Veuillez indiquer une valeur de délai de paiement",
								"invalid": "Le délai de paiement doit être un nombre compris entre {min} et {max}"
							}
						},
						"payment_interval": {
							"label": "Intervalle de paiement",
							"errors": {
								"invalid": "Vous devez sélectionner l’une des options"
							}
						},
						"volume_by_card": {
							"label": "Part du paiement (%)",
							"errors": {
								"invalid": "La part du paiement doit être un nombre compris entre 0 et 100",
								"invalid_hint": "Veuillez ajouter la part du volume des transactions par carte sur le volume total de Klarna pour cette opportunité. Entrez 0 % si votre opportunité n'a réalisé aucun paiement par carte"
							}
						},
						"average_order_value": {
							"label": "Valeur de commande moyenne (en SEK)"
						}
					},
					"buttons": {
						"back": "Retour",
						"next": "Suivant"
					}
				},
				"store_details": {
					"title": {
						"unmanaged": {
							"default": "Quelles sont les coordonnées de votre boutique ?"
						},
						"managed": "Quelles sont les coordonnées de la boutique ?"
					},
					"subtitle": {
						"unmanaged": {
							"US": "Nous utiliserons ces informations pour créer le compte de votre entreprise.",
							"default": "Nous utiliserons les informations fournies comme coordonnées principales et examinerons votre boutique."
						},
						"managed": "Nous utiliserons les informations fournies comme coordonnées principales pour les clients et examinerons la boutique."
					},
					"fields": {
						"store_name": {
							"label": {
								"CA": "Nom de marque/En activité sous la raison sociale",
								"MX": "Nom de marque/En activité sous la raison sociale",
								"US": "Nom de marque/En activité sous la raison sociale",
								"default": "Nom de la boutique"
							},
							"errors": {
								"required": "Le nom de la boutique est obligatoire",
								"required_us": "Le Nom de marque/En activité sous la raison sociale est requis",
								"invalid": "Veuillez saisir un nom de magasin de min. 2 caractères",
								"invalid_us": "Veuillez saisir un nom de marque/DBA de min. 2 caractères",
								"invalid_characters": "Le nom de la boutique ne peut pas contenir les caractères suivants : < >",
								"invalid_characters_us": "Le nom de la marque/DBA ne peut pas contenir les caractères suivants : < >"
							}
						},
						"website": {
							"label": "Site Web de la boutique en ligne",
							"errors": {
								"required": "Le site Web est obligatoire",
								"invalid": "Veuillez saisir une URL de site Web valide"
							}
						},
						"goods_category": {
							"label": "Catégorie principale des marchandises vendues",
							"errors": {
								"required": "La catégorie de marchandises est requise"
							}
						},
						"email": {
							"label": "Adresse électronique de l'assistance client",
							"errors": {
								"required": "Une adresse e-mail de service client est requise",
								"invalid": "Veuillez saisir une adresse e-mail valide"
							}
						}
					},
					"buttons": {
						"next": "Suivant",
						"back": "Modifier les produits"
					}
				},
				"uk_company_details": {
					"title": {
						"unmanaged": "Quelle est votre adresse d’activité enregistrée ?",
						"managed": "Quelle est l’adresse d’activité enregistrée pour la société ?"
					},
					"subtitle": {
						"unmanaged": "Nous avons besoins de savoir à quelle adresse votre société est enregistrée.",
						"managed": "Nous avons besoins de savoir à quelle adresse la société est enregistrée."
					},
					"question": {
						"title": {
							"unmanaged": "Gérez-vous votre société depuis une adresse différente ?",
							"managed": "Cette société opère-t-elle depuis une adresse différente ?"
						},
						"subtitle": {
							"unmanaged": "Ne choisissez Oui que si vous gérez votre société depuis une adresse différente de l’adresse d’activité enregistrée.",
							"managed": "Ne choisissez Oui que si cette société gère son activité depuis une adresse différente de l’adresse d’activité enregistrée."
						}
					},
					"toggle": {
						"title": "Ajouter l’adresse du lieu d’activité principal"
					},
					"fields": {
						"company_name": {
							"label": "Nom légal de la société",
							"errors": {
								"general": "Veuillez indiquer une raison sociale"
							}
						},
						"street": {
							"label": "Adresse",
							"errors": {
								"general": "Veuillez indiquer une adresse"
							}
						},
						"postal_code": {
							"label": "Code postal",
							"errors": {
								"general": "Veuillez indiquer un code postal"
							}
						},
						"city": {
							"label": "Ville",
							"errors": {
								"general": "Veuillez indiquer une ville"
							}
						},
						"country": {
							"label": "Pays",
							"errors": {
								"general": "Veuillez indiquer un pays"
							}
						}
					},
					"buttons": {
						"next": "Suivant",
						"back": "Retour"
					},
					"messages": {
						"lookup": "S’agit-il de votre société ? Veuillez vérifier et confirmer si ces informations sont correctes."
					}
				},
				"uk_sole_trader": {
					"title": "Qui est le propriétaire de cette société ?",
					"subtitle": {
						"unmanaged": "Vous êtes sur le point de conclure un contrat avec Klarna. Par conséquent, nous devons recueillir vos informations personnelles.",
						"managed": "Nous sommes tenus de recueillir et de vérifier les informations personnelles du propriétaire."
					},
					"buttons": {
						"next": "Suivant",
						"back": "Retour"
					},
					"address_form": {
						"question": {
							"title": {
								"unmanaged": "Gérez-vous votre société depuis une adresse différente ?",
								"managed": "Cette société opère-t-elle depuis une adresse différente ?"
							},
							"subtitle": {
								"unmanaged": "Ne choisissez Oui que si vous gérez votre société depuis une adresse différente de votre adresse de résidence.",
								"managed": "Choisissez Oui uniquement si cette société gère son activité à partir d’une adresse différente de l’adresse de résidence du commerçant individuel."
							}
						},
						"title": "Veuillez indiquer l’adresse d’activité",
						"fields": {
							"street": {
								"label": "Adresse",
								"errors": {
									"general": "Veuillez indiquer une adresse valide"
								}
							},
							"postal_code": {
								"label": "Code postal",
								"errors": {
									"general": "Veuillez indiquer un code postal valide"
								}
							},
							"city": {
								"label": "Ville",
								"errors": {
									"general": "Veuillez indiquer une ville valide"
								}
							},
							"country": {
								"label": "Pays",
								"errors": {
									"general": "Veuillez indiquer un pays valide"
								}
							}
						}
					}
				},
				"us_sole_proprietorship": {
					"title": "Qui est le propriétaire de la société ?",
					"subtitle": {
						"default": "En tant qu'établissement financier, nous sommes légalement tenus de recueillir ces informations."
					},
					"infobox": {
						"unmanaged": "Veuillez saisir vos informations personnelles et votre adresse de résidence.",
						"managed": "Veuillez saisir les informations personnelles et l'adresse de résidence du propriétaire."
					},
					"buttons": {
						"next": "Suivant",
						"back": "Retour"
					},
					"address_form": {
						"question": {
							"title": {
								"unmanaged": "Gérez-vous votre société depuis une adresse différente ?",
								"managed": "Cette société opère-t-elle depuis une adresse différente ?"
							},
							"subtitle": {
								"unmanaged": "Ne choisissez Oui que si vous gérez votre société depuis une adresse différente de votre adresse de résidence.",
								"managed": "Choisissez Oui uniquement si cette société gère son activité à partir d’une adresse différente de l’adresse de résidence du commerçant individuel."
							}
						},
						"title": "Veuillez indiquer l’adresse d’activité",
						"fields": {
							"street": {
								"label": "Adresse",
								"errors": {
									"general": "Veuillez indiquer une adresse valide"
								}
							},
							"postal_code": {
								"label": "Code postal",
								"errors": {
									"general": "Veuillez indiquer un code postal valide"
								}
							},
							"city": {
								"label": "Ville",
								"errors": {
									"general": "Veuillez indiquer une ville valide"
								}
							},
							"country": {
								"label": "Pays",
								"errors": {
									"general": "Veuillez indiquer un pays valide"
								}
							},
							"region": {
								"label": "État",
								"errors": {
									"general": "Veuillez indiquer un État"
								}
							}
						}
					}
				},
				"ultimate_beneficial_owner": {
					"title": {
						"default": "Y a-t-il des personnes qui détiennent plus de 25 % de la société ?"
					},
					"subtitle": {
						"AU": [
							{
								"text": "En tant qu'établissement financier, nous sommes légalement tenus de recueillir ces informations."
							}
						],
						"default": [
							{
								"text": "Nous devons connaître les personnes qui détiennent plus de 25 % des actions ou des droits de vote de la société, ou qui exercent un contrôle similaire. Nous sommes légalement tenus de recueillir ces informations par la directive européenne relative au blanchiment de capitaux ("
							},
							{
								"text": "UE 2015/849",
								"link": "https://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri=CELEX:32015L0849"
							},
							{
								"text": ")."
							}
						]
					},
					"infobox": {
						"default": "Veuillez saisir les informations personnelles et l'adresse de résidence de chaque personne.",
						"AU": "Veuillez saisir les informations personnelles et l'adresse de résidence de chaque personne. Il doit s’agir de personnes physiques pour les entreprises présentant une structure de propriété complexe."
					},
					"buttons": {
						"next": "Suivant",
						"back": "Retour",
						"add_person": "+ Ajouter une personne"
					},
					"messages": {
						"lookup": "Ces personnes détiennent-elles plus de 25 % de votre société ? Veuillez vérifier et confirmer si ces informations sont correctes."
					}
				},
				"us_company_details": {
					"title": {
						"unmanaged": "Quelle est l'adresse de votre entreprise ?",
						"managed": "Quelle est l’adresse d’activité enregistrée de la société ?"
					},
					"subtitle": {
						"unmanaged": "C'est ici que votre entreprise est légalement enregistrée, et qu'elle apparaîtra sur les factures de vos clients Klarna.",
						"managed": "Nous avons besoins de savoir à quelle adresse la société est enregistrée."
					},
					"question": {
						"title": {
							"unmanaged": "Gérez-vous votre société depuis une adresse différente ?",
							"managed": "Cette société opère-t-elle depuis une adresse différente ?"
						},
						"subtitle": {
							"unmanaged": "Ne choisissez Oui que si vous gérez votre société depuis une adresse différente de l’adresse d’activité enregistrée.",
							"managed": "Ne choisissez Oui que si cette société gère son activité depuis une adresse différente de l’adresse d’activité enregistrée."
						}
					},
					"toggle": {
						"title": "Ajouter l’adresse du lieu d’activité principal"
					},
					"fields": {
						"company_name": {
							"label": "Raison sociale enregistrée",
							"errors": {
								"general": "Veuillez indiquer une raison sociale"
							}
						},
						"street": {
							"label": "Adresse",
							"errors": {
								"general": "Veuillez indiquer une adresse"
							}
						},
						"postal_code": {
							"label": "Code postal",
							"errors": {
								"general": "Veuillez indiquer un code postal"
							}
						},
						"city": {
							"label": "Ville",
							"errors": {
								"general": "Veuillez indiquer une ville"
							}
						},
						"country": {
							"label": "Pays",
							"errors": {
								"general": "Veuillez indiquer un pays"
							}
						},
						"state_of_incorporation": {
							"label": "État d’enregistrement",
							"errors": {
								"general": "Veuillez indiquer un État d’enregistrement"
							}
						},
						"state": {
							"label": "État",
							"errors": {
								"general": "Veuillez indiquer un État"
							}
						},
						"region": {
							"label": "Région",
							"errors": {
								"puerto_rico": "Porto Rico n’est pas autorisé"
							}
						}
					},
					"buttons": {
						"next": "Suivant",
						"back": "Retour"
					}
				},
				"select_products": {
					"title": "Nos services",
					"title_kco_hidden": "Des moyens de paiement qui augmentent les ventes.",
					"subtitle": "Choisissez les services qui vous intéressent.",
					"subtitle_kco_hidden": "Débloquez le pouvoir d'achat de vos clients. Proposez plus de moyens de paiement afin qu'ils décident quand et comment payer.",
					"platform_alert": null,
					"buttons": {
						"next": "Suivant"
					}
				},
				"signup_products": {
					"title_line_1": "Les produits Klarna pour votre boutique.",
					"title_kco_hidden_line_1": "Des moyens de paiement qui",
					"title_kco_hidden_line_2": "augmentent les ventes.",
					"subtitle": "En proposant les solutions de paiement de Klarna, vous bénéficiez en moyenne d'une augmentation de 30 % du taux de conversion, de 41 % du panier moyen et de 36 % de la fréquence d'achat.",
					"subtitle_kco_hidden": "Débloquez le pouvoir d'achat de vos clients. Proposez plus de moyens de paiement afin qu'ils décident quand et comment payer.",
					"info_block": "Affichage des produits disponibles pour",
					"special_offer": "Offre spéciale :  {percentageFee} % + {fixedFee} par transaction. Valable jusqu'au {validUntil}.",
					"buttons": {
						"contact_sales": "Contacter un représentant des ventes",
						"next": "Créer un compte",
						"back": "Retour"
					}
				},
				"questionnaire": {
					"buttons": {
						"back": "Retour",
						"next": "Suivant"
					}
				},
				"business_concepts": {
					"title": "Veuillez sélectionner les concepts d’affaires applicables.",
					"subtitle": "Veuillez sélectionner uniquement ce qui s'applique. Il peut y avoir plusieurs réponses.",
					"errors": {
						"select_at_least_one": "Veuillez sélectionner au moins un concept d’affaires."
					},
					"buttons": {
						"next": "Suivant",
						"back": "Retour"
					}
				},
				"confirm_copy": {
					"title": "Confirmer la copie",
					"disclaimer": "Les informations existantes éventuelles dans le MID actuel seront remplacées par les données de/du",
					"merchant_id": "{mid}",
					"buttons": {
						"skipCopy": "Ne pas copier",
						"confirmCopy": "Copier les données"
					}
				},
				"pre_assessment_summary": {
					"title": "Synthèse",
					"subtitle": "Veuillez vérifier attentivement les données avant de les soumettre en vue de la souscription",
					"banner": {
						"mcc_deal": "Il s’agit d’une transaction MCC. Veuillez suivre la procédure de remontée MCC/ECC"
					},
					"selling_countries": {
						"title": "Veuillez sélectionner le marché présentant le volume attendu le plus élevé.",
						"main_selling_country": "Pays de vente principal"
					},
					"pre_assessment_products": {
						"title": "Produits"
					},
					"company_details": {
						"title": "Informations relatives à la société"
					},
					"fca_number": {
						"title": "Numéro FCA"
					},
					"high_exposure_questionnaires": {
						"title": "Questionnaires relatifs à une exposition élevée"
					},
					"mia_questionnaires": {
						"title": "Questionnaires MIA"
					},
					"buttons": {
						"back": "Retour",
						"edit": "Modifier",
						"submit": "Envoyer"
					}
				},
				"pre_assessment_overview": {
					"title": "Aperçu de la pré-évaluation",
					"subtitle_APPROVED": "Vous trouverez ci-dessous les conditions validées pour cette opportunité.",
					"subtitle_REJECTED": "Vous trouverez ci-dessous les conditions rejetées pour cette opportunité.",
					"subtitle_UNRESOLVED": "Vous avez la possibilité de modifier les informations soumises si vous repérez une erreur. Cela ne déclenche pas la création d’un nouveau dossier.",
					"status": {
						"APPROVED": "Le dossier a été validé",
						"REJECTED": "Le dossier a été rejeté",
						"UNRESOLVED": "En attente de la décision de souscription…",
						"UNRESOLVED_TIMED_OUT": "Le dossier sera soumis à une décision de souscription manuelle. Veuillez noter que cela peut prendre plusieurs jours.",
						"UNRESOLVED_TIMED_OUT_LINK_LABEL": "Afficher le dossier dans l'interface utilisateur graphique Merchant Review",
						"STARTED": "Le dossier est en cours d’examen"
					},
					"buttons": {
						"change": "Changer",
						"new_case": "Nouveau dossier"
					}
				},
				"recollection_introduction": {
					"title": {
						"default": "Bonjour !"
					},
					"subtitle": {
						"default": [
							{
								"text": "En tant que société réglementée sous le contrôle de l'autorité de surveillance financière suédoise, Klarna doit prévenir le blanchiment de capitaux, comme le prévoit la directive européenne EU 2015/849 (telle que modifiée ou remplacée). Pour vous, en tant que marchand, cela signifie que Klarna collecte des informations sur les personnes qui dirigent votre société (les propriétaires bénéficiaires) avant que vous ne puissiez commencer à utiliser les services Klarna. Les marchands existants sont tenus de fournir ces informations de façon régulière afin de garantir qu'elles sont à jour. Retrouvez plus d'informations dans la directive européenne"
							},
							{
								"text": "ici",
								"link": "https://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri=CELEX:32015L0849"
							},
							{
								"text": "."
							}
						]
					},
					"buttons": {
						"next": "Suivant"
					}
				},
				"recollection_confirmation": {
					"title": "Confirmation",
					"subtitle": "Veuillez vérifier attentivement les données avant de les soumettre en vue de la souscription",
					"stakeholder": "Partie prenante {index}",
					"buttons": {
						"back": "Retour",
						"submit": "Envoyer"
					}
				},
				"recollection_overview": {
					"title": "Merci !",
					"subtitle": "Voici un aperçu des informations que vous avez envoyées.",
					"stakeholder": "Partie prenante {index}",
					"notice": "Vos informations ont été envoyées avec succès."
				},
				"volume_separation": {
					"title_line_1": "Quel est votre volume de ventes e-commerce ?",
					"subtitle": "Klarna dispose des meilleures solutions adaptées à votre entreprise, quelle que soit sa taille.",
					"selector_title": "Chiffre d’affaires annuel",
					"below": "Inférieur à {threshold}",
					"between": "Entre {belowThreshold} et {aboveThreshold}",
					"over": "Supérieur à {threshold}",
					"buttons": {
						"back": "Retour"
					}
				},
				"basic_info": {
					"title_line_1": "Lancez votre entreprise",
					"title_line_2": "sur la bonne voie avec Klarna.",
					"subtitle": "Nous avons besoin de quelques informations de base pour pouvoir continuer.",
					"fields": {
						"email": {
							"label": "Adresse e-mail professionnelle",
							"field_link": "Vous n'êtes pas une entreprise ?",
							"errors": {
								"required": "L'adresse électronique est obligatoire",
								"invalid": "Veuillez saisir une adresse électronique valide"
							}
						},
						"email_confirmation": {
							"label": "Confirmer l'adresse e-mail professionnelle",
							"tooltip": "Votre adresse e-mail professionnelle sera la principale méthode de communication avec Klarna. Assurez-vous qu'elle soit correcte",
							"errors": {
								"required": "Vous devez confirmer l'adresse e-mail",
								"invalid": "Veuillez vérifier que vous avez saisi deux fois la même adresse e-mail"
							}
						},
						"website": {
							"label": "URL de commerce électronique",
							"errors": {
								"required": "L'URL de commerce électronique est requise",
								"invalid": "Veuillez saisir une URL valide"
							}
						},
						"country": {
							"label": "Pays d'enregistrement",
							"errors": {
								"general": "Veuillez sélectionner l'un des pays disponibles"
							}
						}
					},
					"buttons": {
						"continue": "Continuer"
					}
				},
				"contact_details": {
					"title_line_1": "Venez nous parler.",
					"subtitle": "Remplissez ce formulaire et nous vous recontacterons dès que possible avec des solutions adaptées à votre entreprise.",
					"fields": {
						"full_name": {
							"label": "Nom complet",
							"errors": {
								"required": "Le nom complet est requis"
							}
						},
						"phone": {
							"label": "Numéro de téléphone",
							"tooltip": "Veuillez inclure le code du pays, par exemple +1 541 754 3010",
							"errors": {
								"required": "Le numéro de téléphone est requis",
								"invalid": "Numéro de téléphone non valide"
							}
						},
						"tell_us_more": {
							"label": "Dites-nous-en plus à propos de votre entreprise (facultatif)"
						}
					},
					"buttons": {
						"back": "Retour",
						"submit": "Transmettre les coordonnées"
					}
				},
				"contact_received": {
					"title": "À bientôt !",
					"message_1": "Notre équipe de vente vous contactera dès que possible.",
					"message_2": "Notre équipe vous contactera dès que possible. Nous avons également envoyé une confirmation des informations transmises à l'adresse"
				},
				"we_are_sorry": {
					"title": "Nous sommes désolés. Nous ne pouvons pas accepter votre candidature à ce stade.",
					"message_1_unsupported_country": "Klarna ne prend pour l'instant pas en charge votre pays sélectionné :",
					"message_1_sensitive_goods": "Klarna ne prend pas en charge la catégorie de marchandises sélectionnée :",
					"message_1_platform": "Klarna ne prend pas en charge la plateforme de commerce électronique que vous avez sélectionnée :",
					"message_2": "Nous cherchons toujours à créer de nouveaux partenariats, donc nous vous contacterons dès que nous pourrons continuer avec votre application à l'avenir.",
					"platform_alert": {
						"jtl4": [
							{
								"text": "Vous pouvez toujours utiliser le"
							},
							{
								"text": "plugin",
								"link": "https://www.mollie.com/de/integrations/jtl"
							},
							{
								"text": "de notre partenaire Mollie."
							}
						]
					}
				},
				"platform": {
					"title_line_1": "Quelle plateforme utilisez-vous ?",
					"subtitle": "Sélectionnez votre plateforme de commerce électronique et nous y intégrerons votre entreprise en un rien de temps.",
					"custom": "Intégration auto-développée",
					"other_platform": "Autres solutions d'intégration",
					"platform_search": {
						"label": "Plateforme de commerce électronique",
						"no_match": "Aucun résultat trouvé pour « {input} »"
					},
					"buttons": {
						"back": "Retour"
					}
				},
				"partner": {
					"title_line_1": "Quel partenaire de service de paiement voudriez-vous intégrer ?",
					"subtitle": "Choisissez le partenaire de service de paiement qui répond le mieux à vos besoins."
				},
				"account_creation_loading": {
					"title": "Création de votre compte en cours...",
					"message": "Configuration de votre identifiant d'entreprise en cours..."
				},
				"application_checking": {
					"title": "Vérification de votre candidature en cours...",
					"message": "Analyse des données de la boutique en cours"
				},
				"application_review": {
					"title": "Nous avons analysé votre candidature.",
					"title_approved": "Votre candidature a été approuvée !",
					"message": "Il s'agit d'un processus manuel, le délai de traitement peut donc varier mais nous nous en occuperons aussi vite que possible.",
					"email_info_1": "Nous vous avons envoyé un e-mail avec comme objet « {subject} ».",
					"email_info_2": "Suivez-y les étapes pour vous connecter et suivre le statut de votre candidature.",
					"email_info_2_approved": "Suivez-y les étapes pour vous connecter et intégrer Klarna à votre boutique de commerce en ligne.",
					"email_subject": "Bienvenue sur le portail des marchands de Klarna",
					"resend_email": "Renvoyer l'e-mail"
				},
				"user_already_exists": {
					"title": "Connectez-vous au portail des marchands pour continuer.",
					"message_1": "Cette adresse e-mail est déjà connectée avec un compte du portail des marchands. Pour apporter des modifications à votre compte existant, veuillez vous connecter",
					"log_in": "Se connecter au portail des marchands",
					"forgot_password": "Mot de passe oublié ?"
				},
				"otherPlatform": {
					"info": "Nous avons déjà réalisé l'intégration de {platform}",
					"link": "Commencez l'intégration ici",
					"title": "Smoooth, vous pouvez l'intégrer directement !",
					"info2": "Bonne nouvelle ! Vous pouvez intégrer Klarna à votre boutique en ligne directement depuis  <strong>{platform}</strong>.",
					"link2": "Aller à {platform} + intégration Klarna"
				},
				"noLandingPagePlatform": {
					"text": {
						"one": {
							"default": "Veuillez contacter directement notre équipe de vente",
							"SE": "Veuillez contacter directement notre équipe de vente à l'adresse/au"
						}
					}
				},
				"sensitive_goods": {
					"title_2": "Proposez-vous l’un ou plusieurs des produits ou services suivants ?",
					"subtitle_2": "Klarna se réserve le droit de restreindre la vente de certains produits/services en fonction du marché, des lois, du volume de ventes, de la propension au risque et d’autres limitations qui peuvent être autorisées. Ceux-ci ne seront pas traités sans l’accord de Klarna.",
					"titleV2": "Choisissez parmi les catégories suivantes celle qui s’applique à votre entreprise.",
					"goodsCategories": {
						"CBD_HEMP_TOBACCO_ECIGARETTES_VAPE": {
							"title_2": "Produits interdits aux mineurs",
							"description_2": "Tabac, cigarettes électroniques, produits à base de cannabis, alcool, contenu adulte"
						},
						"EVENTS_TICKETS_TOURISM_TRAVEL_VOUCHERS": {
							"title_2": "Voyages, visites guidées et événements",
							"description_2": "Transports, événements, plateformes de vente de billets, hôtels ou logements, locations, agences de voyage"
						},
						"WEAPONS_AMMUNITION": {
							"title_2": "Armes nécessitant un permis",
							"description_2": "Munitions, couteaux de combat, équipement de chasse, matraques, sprays au poivre"
						},
						"MARKETPLACE": {
							"title_2": "Marchés pair à pair",
							"description_2": "Services qui permettent à des tiers de revendre leurs biens ou d’offrir des services via une plateforme en ligne"
						},
						"PHARMACEUTICALS": {
							"title_2": "Services pharmaceutiques et médicaux",
							"description_2": "Distribution de médicaments sur ordonnance, procédures médicales, y compris liées à l’esthétique et aux tatouages"
						},
						"SERVICES_SUBSCRIPTIONS_MEMBERSHIPS_RENTALS_CONTENT": {
							"title_2": "Services d’adhésion, d’abonnement et autres services similaires",
							"description_2": "Services d’abonnement à des biens physiques, du contenu numérique, des services de streaming, des sites de rencontre, etc."
						},
						"NONE": {
							"title_2": "Je propose un autre type de produits/services"
						}
					},
					"link": "En savoir plus sur les produits/services restreints",
					"buttons": {
						"next": "Suivant",
						"continue": "Continuer"
					}
				}
			},
			"address_form_component": {
				"postal_code": {
					"tooltip": {
						"default": "Saisissez votre code postal pour remplir automatiquement les autres parties de votre adresse",
						"US": "Saisissez votre code ZIP pour remplir automatiquement les autres parties de votre adresse"
					},
					"label": {
						"default": "Code postal",
						"US": "Code postal"
					},
					"error": {
						"default": "Veuillez saisir un code postal valide",
						"US": "Veuillez saisir un code postal valide"
					}
				},
				"city": {
					"label": "Ville",
					"error": "Veuillez saisir une ville"
				},
				"street": {
					"label": "Adresse",
					"error": "Veuillez saisir une adresse",
					"tooltip": "Commencez à saisir votre recherche pour afficher des suggestions de rues",
					"no_suggestion_found": "Aucun résultat pour {input}"
				},
				"country": {
					"label": "Pays",
					"error": "Veuillez sélectionner un pays"
				},
				"region": {
					"label": "État/région (facultatif)"
				},
				"state": {
					"label": "État",
					"error": "Veuillez saisir un État"
				}
			},
			"platforms": {
				"custom": "Intégration de l'API",
				"other": "Je ne trouve pas ma plateforme"
			},
			"buttons": {
				"back": "Retour"
			},
			"products": {
				"not_available": "Non disponible sur {reason}",
				"not_available_country": "Non disponible dans votre pays",
				"not_available_platform": "Non disponible sur {platform}",
				"why_product": "Pourquoi Klarna {name}",
				"kco_one": {
					"name": {
						"default": "Checkout"
					},
					"description": {
						"default": "Remplacez la caisse de votre magasin par les services de caisse complets de Klarna."
					},
					"description_expanded": {
						"default": "Remplacez la caisse de votre magasin par les services de caisse complets de Klarna."
					},
					"options": {
						"kco_one-pay-now": {
							"name": {
								"default": "Payer maintenant"
							},
							"description": {
								"default": "Proposer des paiements instantanés par carte ou virement."
							}
						},
						"kco_one-pay-later": {
							"name": {
								"default": "Payer sous 30 jours"
							},
							"description": {
								"default": "Proposer un paiement sous 30 jours. Sans intérêts."
							}
						},
						"kco_one-slice-it": {
							"name": {
								"default": "Financement"
							},
							"description": {
								"default": "Proposer un paiement sous 6 à 36 mois.",
								"DE": "Proposer un paiement sous 6 à 24 mois.",
								"AT": "Proposer un paiement sous 6 à 24 mois."
							}
						},
						"kco_one-slice-it-in-3": {
							"name": {
								"default": "Versements"
							},
							"description": {
								"default": "Proposer un paiement en 3 fois sans intérêts.",
								"GB": "Proposer un paiement en 3 fois sans intérêts."
							}
						},
						"kco_one-slice-it-in-4": {
							"name": {
								"default": "Payer en 4",
								"US": "Versements",
								"AU": "Payer en 4 fois"
							},
							"description": {
								"default": "Proposer un paiement en 4 fois sans intérêts.",
								"GB": "Proposer un paiement en 4 fois sans intérêts."
							}
						}
					},
					"features": {
						"other_payment_options": {
							"name": {
								"default": "Autres options de paiement"
							},
							"description": {
								"default": "Cartes de crédit, cartes de débit et autres"
							}
						},
						"on_site_messaging": {
							"name": {
								"default": "Messages intégrés"
							}
						},
						"billing": {
							"name": {
								"default": "Identification et facturation automatiques"
							}
						},
						"shipping": {
							"name": {
								"default": "Options d’expédition personnalisées"
							}
						},
						"post_purchase": {
							"name": {
								"default": "Assistance après-vente"
							}
						}
					}
				},
				"kp_one": {
					"name": {
						"default": "Méthode de paiement"
					},
					"description": {
						"default": "Ajoutez les méthodes de paiement Klarna à votre caisse existante"
					},
					"description_expanded": {
						"default": "En proposant les solutions de paiement de Klarna, vous bénéficiez en moyenne d'une augmentation de 30 % du taux de conversion, de 41 % du panier moyen et de 36 % de la fréquence d'achat."
					},
					"options": {
						"kp_one-pay-now": {
							"name": {
								"default": "Payer maintenant"
							},
							"description": {
								"default": "Proposer des paiements instantanés par carte ou virement."
							}
						},
						"kp_one-pay-later": {
							"name": {
								"default": "Payer sous 30 jours"
							},
							"description": {
								"default": "Les clients paient 30 jours après l’achat, sans intérêts."
							}
						},
						"kp_one-slice-it": {
							"name": {
								"default": "Financement"
							},
							"description": {
								"default": "Les clients peuvent payer en 6 à 36 mois.",
								"DE": "Les clients peuvent payer en 6 à 24 mois",
								"AT": "Les clients peuvent payer en 6 à 24 mois."
							}
						},
						"kp_one-slice-it-in-3": {
							"name": {
								"default": "Versements"
							},
							"description": {
								"default": "Proposer un paiement en 3 fois sans intérêts.",
								"GB": "Proposer un paiement en 3 fois sans intérêts."
							}
						},
						"kp_one-slice-it-in-4": {
							"name": {
								"default": "Payer en 4",
								"US": "4 paiements",
								"CA": "4 paiements",
								"AU": "Payer en 4 fois"
							},
							"description": {
								"default": "Proposer un paiement en 4 fois sans intérêts.",
								"GB": "Proposer un paiement en 4 fois sans intérêts.",
								"US": "Les commandes de 35 $ à 1000 $ peuvent être payées en 4 fois sans intérêts, toutes les 2 semaines.",
								"CA": "Toute commande d’une valeur comprise entre 35 $ et 1 000 $ peut être divisée en 4 paiements sans intérêts, à rembourser toutes les 2 semaines."
							}
						},
						"kp_one-pay-by-card": {
							"name": {
								"default": "Payer par carte"
							},
							"description": {
								"default": "Proposer des paiements instantanés par carte ou virement."
							}
						}
					}
				}
			}
		},
		"fields": {
			"enm": {
				"product_channel": {
					"label": "Comment envisagez-vous vos ventes ?",
					"options": {
						"IN_STORE": "Magasin physique",
						"TELESALES": "Ventes à distance"
					},
					"description": {
						"IN_STORE": "Les ventes sont principalement effectuées en personne et le client reçoit les articles immédiatement.",
						"TELESALES": "Les ventes sont principalement effectuées par téléphone suite à un appel entrant du client. Le client ne reçoit pas les articles immédiatement."
					}
				},
				"country": {
					"label": "Pays"
				},
				"organization_category": {
					"label": "Type d’entité juridique",
					"options": {
						"SOLE_TRADER": "Commerçant individuel",
						"PARTNERSHIP": "Partenariat",
						"UNDEFINED": "NON DÉFINI",
						"BV": "BV",
						"CV": "CV",
						"CVOA": "CVOA",
						"EEN": "EEN",
						"MTS": "MTS",
						"NV": "NV",
						"SE": "SE",
						"VOF": "VOF",
						"C_CORP": "C Corporation",
						"S_CORP": "S Corporation",
						"TRUST_ESTATE": "Fiducie/patrimoine",
						"INDIVIDUAL": "Individuel",
						"SOLE_PROPRIETORSHIP": "Entreprise personnelle",
						"SINGLE_MEMBER_LIMITED_LIABILITY_COMPANY": "Entreprise unipersonnelle à responsabilité limitée",
						"LIMITED_LIABILITY_COMPANY": "Société à responsabilité limitée",
						"PUBLIC_LISTED_COMPANY": "Société cotée en bourse",
						"PRIVATE_COMPANY": "ENTREPRISE_PRIVÉE"
					}
				},
				"store_category": {
					"label": "Catégorie principale des marchandises vendues",
					"options": {
						"ADULT_SHOES_AND_CLOTHING": "Vêtements et chaussures - Chaussures et vêtements pour adultes",
						"AUTOMOTIVE_PARTS_AND_ACCESSORIES": "Produits automobiles - Pièces et accessoires automobiles",
						"BAGS_AND_WALLETS": "Bijoux et accessoires - Sacs et portefeuilles",
						"BODY_AND_HAIR_CARE": "Santé et beauté - Soin du corps et des cheveux",
						"BOOK_AND_MAGAZINES": "Divertissement - Livre et magazines",
						"CANDY": "Alimentation et boissons - Confiseries",
						"CAR_ELECTRONICS": "Électronique - Électronique automobile",
						"CHILDREN_CLOTHES_AND_NURTURING_PRODUCTS": "Produits pour les enfants - Vêtements pour enfants et articles de soin",
						"CHILDREN_TOYS": "Produits pour les enfants - Jouets pour enfants",
						"CLEANING_AND_SANITARY": "Maison et jardin - Nettoyage et hygiène",
						"COLLECTIBLES": "Loisirs, sport et hobbies - Collections",
						"CONCEPT_STORES_AND_MISCELLANEOUS": "Loisirs, sport et hobbies - Concept Store et divers",
						"COSMETICS": "Santé et beauté - Cosmétiques",
						"COSTUMES_AND_PARTY_SUPPLIES": "Loisirs, sport et hobbies - Costumes et articles de fête",
						"DATING_SERVICES": "Produits immatériels - Services de rencontre",
						"DECORATION_AND_ART": "Maison et jardin - Décoration et art",
						"DIETARY_SUPPLEMENTS": "Santé et beauté - Compléments alimentaires",
						"DIGITAL_SERVICES": "Produits immatériels - Services numériques",
						"DIVERSIFIED_CHILDREN_PRODUCTS": "Produits pour les enfants - Articles pour enfants variés",
						"DIVERSIFIED_ELECTRONICS": "Électronique - Articles électroniques variés",
						"DIVERSIFIED_ENTERTAINMENT": "Divertissement - Divertissements variés",
						"DIVERSIFIED_EROTIC_MATERIAL": "Articles érotiques - Articles érotiques variés",
						"DIVERSIFIED_HEALTH_AND_BEAUTY_PRODUCTS": "Santé et beauté - Articles santé et beauté variés",
						"DIVERSIFIED_HOME_AND_GARDEN_PRODUCTS": "Maison et jardin - Articles maison et jardin variés",
						"DIVERSIFIED_JEWELRY_AND_ACCESSORIES": "Bijoux et accessoires - Bijoux et accessoires variés",
						"EDUCATION": "Produits immatériels - Éducation",
						"ELECTRONIC_EQUIPMENT_AND_RELATED_ACCESSORIES": "Électronique - Équipement électronique et accessoires associés",
						"EROTIC_CLOTHING_AND_ACCESSORIES": "Articles érotiques - Vêtements et accessoires érotiques",
						"EVENT_TICKETS": "Produits immatériels - Billets pour des événements",
						"FOOD_AND_BEVERAGE": "Alimentation et boissons - Aliments et boissons",
						"FRAGRANCES": "Santé et beauté - Parfums",
						"FURNITURE": "Maison et jardin - Meubles",
						"GENERAL_SHOES_AND_CLOTHING": "Vêtements et chaussures - Chaussures et vêtements généraux",
						"HOBBY_ARTICLES": "Loisirs, sport et hobbies - Articles de loisir",
						"HOUSEHOLD_ELECTRONICS": "Électronique - Électronique domestique",
						"JEWELRY_AND_WATCHES": "Bijoux et accessoires - Bijoux et montres",
						"KITCHENWARE": "Maison et jardin - Ustensiles de cuisine",
						"MARKETPLACES": "Produits immatériels - Marchés",
						"MUSIC_AND_MOVIES": "Divertissement - Musique et films",
						"MUSICAL_INSTRUMENTS_AND_EQUIPMENT": "Loisirs, sport et hobbies - Matériel et instruments de musique",
						"NON_PRESCRIPTION_SUNGLASSES_AND_LENSES": "Bijoux et accessoires - Lunettes de soleil et lentilles sans ordonnance",
						"OFFICE_MACHINES_AND_RELATED_ACCESSORIES": "Électronique - Matériel de bureau et accessoires associés",
						"OTHER_SERVICES": "Produits immatériels - Autres services",
						"PERSONAL_CARE_AND_BODY_IMPROVEMENT": "Santé et beauté - Soins personnels et embellissement du corps",
						"PET_SUPPLIES": "Maison et jardin - Articles pour animaux domestiques",
						"PHARMACEUTICAL_PRODUCTS": "Santé et beauté - Produits pharmaceutiques",
						"PLANTS_AND_FLOWERS": "Maison et jardin - Plantes et fleurs",
						"PRESCRIPTION_OPTICS": "Santé et beauté - Optique de prescription",
						"PRINTS_AND_PHOTOS": "Loisirs, sport et hobbies - Impressions et photos",
						"SAFETY_PRODUCTS": "Maison et jardin - Produits de sécurité",
						"SEX_TOYS": "Articles érotiques - Jouets érotiques",
						"SPORTS_GEAR_AND_OUTDOOR": "Loisirs, sport et hobbies - Équipement de sport et d’extérieur",
						"TOBACCO": "Alimentation et boissons - Tabac",
						"TOOLS_AND_HOME_IMPROVEMENT": "Maison et jardin - Outils et embellissement de la maison",
						"TRAVEL_SERVICES": "Produits immatériels - Services de voyage",
						"UNDERWEAR": "Vêtements et chaussures - Sous-vêtements",
						"VIDEO_GAMES_AND_RELATED_ACCESSORIES": "Divertissement - Jeux vidéo et accessoires associés",
						"WHEELS_AND_TIRES": "Articles automobiles - Roues et pneus",
						"WINE_BEER_AND_LIQUOR": "Alimentation et boissons - Vin, bière et spiritueux",
						"YOUTHFUL_SHOES_AND_CLOTHING": "Vêtements et chaussures - Chaussures et vêtements pour les jeunes"
					}
				},
				"currency": {
					"label": "Devise"
				},
				"account_type": {
					"label": "Type de compte bancaire",
					"options": {
						"IBAN": "IBAN",
						"LOCAL_SE": "Local Suède",
						"LOCAL_US": "Local États-Unis",
						"LOCAL_GENERIC": "Local Norvège/Danemark",
						"SPECIAL": "Spécial",
						"BANKGIRO": "Local Suède Bankgiro",
						"PLUSGIRO": "Local Suède Plusgiro"
					}
				},
				"person_role": {
					"label": "Rôle",
					"options": {
						"LEGAL_REPRESENTATIVE": "Représentant légal",
						"ALTERNATIVE_BENEFICIAL_OWNER": "Bénéficiaire effectif alternatif",
						"ULTIMATE_BENEFICIAL_OWNER": "Propriétaire bénéficiaire effectif",
						"OWNER": "Propriétaire"
					}
				},
				"business_size": {
					"label": "Taille de l'entreprise",
					"options": {
						"LARGE": "grand",
						"MEDIUM": "moyen",
						"small": "petit"
					}
				},
				"sensitive_good_category": {
					"label": "Proposez-vous l’un ou plusieurs des produits ou services suivants dans votre magasin ?",
					"options": {
						"AGE_RESTRICTED_PRODUCTS": "Produits interdits aux mineurs",
						"LICENSED_WEAPONS": "Armes nécessitant un permis",
						"PHARMA_AND_MEDICAL_SERVICES": "Services pharmaceutiques et médicaux",
						"TRAVEL_TOURS_EVENTS": "Voyages, visites guidées et événements",
						"PEER_TO_PEER_MARKETPLACE": "Marchés pair à pair",
						"MEMBERSHIPS_SUBSCRIPTIONS_SERVICES": "Services d’adhésion, d’abonnement et autres services similaires",
						"NONE": "Je propose un autre type de produits/services"
					},
					"description": {
						"AGE_RESTRICTED_PRODUCTS": "Tabac, cigarettes électroniques, produits à base de cannabis, alcool, contenu adulte",
						"LICENSED_WEAPONS": "Munitions, couteaux de combat, équipement de chasse, matraques, sprays au poivre",
						"PHARMA_AND_MEDICAL_SERVICES": "Distribution de médicaments sur ordonnance, procédures médicales, y compris liées à l’esthétique et aux tatouages",
						"TRAVEL_TOURS_EVENTS": "Transports, événements, plateformes de vente de billets, hôtels ou logements, locations, agences de voyage",
						"PEER_TO_PEER_MARKETPLACE": "Services qui permettent à des tiers de revendre leurs biens ou d’offrir des services via une plateforme en ligne",
						"MEMBERSHIPS_SUBSCRIPTIONS_SERVICES": "Services d’abonnement à des biens physiques, du contenu numérique, des services de streaming, des sites de rencontre, etc.",
						"NONE": "Je propose un autre type de produits/services"
					},
					"error_message": "Nous sommes désolés. Nous ne sommes pas en mesure de traiter votre demande car nous ne prenons pas en charge actuellement le type de produit ou service que vous avez sélectionné."
				}
			},
			"common": {
				"country": {
					"label": "Pays"
				},
				"address": {
					"city": {
						"label": "Ville"
					},
					"postal_code": {
						"label": "Code postal"
					},
					"region": {
						"label": "État/région"
					},
					"street_address": {
						"label": "Adresse du magasin physique"
					},
					"street_address2": {
						"label": "Ligne d'adresse 2"
					}
				}
			},
			"payload": {
				"business_information": {
					"company_name": {
						"label": "Raison sociale"
					},
					"registration_authority": {
						"label": "Autorité d’enregistrement"
					},
					"registration_id": {
						"label": "Numéro d’enregistrement"
					},
					"subject_to_vat": {
						"label": "Votre société est-elle assujettie à la TVA ?"
					},
					"vat_id": {
						"label": "Numéro de TVA"
					},
					"persons": {
						"date_of_birth": {
							"label": "Date de naissance"
						},
						"first_name": {
							"label": "Prénom"
						},
						"last_name": {
							"label": "Nom"
						},
						"person_identity_document": {
							"label": "Document d'identité"
						},
						"person_proof_of_address": {
							"label": "Justificatif de domicile"
						},
						"personal_identifier": {
							"label": "Pièce d'identité"
						}
					},
					"should_auto_capture_orders": {
						"label": "Souhaitez-vous enregistrer automatiquement les commandes ?",
						"tooltip": "Les commandes doivent être enregistrées lors de la livraison en magasin ou de l’expédition depuis un entrepôt. En sélectionnant l’enregistrement automatique, la commande sera automatiquement enregistrée lorsque le client confirmera l’achat."
					}
				},
				"contract_entity": {
					"label": "Entité contractuelle"
				},
				"contract_onboarding_type": {
					"label": "Type d'intégration de partenaire commercial"
				},
				"underwriting_inquiry_email": {
					"label": "E-mail de souscription"
				},
				"bank_accounts": {
					"account_holder": {
						"label": "Nom du titulaire du compte"
					},
					"account_number": {
						"label": "Numéro de compte"
					},
					"bic": {
						"label": "Code BIC"
					},
					"iban": {
						"label": "Numéro de compte (IBAN)"
					},
					"is_default": {
						"label": "Utiliser ce compte pour les devises non spécifiées"
					},
					"routing_number": {
						"label": "Numéro de routage"
					}
				},
				"in_stores": {
					"contact_email": {
						"label": "Adresse e-mail"
					},
					"name": {
						"label": "Nom de la boutique"
					},
					"support_email": {
						"label": "Adresse électronique de l'assistance client"
					},
					"support_phone": {
						"label": "Numéro de téléphone de l'assistance client"
					},
					"business_concepts": {
						"options": {
							"TRADITIONAL_SALE_OF_GOODS": "Vente de marchandises classique",
							"VOUCHER": "Bon",
							"MEMBERSHIP": "Adhésion",
							"SUBSCRIPTION": "Abonnement",
							"PHARMACIES": "Pharmacies",
							"US_PHARMACIES": "Pharmacies aux États-Unis",
							"MEDICAL_SERVICES": "Services médicaux",
							"MARKETPLACES": "Marketplaces",
							"FIREARM_DEALERS": "Revendeur d’armes à feu",
							"AUCTIONS": "Enchères",
							"ALCOHOL": "Alcool",
							"TOBACCO": "Tabac",
							"HEMP_CBD_THC": "Marijuana, CBD ou THC",
							"DONATIONS_CHARITY": "Dons et charité",
							"TRAVEL": "Voyage",
							"EVENTS": "Événements",
							"COURSES": "Formations",
							"EDUCATIONAL_COURSES": "Cours éducatifs",
							"FOOD_DELIVERY": "Livraison de nourriture",
							"CUSTOMISED_PRE_ORDER_FURNITURE": "Pré-commande personnalisée/Mobilier",
							"DIGITAL_CONTENT": "Contenu numérique",
							"GAMING_INDUSTRY": "Industrie du jeu (jeux d'argent, paris, casinos, lotteries)"
						}
					}
				},
				"terms_and_conditions": {
					"default": "Conditions générales",
					"UPSELL_WEBSTORE_TO_KPOS": "Conditions d’utilisation de Klarna en magasin"
				},
				"pricing_terms": {
					"default": "Conditions de tarification",
					"UPSELL_WEBSTORE_TO_KPOS": "Tarification pour Klarna en magasin"
				}
			}
		},
		"group": {
			"title": {
				"additional_data": "Informations supplémentaires",
				"bank_account": "Quelles sont vos données de compte bancaire ?",
				"business_size": "Quel est votre volume de vente annuel attendu avec Point of Sale de Klarna ?",
				"in_store_get_started": "Lancez votre entreprise avec Klarna.",
				"in_store_legal_form": "Quel type d’activité exercez-vous ?",
				"in_store_registered_address": "Quelle est votre adresse enregistrée ?",
				"in_store_registration": "Votre société est-elle une entreprise enregistrée ?",
				"in_store_stakeholder": "Qui dirige la société ?",
				"in_store_stores": "Quelles sont les coordonnées de votre magasin pour Point of Sale de Klarna ? ",
				"in_store_vat": "Votre société est-elle assujettie à la TVA ?",
				"product_channel": "Comment votre entreprise prévoit-elle d'utiliser Point of Sale de Klarna ?",
				"sensitive_goods": "Quelle catégorie de produits comptez-vous vendre avec Point of Sale de Klarna ?",
				"ads_manager_get_started": "Vous y êtes presque.",
				"content_store_get_started": "Vous y êtes presque."
			},
			"subtitle": {
				"additional_data": "Nous analysons votre candidature et avons besoin d'informations supplémentaires pour continuer.",
				"bank_account": "Les transactions Klarna seront transférées sur ce compte bancaire.",
				"business_size": "Nous avons besoin d'informations de base concernant votre activité afin de traiter votre candidature.",
				"in_store_get_started": "Nous avons besoin d'informations de base pour pouvoir continuer",
				"in_store_legal_form": "Nous sommes tenus de poser des questions spécifiques en fonction de votre type de société.",
				"in_store_registered_address": "C'est ici que votre entreprise est légalement enregistrée, et qu'elle apparaîtra sur les factures de vos clients Klarna.",
				"in_store_registration": "Nous avons besoin du numéro d’enregistrement de votre société pour vérifier vos informations commerciales.",
				"in_store_stakeholder": "En tant qu'établissement financier, nous sommes tenus de recueillir ces informations",
				"in_store_stores": "Ces informations seront utilisées pour paramétrer votre nouveau compte Point of Sale de Klarna.",
				"in_store_vat": "Si vous avez un numéro de TVA, nous pouvons vérifier plus facilement les informations relatives à votre société.",
				"product_channel": "Choisissez votre canal de ventes principal. Vous pourrez utiliser Point of Sale de Klarna pour les deux canaux.",
				"sensitive_goods": "L'intégration autonome de Point of Sale de Klarna ne vous permet pas de vendre des articles définis comme interdits par Klarna.",
				"ads_manager_get_started": "Veuillez nous fournir une adresse e-mail de facturation sur laquelle les factures de campagne vous seront envoyées. Vous devez être un utilisateur administrateur pour activer le compte. L'administrateur peut ensuite accorder des autorisations aux autres utilisateurs.",
				"content_store_get_started": "Avant d'obtenir l'accès au Content Manager, veuillez lire et accepter nos conditions générales."
			},
			"summary": {
				"title": "Avant de soumettre votre demande, vérifiez vos informations"
			},
			"status": {
				"UNDERWRITING_INITIATED": {
					"title": {
						"default": "Nous traitons votre demande. Cela peut prendre quelques instants.",
						"UPSELL_WEBSTORE_TO_ADS_MANAGER": "Veuillez patienter...",
						"UPSELL_WEBSTORE_TO_CONTENT_MANAGER": "Veuillez patienter..."
					},
					"paragraphs": {
						"default": [
							{
								"text": "Votre demande est en cours de traitement et nous créons votre nouveau ID de marchand."
							}
						],
						"UPSELL_WEBSTORE_TO_ADS_MANAGER": [
							{
								"text": "Nous préparons votre compte Ads Manager."
							}
						],
						"UPSELL_WEBSTORE_TO_CONTENT_MANAGER": [
							{
								"text": "Nous mettons tout en place pour votre compte Content Manager."
							}
						]
					}
				},
				"ONBOARDING_COMPLETED": {
					"title": {
						"default": "Félicitations ! Votre demande a bien été validée.",
						"UPSELL_WEBSTORE_TO_ADS_MANAGER": "Tout est prêt !",
						"UPSELL_WEBSTORE_TO_CONTENT_MANAGER": "Tout est prêt !"
					},
					"paragraphs": {
						"default": [
							{
								"text": "Vous pouvez maintenant intégrer Klarna dans votre boutique en ligne. Rendez-vous dans l’onglet Produits de l’Espace vendeur pour trouver vos identifiants d’intégration et les instructions pour les utiliser."
							}
						],
						"UPSELL_WEBSTORE_TO_KPOS": [
							{
								"text": "Configurez dès maintenant votre boutique pour commencer à recevoir immédiatement des paiements."
							}
						],
						"UPSELL_WEBSTORE_TO_ADS_MANAGER": [
							{
								"text": "Rendez-vous sur Ads Manager pour commencer à créer votre première campagne."
							}
						],
						"UPSELL_WEBSTORE_TO_CONTENT_MANAGER": [
							{
								"text": "Rendez-vous sur Content Manager et publiez votre première offre dès aujourd'hui."
							}
						]
					},
					"second_title": {
						"default": "Consultez les Klarna Docs pour de plus amples informations sur l'intégration de Klarna",
						"UPSELL_WEBSTORE_TO_KPOS": "Besoin d’aide pour paramétrer votre boutique ? Nous sommes là pour vous aider",
						"UPSELL_WEBSTORE_TO_ADS_MANAGER": "Vous avez besoin d'aide pour utiliser Ads Manager ? Consultez notre FAQ ou contactez notre Support Vendeur. Nous nous ferons un plaisir de vous aider.",
						"UPSELL_WEBSTORE_TO_CONTENT_MANAGER": "Vous avez besoin d'aide pour utiliser Content Manager ? Consultez notre FAQ ou contactez notre Support Vendeur. Nous nous ferons un plaisir de vous aider."
					},
					"second_paragraphs": {
						"default": [
							{
								"text": "Les directives sur les pratiques exemplaires peuvent vous aider à profiter au maximum de votre nouveau partenariat avec nous."
							},
							{
								"text": "Paiement Klarna",
								"link": "#"
							},
							{
								"text": "« Klarna Payments",
								"link": "#"
							}
						],
						"UPSELL_WEBSTORE_TO_KPOS": [
							{
								"text": "Contactez notre Support Vendeur. Nous serons ravis de vous assister."
							},
							{
								"text": "Contacter le service d’assistance",
								"link": "https://www.klarna.com/se/foretag/butikssupport/"
							}
						],
						"UPSELL_WEBSTORE_TO_ADS_MANAGER": [
							{
								"text": "Consulter la FAQ.",
								"link": "https://portal.klarna.com/?help-page=topic%3Aads-manager"
							}
						],
						"UPSELL_WEBSTORE_TO_CONTENT_MANAGER": [
							{
								"text": "Consulter la FAQ.",
								"link": "https://portal.klarna.com/?help-page=topic%3Acontent-manager"
							}
						]
					},
					"button_text": {
						"default": "C'est parti !",
						"UPSELL_WEBSTORE_TO_ADS_MANAGER": "C'est parti !",
						"UPSELL_WEBSTORE_TO_CONTENT_MANAGER": "C'est parti !",
						"UPSELL_WEBSTORE_TO_KPOS": "Commencer à vendre"
					}
				},
				"MANUAL_UNDERWRITING_INITIATED": {
					"title": "Merci ! Nous examinons votre demande.",
					"badge": "Environ 5 à 7 jours",
					"paragraphs": [
						{
							"text": "Vous recevrez un e-mail une fois la révision terminée ou dans le cas où nous aurions besoin d'informations supplémentaires."
						}
					],
					"second_title": "Pendant ce temps, consultez vos e-mails",
					"second_paragraphs": [
						{
							"text": "Nous vous avons envoyé un e-mail intitulé « Bienvenue dans l’Espace vendeur ». Suivez les étapes indiquées pour vous connecter et activer votre compte."
						}
					]
				},
				"SUSPENDED": {
					"title": "Malheureusement, votre candidature n'a pas été approuvée.",
					"paragraphs": [
						{
							"text": "Après avoir examiné les détails de votre entreprise, nous ne pouvons donner suite à la demande pour <strong>{businessName}</strong>."
						},
						{
							"text": "Voici quelques-unes des raisons les plus communes :"
						},
						{
							"list": [
								{
									"text": "Votre boutique ne respecte pas les directives éthiques de Klarna."
								},
								{
									"text": "Votre service client est inaccessible"
								},
								{
									"text": "Autres facteurs administratifs."
								}
							]
						},
						{
							"text": "Merci de votre intérêt dans <strong>Klarna [En magasin]</strong>. Nous espérons pouvoir collaborer avec vous dans le futur."
						}
					],
					"second_title": "Si vous avez des questions supplémentaires",
					"second_paragraphs": [
						{
							"text": "Concernant notre décision ou tout autre produit Klarna, veuillez nous contacter, nous nous ferons un plaisir de vous aider."
						}
					]
				}
			},
			"stakeholders": {
				"LEGAL_REPRESENTATIVE": {
					"title": {
						"default": "Qui est en charge de signer les contrats de votre entreprise ?"
					},
					"subtitle": {
						"default": [
							{
								"text": "Votre entreprise est sur le point de conclure un contrat avec Klarna. Nous devons vérifier qui est légalement autorisé à signer de tels contrats."
							}
						]
					}
				},
				"OWNER": {
					"title": {
						"default": "Y a-t-il des personnes qui détiennent plus de 25 % de la société ?"
					},
					"subtitle": {
						"AU": [
							{
								"text": "En tant qu'établissement financier, nous sommes légalement tenus de recueillir ces informations."
							}
						],
						"default": [
							{
								"text": "Nous devons connaître les personnes qui détiennent plus de 25 % des actions ou des droits de vote de la société, ou qui exercent un contrôle similaire. Nous sommes légalement tenus de recueillir ces informations par la directive européenne relative au blanchiment de capitaux ("
							},
							{
								"text": "UE 2015/849",
								"link": "https://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri=CELEX:32015L0849"
							},
							{
								"text": ")."
							}
						]
					}
				},
				"ALTERNATIVE_BENEFICIAL_OWNER": {
					"title": {
						"default": "Qui dirige la société ?"
					},
					"subtitle": {
						"default": [
							{
								"text": "Nous sommes légalement tenus par la directive européenne visant à lutter contre le blanchiment de capitaux ("
							},
							{
								"text": "UE 2015/849",
								"link": "https://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri=CELEX:32015L0849"
							},
							{
								"text": ")."
							}
						],
						"US": [
							{
								"text": "En tant qu'établissement financier, nous sommes légalement tenus de recueillir ces informations."
							}
						],
						"CA": [
							{
								"text": "En tant qu'établissement financier, nous sommes légalement tenus de recueillir ces informations."
							}
						],
						"AU": [
							{
								"text": "En tant qu'établissement financier, nous sommes légalement tenus de recueillir ces informations."
							}
						]
					}
				},
				"ULTIMATE_BENEFICIAL_OWNER": {
					"title": {
						"default": "Y a-t-il des personnes qui détiennent plus de 25 % de la société ?"
					},
					"subtitle": {
						"AU": [
							{
								"text": "En tant qu'établissement financier, nous sommes légalement tenus de recueillir ces informations."
							}
						],
						"default": [
							{
								"text": "Nous devons connaître les personnes qui détiennent plus de 25 % des actions ou des droits de vote de la société, ou qui exercent un contrôle similaire. Nous sommes légalement tenus de recueillir ces informations par la directive européenne relative au blanchiment de capitaux ("
							},
							{
								"text": "UE 2015/849",
								"link": "https://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri=CELEX:32015L0849"
							},
							{
								"text": ")."
							}
						]
					}
				}
			}
		},
		"product-selection-container": {
			"products": {
				"products_block": {
					"title_1": "Solutions",
					"title_2": "Modes de paiement",
					"note": "Tous les prix sont indiqués par transaction.",
					"per_transaction": "par transaction",
					"cross_border_notice": "Des frais transfrontaliers supplémentaires peuvent s’appliquer",
					"cross_border_notice_pricing_annex_suffix": {
						"before_link": "veuillez consulter",
						"link_text": "l’annexe sur la tarification"
					},
					"not_available_for_business": "Indisponible pour votre entreprise",
					"not_available_for_country": "Vous pouvez vendre uniquement sur d’autres marchés",
					"not_compatible_with_platform": "Indisponible sur votre plateforme",
					"installed": "Installé"
				},
				"buttons": {
					"next": "Suivant"
				}
			}
		}
	}
};